export const headerSEOValues = {
  "/": {
    title: "Evaluer en ligne une affaire en quelques clics",
    description:
      "Fonds de commerce, titres de société, murs : évaluez vous-même en ligne une affaire (analyse professionnelle globale et confidentielle)",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/",
    breadcrumb: [],
  },
  "/tarifs": {
    title: "Nos tarifs. Découvrez l'offre qui vous convient",
    description:
      "Vous êtes prêts à acheter ou à vendre un commerce ou une entreprise ? Choisissez votre formule et préparez votre projet avec nos estimations en ligne",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/offres",
    breadcrumb: [{ name: "Nos tarifs. Découvrez l'offre qui vous convient", item: "/offres" }],
  },
  // Outils
  "/philosophie": {
    title: "Notre philosophie, qui sommes-nous ?",
    description:
      "Notre solution est le fruit d’une rencontre entre un spécialiste de la cession de commerce et entreprise et un spécialiste du digital",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/philosophie",
    breadcrumb: [{ name: "Notre philosophie, qui sommes-nous ?", item: "/philosophie" }],
  },
  "/faq": {
    title: "Foire aux questions fréquentes",
    description:
      "Vous souhaitez en savoir plus ? Voici nos réponses aux questions fréquentes sur le domaine de la cession, transmission... de commerce et d'entreprise",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/faq",
    breadcrumb: [{ name: "Foire aux questions fréquentes", item: "/faq" }],
  },
  "/lexique": {
    title: "Lexique commercial à l'usage des (non)initiés",
    description:
      "Notre petit lexique vous propose de découvrir/re-découvrir le champs lexical du commerce. Pratique pour mieux comprendre nos conseils et tutos",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/lexique",
    breadcrumb: [{ name: "", item: "/lexique" }],
  },
  "/calculateur-cotisations": {
    title: "Calculateur de cotisations en ligne",
    description:
      "Déterminez le salaire brut à partir du net, mensuel ou annuel, et estimez le montant des cotisations patronales",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/calculateur-cotisations",
    breadcrumb: [{ name: "Calculateur de cotisations en ligne", item: "/calculateur-cotisations" }],
  },
  "/simulateur-credit": {
    title: "Simulateur de crédit en ligne",
    description: "Editez et téléchargez un tableau d'amortissement personnalisé pour votre plan de financement",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/simulateur-credit",
    breadcrumb: [{ name: "Simulateur de crédit en ligne", item: "/simulateur-credit" }],
  },
  "/plan-financement": {
    title: "Plan de financement en ligne",
    description: "TODO",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/plan-financement",
    breadcrumb: [{ name: "Plan de financement en ligne", item: "/plan-financement" }],
  },
  "/outils-pratiques": {
    title: "Outils pratiques. Cession, acquisition, optimisation d'affaire",
    description: "Téléchargez nos outils exclusifs pour vous aider à optimiser, céder ou acquérir une affaire",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/outils-pratiques",
    breadcrumb: [{ name: "Outils pratiques. Cession, acquisition, optimisation d'affaire", item: "/outils-pratiques" }],
  },
  // Articles
  "/conseils-pros": {
    title: "Conseils de pros sur la cession, acquisition et optimisation",
    description:
      "Cession, acquisition, optimisation d'affaire : astuces, pièges à éviter, points essentiels, parcours et étapes à anticiper",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/conseils-pros",
    breadcrumb: [{ name: "Conseils de pros sur la cession, acquisition et optimisation", item: "/conseils-pros" }],
  },
  
"/conseils-pros/cession-fonds-de-commerce": {
  title: "Cession de fonds de commerce : les grandes étapes",
  description: "Une cession de fonds de commerce se fait en étapes distinctes, avec de nombreux intervenants, abordant des aspects bilantiels, sociaux et juridiques.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/cession-fonds-de-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Cession de fonds de commerce : les grandes étapes",
      item: "/conseils-pros/cession-fonds-de-commerce"
    }
  ],
  faq: [
    {
      title: "Quelles sont les grandes étapes d’une cession de fonds de commerce&nbsp;?",
      answer: "Après la phase de mise en vente, de visites et d’échanges entre personnes intéressées, la première étape est l’offre d’achat signée par l’acquéreur et contresignée par le vendeur. La seconde étape est la signature d’un compromis de vente (aussi appelé protocole d’accord ou promesse synallagmatique de vente). La troisième et dernière étape, après la réalisation de toutes les conditions suspensives, est la signature de l’acte de vente (ou acte définitif). C’est là que les clefs de l’affaire sont dans votre poche !"
    },
    {
      title: "Peut-on choisir librement de vendre un fonds de commerce, des titres de société, un droit au bail ou des murs commerciaux&nbsp;?",
      answer: "Oui… et non ! Cela dépend de plusieurs facteurs, tels que la façon dont a été acquis l’objet à l’origine, la demande face à ce que vous souhaitez céder, l’impact de la fiscalité sur le mode de cession, ou encore la finançabilité potentielle par un repreneur. Vos conseils juridiques et comptables sont là pour vous aider à y voir plus clair."
    },
    {
      title: "Vendre un fonds de commerce, c’est comme vendre un logement&nbsp;?",
      answer: "Non, car même si certaines étapes sont identiques, les critères et obligations légales sont plus nombreux et contraignants, ce qui peut se comprendre, car contrairement à un logement, un fonds de commerce touche des domaines sensibles, tels que la génération de chiffre d’affaires et de revenus, ou encore l’embauche de personnel et le droit du travail."
    }
  ]
},
"/conseils-pros/offre-achat-lettre-intention": {
  title: "La lettre d’intention d’achat et l’offre d’achat",
  description: "L’offre d’achat (ou la lettre d’intention d’achat) est la 1ère étape officielle d’une cession d’affaire, sous forme de document signé par les deux parties.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/offre-achat-lettre-intention",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "La lettre d’intention d’achat et l’offre d’achat",
      item: "/conseils-pros/offre-achat-lettre-intention"
    }
  ],
  faq: [
    {
      title: "Est-on engagé si l’on signe une lettre d’intention d’achat ou une offre d’achat&nbsp;?",
      answer: "Cela dépend des termes de la lettre d’intention d’achat ou de l’offre d’achat. Une offre d’achat est généralement plus engageante qu’une lettre d’intention d’achat. Cependant, si l’intégralité des éléments essentiels au contrat de cession se trouvent dans la lettre d’intention d’achat ou l’offre d’achat présentée par l’acquéreur, la signer engage le cédant et a réputation de valoir contrat. Il vaut donc mieux faire viser ce document par votre conseil juridique avant de le signer."
    },
    {
      title: "Faut-il indiquer tous les critères négociés dans la lettre d’intention d’achat ou l’offre d’achat&nbsp;?",
      answer: "Non, c’est le rôle du compromis de vente ou du protocole d’accord, l’étape suivante. Cependant, pour que la lettre d’intention d’achat ou l’offre d’achat soit un minimum crédible, elle doit mentionner un certain nombre d’éléments essentiels, tels que l’identité de l’acquéreur et du cédant, l’objet de l’offre, ou encore le prix proposé. C’est un document de quelques pages, qui n’a pas vocation à être trop sophistiqué, sous peine d’engager de longues discussions précoces entre les parties, ce qui arrivera de toute façon lors du compromis de vente ou du protocole d’accord !"
    },
    {
      title: "Est-il indispensable de signer une lettre d’intention d’achat ou une offre d’achat pour vendre ou acheter une affaire&nbsp;?",
      answer: "Le temps de la sacro-sainte poignée de mains qui prévaut sur tout le reste étant révolu, il semble difficile de se passer de cette étape préalable à la signature d’un compromis de vente ou d’un protocole d’accord. Signer une lettre d’intention d’achat ou une offre d’achat permet a minima d’avoir un document officiel commun de référence, sur lequel figure les données basiques de la transaction à venir, et que l’on peut communiquer au conseil juridique pour qu’il prenne le relais."
    }
  ]
},
"/conseils-pros/compromis-vente-protocole-accord": {
  title: "Tout savoir sur le compromis de vente et le protocole d’accord",
  description: "Le compromis de vente ou promesse synallagmatique de vente formalise les conditions de la cession. Il détaille tous les éléments du contrat.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/compromis-vente-protocole-accord",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Tout savoir sur le compromis de vente et le protocole d’accord",
      item: "/conseils-pros/compromis-vente-protocole-accord"
    }
  ],
  faq: [
    {
      title: "Tous les points de la cession d’un fonds de commerce se négocient-ils lors du compromis de vente&nbsp;?",
      answer: "Oui… Et non. Tous les aspects de l’opération de cession sont détaillés et encadrés dans le compromis de vente, mais il est plus prudent d’anticiper les différentes facettes de la négociation (clause de non-concurrence, accompagnement, stocks, normes, etc.) en amont, afin d’éviter les malentendus lorsque les conseils juridiques listeront les conditions précises de la cession dans le projet de compromis."
    },
    {
      title: "Peut-on inscrire n’importe quelles conditions suspensives dans un compromis de vente&nbsp;?",
      answer: "Oui… En théorie. La détermination des conditions suspensives inscrites au compromis de vente ne résulte que d’un accord commun entre acquéreur et cédant. Cependant, plus il y a de conditions, plus la transaction sera difficile à concrétiser. Il est donc recommandé de purger un maximum de points de discussion en amont du compromis."
    },
    {
      title: "Y a-t-il un délai de rétractation lorsque l’on signe un compromis de vente de fonds de commerce&nbsp;?",
      answer: "Non. Contrairement à l’immobilier dit traditionnel (logements),\n la cession de fonds de commerce et de titres de société ne bénéficie pas du même délai de rétractation de 10 jours, qui permet à l’acquéreur de renoncer à l’achat sans verser de contrepartie financière. La signature d’un compromis de vente de fonds de commerce est donc définitivement engageant, sous conditions suspensives."
    }
  ]
},
"/conseils-pros/estimation-fonds-commerce": {
  title: "Évaluation fonds de commerce : Comment l'analyser ?",
  description: "Évaluer un fonds de commerce, c'est donner une valeur clé à votre patrimoine commercial, une étape essentielle pour définir votre stratégie future.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/estimation-fonds-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Évaluation fonds de commerce : Comment l'analyser ?",
      item: "/conseils-pros/estimation-fonds-commerce"
    }
  ],
  faq: [
    {
      title: "Faut-il inclure la trésorerie et les dettes de l'entreprise pour évaluer un  fonds de commerce&nbsp;?",
      answer: "La cession d’un fonds de commerce exclut la structure juridique qui le détient. La trésorerie et les dettes restent dans la société, et un séquestre solde les dettes lors de la transaction. En cas de cession des titres de société, l’approche est plus technique, notamment à cause de l’imposition sur la plus-value. Toutefois, choisir entre cession de titres ou de fonds uniquement pour des raisons fiscales peut ne pas convenir aux repreneurs et à leurs conseillers, qui privilégient souvent une approche adaptée à leurs besoins."
    },
    {
      title: "Existe-t-il un barème officiel pour estimer la valeur des fonds de  commerce&nbsp;?",
      answer: "Il n’existe aucun barème de valorisation officiel. Bien que certaines publications privées  proposent des barèmes, ceux-ci n’ont aucun caractère certifié, public ou légal. Le barème fiscal, parfois mentionné, n’est pas non plus une référence officielle. Souvent utilisé par les experts et les tribunaux, notamment en région parisienne, il repose sur des multiples de chiffre d’affaires TTC. Cependant, il offre des fourchettes d’évaluation très larges et ne couvre qu’un nombre limité d’activités. S’il a le mérite d’exister, ce barème reste une approche partielle et insuffisante pour une évaluation précise d’une exploitation."
    },
    {
      title: "Comment savoir si un fonds de commerce est à vendre&nbsp;?",
      answer: "Pour savoir si un fonds de commerce est à vendre, consultez des sites spécialisés, sollicitez des professionnels comme des agences immobilières ou experts-comptables, et renseignez-vous auprès des chambres de commerce. Vous pouvez aussi contacter directement des entreprises ciblées ou surveiller les annonces publiées au Bodacc pour repérer des opportunités.\\n"
    }
  ]
},
"/conseils-pros/imposition-plus-value-fonds-commerce": {
  title: "Calculer l’imposition sur la plus-value d'un fonds de commerce\\r\\n",
  description: "Lors de la cession d’un fonds de commerce, si le cédant réalise une plus-value, il est soumis à l’imposition sur les plus-values professionnelles.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/imposition-plus-value-fonds-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Calculer l’imposition sur la plus-value d'un fonds de commerce\\r\\n",
      item: "/conseils-pros/imposition-plus-value-fonds-commerce"
    }
  ],
  faq: [
    {
      title: "Existe-t-il des exonérations d’imposition sur plus-value de cession de fonds de commerce&nbsp;?",
      answer: "Oui, plusieurs dispositifs existent pour les entreprises individuelles et les sociétés commerciales. Elles doivent exercer une activité commerciale, industrielle, artisanale, libérale ou agricole, et répondre aux critères respectifs de trois cas de figure possible : le départ en retraite du dirigeant, ou la valeur du fonds de commerce cédé, ou encore le niveau des recettes annuelles de l’entreprise. Dans les trois cas, l’activité doit avoir été exercée par le dirigeant durant au moins 5 ans avant la vente du fonds de commerce."
    },
    {
      title: "L’imposition sur la plus-value de cession de fonds de commerce est-elle la même pour tout le monde&nbsp;?",
      answer: "Non, elle varie en fonction du mode d’imposition du cédant (IS ou IR),\n ainsi que de la durée de détention du fonds de commerce (plus ou moins de deux ans) pour une entreprise à l’IR, où l’on distingue les plus-values à court terme (sur éléments amortis) et long terme (sur éléments non-amortis). La 1ère intègre le résultat, soumis au barème progressif de l’IR. La 2nde est soumise à la « flat-tax » de 30% (IR à 12,8 % + prélèvements sociaux à 17,2%). Pour une entreprise à l’IS, la plus-value (il n’y a plus de court ou long terme) intègre le résultat de l’exercice, soumis en totalité à l’IS (26,5% ou 27,5%, voire le taux réduit de 15%)."
    },
    {
      title: "Comment calculer la plus-value sur cession d’un fonds de commerce&nbsp;?",
      answer: "C’est la différence entre le prix d’acquisition (qui est de zéro si le fonds a été créé et non racheté) et le prix de cession du fonds de commerce. Le fonds de commerce bénéficiant d’amortissements dans la durée, ceux-ci sont déduits du prix d’acquisition retenu pour le calcul de la plus-value. C’est la valeur nette comptable. En bref, la plus-value professionnelle, c’est le prix de vente moins le prix d’achat déduit des amortissements."
    }
  ]
},
"/conseils-pros/renouvellement-bail-commercial": {
  title: "Renouvellement du bail commercial : Ce qu'il faut savoir",
  description: "Le renouvellement du bail commercial est crucial et doit être anticipé par le locataire pour assurer la pérennité de son exploitation et faciliter une future cession. \\n",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/renouvellement-bail-commercial",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Renouvellement du bail commercial : Ce qu'il faut savoir",
      item: "/conseils-pros/renouvellement-bail-commercial"
    }
  ],
  faq: [
    {
      title: "Est-ce que le bail commercial se renouvelle automatiquement&nbsp;?",
      answer: "Non, le bail commercial ne se renouvelle pas automatiquement. Une demande de renouvellement doit être faite par le locataire ou le bailleur avant l'expiration du bail. Cette demande doit être effectuée dans les six mois précédant la fin de la période triennale du bail, ou à tout moment pendant la prolongation tacite. Si aucune demande n'est faite, le bail est prolongé tacitement aux mêmes conditions, mais cette situation n'est pas sécuritaire pour le locataire."
    },
    {
      title: "Comment renouveler un bail commercial 3 6 9&nbsp;?",
      answer: "Pour renouveler un bail commercial 3-6-9, le locataire ou le bailleur doit envoyer une demande de renouvellement par acte d'huissier, au moins six mois à l'avance avant l'expiration du bail. Cette demande doit inclure une clause spécifique indiquant que le bailleur a trois mois pour répondre. En cas de non-réponse du bailleur, son silence vaut acceptation du renouvellement, mais cela exclut la décision sur la révision du loyer. En cas de refus, le bailleur doit justifier sa décision avec des motifs graves ou légitimes, tels que la violation des clauses du bail. Si le refus est injustifié, le locataire peut demander une indemnité d'éviction au Président du tribunal judiciaire."
    },
    {
      title: "Prolongation ou renouvellement du bail commercial, quelle différence&nbsp;?",
      answer: "La prolongation du bail commercial se produit automatiquement si aucune demande de renouvellement ou de congé n'est faite avant l'expiration du bail. Elle se fait aux mêmes conditions, mais elle laisse le locataire vulnérable à une résiliation rapide par le bailleur. Le renouvellement, en revanche, implique un nouvel accord entre les parties et peut inclure une révision du loyer selon les règles du plafonnement. La demande de renouvellement doit être faite par acte d'huissier et signifiée au greffe. Contrairement à la prolongation, le renouvellement officialise un nouveau contrat avec des dates précises de début et de fin, offrant ainsi plus de sécurité au locataire."
    }
  ]
},
"/conseils-pros/bail-commercial-points-importants": {
  title: "Bail commercial : les points à savoir",
  description: "Le bail commercial est un élément crucial dans un commerce ou une entreprise, car il définit les obligations réciproques du propriétaire et du locataire.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/bail-commercial-points-importants",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Bail commercial : les points à savoir",
      item: "/conseils-pros/bail-commercial-points-importants"
    }
  ],
  faq: [
    {
      title: "Quelle est l’importance du taux d’effort et de la valeur locative&nbsp;?",
      answer: "Le taux d’effort représente le poids du loyer effectif sur l’exploitation. Il est calculé en étant rapporté au chiffre d’affaires. Maîtriser son taux d’effort, soit par un loyer bien négocié, soit par un volume d’affaires important, permet de dégager une meilleure rentabilité et d’augmenter la valeur de l’affaire. La valeur locative d'un local est calculée en fonction du loyer annuel au prix du marché, et permet de fixer un loyer de manière cohérente par rapport aux pratiques d’un même secteur géographique."
    },
    {
      title: "Quels sont les points essentiels du bail commercial &nbsp;?",
      answer: "L’activité autorisée dans le bail commercial, appelée destination, qu’il faut respecter scrupuleusement. La répartition des charges et des travaux est à négocier soigneusement pour être équitable. Les conditions de renouvellement et de résiliation sont un point fondamental, ainsi que les conditions de cession du droit au bail, pour assurer la pérennité de la propriété commerciale. Enfin, le montant du dépôt de garantie doit être raisonnable pour ne pas trop peser sur le plan de financement."
    },
    {
      title: "Quelle est l’utilité d’un bail commercial&nbsp;?",
      answer: "Le bail commercial, qui est un contrat de location d'un local destiné à une activité commerciale, est un engagement de longue durée entre un propriétaire de murs commerciaux et un locataire. Le bail régit leurs obligations réciproques et protège le locataire par une stabilité dans la durée de l’exploitation et par l’acquisition de la propriété commerciale au travers du droit au renouvellement."
    }
  ]
},
"/conseils-pros/vente-fonds-commerce": {
  title: "La vente d'un fonds de commerce : les éléments à savoir",
  description: "Vendre un fonds de commerce consiste à céder un ensemble homogène d’éléments corporels et incorporels, qui constituent une activité commerciale.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/vente-fonds-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "La vente d'un fonds de commerce : les éléments à savoir",
      item: "/conseils-pros/vente-fonds-commerce"
    }
  ],
  faq: [
    {
      title: "Quels sont les principaux avantages et inconvénients de l‘acquéreur en reprenant un fonds de commerce&nbsp;?",
      answer: "L’acquéreur d’un  fonds de commerce dispose immédiatement d’un outil clé en main pour poursuivre l’activité (locaux, équipements, clientèle, renommée, enseigne commerciale). Il n’est pas obligé de reprendre les contrats commerciaux. En revanche, lors de la vente du fonds de commerce, il doit reprendre les contrats de travail. Par ailleurs, il doit payer des droits d’enregistrement supérieurs à ceux qu’il paierait pour l’achat de titres de société. Enfin, il doit souvent réaliser un apport personnel de 30 à 40%, généralement plus conséquent pour une opération d’achat de titres de société."
    },
    {
      title: "Quels sont les principaux avantages et inconvénients du cédant en vendant un fonds de commerce&nbsp;?",
      answer: "Lors de la vente du fonds de commerce, le vendeur conserve sa société et sa trésorerie, qu’il peut réinvestir dans un autre fonds, tout en réalisant des économies de création. Il ne doit concéder aucune garantie d’actif et de passif à l’acquéreur et limite son engagement. En revanche, il ne perçoit son prix de cession qu’au terme de 3 à 5 mois, à l’issue des oppositions des créanciers et des formalités obligatoires. Enfin, céder un fonds de commerce est une opération plus simple que céder des titres et suscite un engouement plus marqué de la part des acquéreurs potentiels."
    },
    {
      title: "Quels sont les critères de choix pour vendre un fonds de commerce ou des titres de société&nbsp;?",
      answer: "Choisir la vente du fonds de commerce ou la vente des titres de société est conditionné à plusieurs critères. Le plus important est l’impact fiscal, très différent selon le mode de cession. Vient ensuite le niveau de complexité induit par l’opération, dont découlent la finançabilité pour l’acquéreur et donc la faisabilité pour les deux parties. Enfin, il convient de prendre en compte le niveau et la durée d’engagement des parties. Chaque mode de cession possède des avantages et des inconvénients."
    }
  ]
},
"/conseils-pros/credit-vendeur-cession-fonds-commerce": {
  title: "Les avantages du crédit-vendeur dans une cession de fonds de commerce",
  description: "Dans une cession de fonds de commerce ou de titres de société, le crédit-vendeur permet au cédant d’accorder une facilité de paiement au repreneur.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/credit-vendeur-cession-fonds-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Les avantages du crédit-vendeur dans une cession de fonds de commerce",
      item: "/conseils-pros/credit-vendeur-cession-fonds-commerce"
    }
  ],
  faq: [
    {
      title: "Quelles garanties le cédant peut-il mettre en place dans un crédit-vendeur&nbsp;?",
      answer: "Tel que le ferait une banque en délivrait un crédit professionnel, un vendeur peut garantir le crédit-vendeur grâce à trois dispositifs, que sont le nantissement du fonds de commerce ou des titres de société, appelé « privilège du prêteur de denier » (PPD),\n le cautionnement d’un tiers (qui peut être une banque),\n et l’hypothèque (ou nantissement, ou gage) des autres biens personnels du repreneur."
    },
    {
      title: "Quels sont les principaux avantages du crédit- vendeur&nbsp;?",
      answer: "Il permet au cédant de trouver davantage de candidats à reprise, en abaissant le seuil de leur apport personnel. Il peut aussi se montrer plus sélectif sur les candidats. Et il préserve mieux son prix de vente. Le crédit-vendeur permet à l’acquéreur de compléter un financement bancaire insuffisant pour financer la totalité des éléments repris (stock, trésorerie ou une partie du prix du fonds de commerce ou des titres de société)."
    },
    {
      title: "Quels sont les facteurs de réussite du crédit-vendeur&nbsp;?",
      answer: "Le crédit-vendeur s’appuie d’abord sur la confiance mutuelle entre le cédant et le repreneur. Cette confiance est bâtie d’une part par le repreneur, en justifiant de ses compétences métier et par ses qualités relationnelles avec le cédant. D’autre part par le cédant, qui prend un risque dans l’opération en conditionnant une partie du prix de cession aux résultats futurs de son repreneur."
    }
  ]
},
"/conseils-pros/acteurs-cession-fonds-commerce-accompagnement": {
  title: "Découvrez les différents acteurs d'une cession de fonds de commerce",
  description: "Céder un fonds de commerce est une opération incluant de nombreux acteurs. Connaître le rôle de chaque intervenant permet de bien anticiper la cession.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/acteurs-cession-fonds-commerce-accompagnement",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Découvrez les différents acteurs d'une cession de fonds de commerce",
      item: "/conseils-pros/acteurs-cession-fonds-commerce-accompagnement"
    }
  ],
  faq: [
    {
      title: "Pourquoi le vendeur du fonds de commerce doit-il anticiper qui seront les acteurs de la cession&nbsp;?",
      answer: "Au départ d’un projet de cession de fonds de commerce, le cédant a tendance à n’inclure dans son horizon d’interlocuteurs que ses conseils juridiques et comptables, ainsi que l’acquéreur. Puis il se rend rapidement compte que la cession va dépendre de nombreux autres intervenants et de leur délai de réaction. Identifier le plus tôt possible tous les acteurs d’une cession de fonds de commerce permet au vendeur de prévenir certaines longueurs ou pire, certains blocages qui peuvent nuire à l’opération."
    },
    {
      title: "Les acteurs d’une cession de fonds de commerce sont-ils nombreux&nbsp;?",
      answer: "A l’inverse d’une cession immobilière traditionnelle, la cession de fonds de commerce demande l’intervention de nombreux acteurs. Les conseils juridiques et comptables sont en première ligne, ainsi que l’intermédiaire s’il y en a un. Mais la cession d’un fonds de commerce ne peut se faire sans tenir compte des autres intervenants, dont le bailleur, la banque, l’assurance, les fournisseurs et partenaires commerciaux, les salariés, l’administration, les organismes de contrôle. Un véritable écosystème gravite autour d’une cession de fonds de commerce."
    },
    {
      title: "Est-il possible de réaliser une cession de fonds de commerce sans conseils juridiques et comptables&nbsp;?",
      answer: "C’est théoriquement possible, à condition que le bail autorise une cession sous seing privé. Il est cependant fortement déconseillé de procéder à une vente de fonds de commerce sans l’intervention de conseils juridiques et comptables, car la cession implique de nombreuses formalités et nécessite un véritable savoir-faire spécialisé. Le rôle de l’avocat ou du notaire, ainsi que de l’expert-comptable, est donc primordial, afin d’encadrer la vente du fonds de commerce en respectant les obligations légales et un certain formalisme. Leur rôle est aussi de conseiller les parties au mieux de leurs intérêts sur les impacts juridiques et fiscaux de la cession, ainsi que sur leurs engagements mutuels."
    }
  ]
},
"/conseils-pros/valorisation-murs-commerciaux": {
  title: "Estimation murs commerciaux : Comment s'y prendre ?",
  description: "Vendre des murs commerciaux, c’est bien plus qu’une simple transaction immobilière : découvrez les critères pour estimer votre bien.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/valorisation-murs-commerciaux",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Estimation murs commerciaux : Comment s'y prendre ?",
      item: "/conseils-pros/valorisation-murs-commerciaux"
    }
  ],
  faq: [
    {
      title: "Comment calculer le prix des murs d'un commerce&nbsp;?",
      answer: "Le prix des murs d’un commerce se calcule principalement en divisant le loyer annuel potentiel par un taux de capitalisation (ou rendement attendu). Ce taux varie selon l’emplacement, le type de commerce, le locataire, et les conditions du marché. Par exemple, avec un loyer annuel de 30 000 € et un taux de 7 %, le prix serait environ 428  571 €. Une analyse comparative du marché et, idéalement, une expertise professionnelle sont recommandées pour affiner l’estimation."
    },
    {
      title: "Quel est le prix du m2 d'un local commercial&nbsp;?",
      answer: "Le prix au m² d’un local commercial varie selon l’emplacement, le type d’activité, l’état du marché et la condition du local. En centre-ville ou zones géographiques prisées, il  peut atteindre 20 000 €/m², tandis qu’en périphérie, il est souvent inférieur à 3 000 €/m².  Pour une estimation précise, analysez les annonces locales, consultez les transactions  récentes (via le service DVF) ou faites appel à un expert immobilier."
    },
    {
      title: "Comment vendre des murs commerciaux&nbsp;?",
      answer: "Pour vendre des murs commerciaux, commencez par faire évaluer le bien par un expert immobilier pour en déterminer le juste prix, en tenant compte de la valeur locative, du marché et de l’état du local. Assurez-vous que le bien est attractif, en bon état ou dispose d’un locataire fiable avec un bail en cours. Préparez les documents nécessaires, comme le titre de propriété, le bail commercial, et les diagnostics obligatoires. Publiez une annonce sur des plateformes spécialisées ou confiez la vente à une agence pour cibler les acheteurs potentiels. Enfin, négociez avec transparence et finalisez la vente chez un notaire pour sécuriser la transaction."
    }
  ]
},
"/conseils-pros/formalites-cession-fonds-commerce": {
  title: "Les formalités d'une cession de fonds de commerce",
  description: "La cession de fonds de commerce induit des formalités indispensables : information aux salariés, déclaration en mairie, publicité, acte, enregistrement.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/formalites-cession-fonds-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Les formalités d'une cession de fonds de commerce",
      item: "/conseils-pros/formalites-cession-fonds-commerce"
    }
  ],
  faq: [
    {
      title: "Qui supporte les frais de formalités à accomplir lors d’une cession de fonds de commerce&nbsp;?",
      answer: "C’est l’acquéreur qui supporte la plupart des frais inhérents à une opération de cession d’un fonds de commerce. Les frais principaux sont constitués des droits d’enregistrement (aussi appelés droits de mutation),\n calculés sur 3% du prix du fonds pour la tranche allant de 23.000 à 200.000 € et 5% pour la tranche supérieure à 200.000 €. Il n’y a aucun droit sur un fonds dont la valeur est inférieure à 23.000 €. Les autres frais de formalités, moindres (séquestre, CFE, annonces légales, Bodacc),\n font généralement l’objet d’une facturation globale par le conseil juridique à son client acquéreur, puisqu’il réalise ces formalités pour son compte."
    },
    {
      title: "Quand et comment faut-il informer les salariés lors d’une cession de fonds de commerce&nbsp;?",
      answer: "Lors d’une cession de fonds de commerce, les salariés doivent obligatoirement être informés au moins 2 mois avant la signature de l’acte de vente. Cette information se réalise souvent après le compromis de vente, qui engage les parties, pour ne pas déstabiliser l’équipe inutilement. La façon d’informer les salariés est libre, allant de la simple remise en mains propres à l’acte d’huissier. L’essentiel étant d’utiliser tout moyen rendant certaine la date de réception de l’information."
    },
    {
      title: "Quelles sont les formalités à accomplir lors d’une cession de fonds de commerce&nbsp;?",
      answer: "Les formalités engendrées par la cession d’un fonds de commerce sont nombreuses et répondent à un calendrier précis. C’est habituellement le conseil juridique qui s’en charge pour le compte de l’acquéreur et du cédant. Les formalités sont l’information aux salariés, la levée du droit de préemption de la commune, l’acte de cession et ses mentions obligatoires, les publicités légales, l’enregistrement de la cession, la clôture des comptes, les formalités auprès du CFE et le séquestre."
    }
  ]
},
"/conseils-pros/evaluation-entreprises-titres-societe": {
  title: "Guide complet de l'évaluation des titres de société",
  description: "Découvrez comment évaluer les titres de société : méthodes, calculs, points de vigilance et conseils d’experts pour réussir votre vente.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/evaluation-entreprises-titres-societe",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Guide complet de l'évaluation des titres de société",
      item: "/conseils-pros/evaluation-entreprises-titres-societe"
    }
  ],
  faq: [
    {
      title: "Quelle est la différence entre la cession d’un fonds de commerce et la cession de titres de société&nbsp;?",
      answer: "La différence tient surtout à des aspects fiscaux et financiers. Pour le vendeur, la cession de titres entraîne souvent une imposition sur la plus-value, tandis que pour l’acheteur, les droits d’enregistrement sont généralement plus faibles, mais le risque est plus élevé puisqu’il reprend l’ensemble de la société. Ce risque justifie parfois une négociation à la baisse du prix de vente par rapport à celui d’un fonds de commerce. Enfin, le crédit vendeur peut offrir une souplesse supplémentaire pour faciliter l’accord."
    },
    {
      title: "Quelle est la fiscalité sur une vente de parts sociales&nbsp;?",
      answer: "La vente de parts sociales génère, pour le vendeur, une plus-value imposable. Cette plus-value est soumise à l’impôt sur le revenu, au taux forfaitaire de 30 % (prélèvements sociaux inclus),\n appelé \\\"flat tax\\\". Dans certains cas, le vendeur peut bénéficier d’abattements ou de régimes spécifiques selon la durée de détention ou la nature de l’activité. Il est donc important d’anticiper cette fiscalité avant la cession."
    },
    {
      title: "Comment acheter des parts d'une entreprise&nbsp;?",
      answer: "Pour acheter des parts d'une entreprise, il faut d'abord trouver un accord avec le ou les associés vendeurs sur le prix et les conditions de la cession. Une fois l’accord trouvé, un acte de cession de parts est rédigé et signé. La vente peut nécessiter l’agrément des autres associés, selon les statuts de la société. Enfin, l'opération est formalisée par la mise à jour des statuts, l'enregistrement de l'acte et la modification des informations au registre du commerce."
    }
  ]
},
"/conseils-pros/cession-droit-bail": {
  title: "Mode d’emploi de la cession de droit au bail",
  description: "Découvrez les particularités de la cession du droit au bail. Elément du fonds de commerce, le droit au bail est le droit d’utiliser un local commercial.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/cession-droit-bail",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Mode d’emploi de la cession de droit au bail",
      item: "/conseils-pros/cession-droit-bail"
    }
  ],
  faq: [
    {
      title: "Quelles sont les conditions de cession du droit au bail&nbsp;?",
      answer: "Les conditions de cession du droit au bail figurent dans le bail commercial, qui n'autorise généralement la cession du bail qu’à l’acquéreur du fonds de commerce. La cession du droit au bail induisant un changement d’activité exercée dans le local, elle est soumise à l'accord préalable du bailleur. A l’inverse d’une cession de fonds de commerce, où il est demandé au bailleur un renouvellement du bail (avec demande éventuelle de déspécialisation d’activité),\n la cession du droit au bail entraîne la conclusion d’un bail neuf."
    },
    {
      title: "Comment estimer la valeur d’un droit au bail&nbsp;?",
      answer: "La valeur du droit au bail est calculée sur la base de nombreux facteurs. La qualité d’emplacement, la surface du local, les activités autorisées, le montant du loyer et la valeur locative sont les principaux critères de valorisation. L’on tient également compte de l’état du local d’activité, des éventuels aménagements présents. Enfin, il convient d’analyser la nature du bail commercial et ses conditions générales."
    },
    {
      title: "Quelle est la différence entre un droit au bail et un fonds de commerce&nbsp;?",
      answer: "Dans une vente de fonds de commerce, l’exploitant cède tous les éléments composant le fonds. Ce sont les éléments corporels (matériel et aménagements) et incorporels (clientèle, nom commercial, licences, et droit au bail, entre autres). Dans la cession de droit au bail, l’exploitant ne vend que le bail commercial, sans aucun autre élément d’actif composant le fonds de commerce. La cession du droit de bail est donc la vente par un commerçant à un autre du simple droit de lui succéder dans le local qu'il occupe."
    }
  ]
},
"/conseils-pros/valorisation-entreprise": {
  title: "Nos conseils sur la valorisation des entreprises et des commerces",
  description: "Découvrez les clés de la valorisation d'une entreprise : méthodes,  critères financiers, moments stratégiques et bonnes pratiques.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/valorisation-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Nos conseils sur la valorisation des entreprises et des commerces",
      item: "/conseils-pros/valorisation-entreprise"
    }
  ],
  faq: [
    {
      title: "Pourquoi bien choisir les années d’estimation&nbsp;?",
      answer: "Le choix des années à inclure dans l'estimation est crucial, car il affecte la perception de la valeur par les repreneurs potentiels. Une valorisation basée uniquement sur des chiffres passés ou des prévisions irréalistes risque de créer un désaccord entre le cédant et le repreneur. L'objectif est d'aboutir à une estimation réaliste et négociable, en intégrant à la fois les bilans passés et les prévisionnels bien étayés. Cela permet de garantir la pertinence de l'estimation tout en préservant les intérêts des deux parties."
    },
    {
      title: "Quelles sont les méthodes d'évaluation d'entreprise&nbsp;?",
      answer: "Les principales méthodes d'évaluation d'entreprise incluent la méthode des flux de trésorerie actualisés (DCF),\n qui se base sur les flux de trésorerie futurs actualisés, et la méthode des comparables, qui compare l'entreprise à d'autres sociétés similaires. La méthode patrimoniale évalue les actifs nets de l'entreprise, tandis que la méthode par les transactions comparables se fonde sur des transactions récentes dans le même secteur. Enfin, la méthode des options réelles est utilisée pour évaluer des entreprises dans des secteurs à forte incertitude, comme les start-ups. Le choix de la méthode dépend du contexte et de la nature de l'entreprise."
    },
    {
      title: "Qu'est-ce qu'un multiple d'EBITDA (EBE)&nbsp;?",
      answer: "Un multiple d'EBITDA (ou EBE en français, pour Excédent Brut d'Exploitation) est un ratio utilisé pour évaluer la valeur d'une entreprise. Il permet de comparer la valeur de l'entreprise avec ses performances financières, en particulier sa rentabilité opérationnelle. Le multiple d'EBITDA est calculé en divisant la valeur d'entreprise (prix de vente ou valeur sur le marché) par l'EBITDA. Ce multiple est souvent utilisé dans les transactions de fusion-acquisition pour estimer le prix de vente d'une société, car il permet de comparer des entreprises de tailles différentes au sein d'un même secteur. Plus le multiple est élevé, plus l'entreprise est considérée comme prometteuse en termes de croissance et de rentabilité future."
    }
  ]
},
"/conseils-pros/donation-avant-cession": {
  title: "Donation avant cession : comment la mettre en place ?",
  description: "La donation avant cession permet d’optimiser la vente de son entreprise en transmettant du patrimoine à ses enfants, grâce à certains dispositifs fiscaux.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/donation-avant-cession",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Donation avant cession : comment la mettre en place ?",
      item: "/conseils-pros/donation-avant-cession"
    }
  ],
  faq: [
    {
      title: "Quelle est la forme à respecter pour réaliser une donation avant cession&nbsp;?",
      answer: "Il est recommandé de faire appel à un notaire pour réaliser la donation de titres (obligatoire pour la donation-partage et la donation avec réserve d'usufruit). Il rédige un acte et gère les formalités déclaratives. La donation peut aussi être effectuée librement par le don manuel, déclaré en ligne ou par courrier au service fiscal du domicile du donataire."
    },
    {
      title: "Quels sont les critères à respecter pour réaliser une donation avant cession&nbsp;?",
      answer: "La donation avant cession doit être réalisée dans un ordre précis et avec une intention libérale. Dans le cas contraire, il y a un risque de requalification par le fisc avec des conséquences financières importantes. L’opération ne doit donc pas être fictive. Elle doit suivre la chronologie donation, puis cession. Post-cession, le donateur ne doit pas récupérer son bien ou le fruit de la cession par le donataire."
    },
    {
      title: "Quelle est l’utilité d’une donation avant cession&nbsp;?",
      answer: "La donation avant cession est utile dans le cadre d’un projet de cession de titres de société et de transmission de patrimoine. Cela permet de ne pas cumuler l’imposition sur plus-value de cession et les droits de donation. Le dirigeant-cédant peut ainsi transmettre une partie de son patrimoine à ses enfants avec une fiscalité allégée."
    }
  ]
},
"/conseils-pros/apport-cession": {
  title: "L'apport cession : Quels sont les enjeux ?",
  description: "L'apport-cession permet de reporter l'imposition des plus-values en apportant les titres d'une société à une autre, sous certaines conditions. Découvrez comment optimiser ce mécanisme.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/apport-cession",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "L'apport cession : Quels sont les enjeux ?",
      item: "/conseils-pros/apport-cession"
    }
  ],
  faq: [
    {
      title: "Qu'est-ce que le remploi ou le report d'imposition&nbsp;?",
      answer: "Le remploi dans une opération d'apport-cession permet de différer l'imposition sur la plus-value réalisée lors de la vente de titres. Cela se fait en réinvestissant le produit de la vente dans des actifs éligibles, généralement dans les deux ans suivant la cession. Ce mécanisme permet de continuer à bénéficier du report d’imposition tant que les conditions de réinvestissement sont respectées."
    },
    {
      title: "Qu'est-ce qu'une soulte en apport cession&nbsp;?",
      answer: "Dans une opération d'apport-cession décrite dans l'article 150-0 B ter du Code général des impôts, une soulte est une somme d'argent versée pour compenser la différence de valeur entre les titres apportés et ceux reçus en échange. Lorsqu'un contribuable apporte des titres à une holding, il reçoit de nouveaux titres en retour. Si la valeur des titres apportés est supérieure à celle des titres reçus, une soulte peut être versée pour combler cet écart. Cette soulte peut avoir des conséquences fiscales : si elle dépasse un certain seuil, souvent 10 % de la valeur des titres reçus, cela peut entraîner une imposition immédiate de la plus-value, même si un report d’imposition était envisagé."
    },
    {
      title: "Quels sont les types d'apport&nbsp;?",
      answer: "L'apport cession se divise en deux principaux types d'apports, chacun avec ses propres implications fiscales et juridiques. Le premier est l'apport en nature, qui consiste à transférer des actifs autres que de l'argent, tels que des titres (actions, parts sociales),\n des biens immobiliers, des équipements, ou des brevets, à une société. Dans le cadre d'un apport cession, ce sont généralement les titres de la société d'origine qui sont apportés à une holding. Le second type est l'apport en numéraire, où le cédant injecte de l'argent dans une société en échange de parts ou d'actions. Bien que cet apport ne soit pas directement lié au report d'imposition sur les plus-values, il peut jouer un rôle dans la structuration de la holding qui recevra les titres apportés."
    }
  ]
},
"/conseils-pros/trouver-local-commercial": {
  title: "Nos conseils pour choisir et trouver un local commercial",
  description: "Trouver un local commercial est une étape essentielle de la création d’entreprise. Découvrez comment procéder avec méthode pour faire les bons choix.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/trouver-local-commercial",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Nos conseils pour choisir et trouver un local commercial",
      item: "/conseils-pros/trouver-local-commercial"
    }
  ],
  faq: [
    {
      title: "Trouver un local commercial adapté dépend de quels facteurs&nbsp;?",
      answer: "Les trois critères principaux pour trouver un local commercial adéquat sont l’emplacement, les caractéristiques du local et les conditions du bail commercial. Le local idéal à 100% est presque une chimère... Il faut donc être souple en sachant faire des compromis, ainsi que raisonnable pour fonder ses choix sur des éléments factuels."
    },
    {
      title: "Comment trouver le bon local commercial&nbsp;?",
      answer: "Au-delà de l’intuition personnelle, trouver un local commercial repose sur une analyse d’éléments concrets. Ces éléments sont d’abord collectés lors d’une étude de la zone de chalandise. Puis l’on réalise une étude de marché. Et enfin, une étude d’implantation. Ces trois phases permettent d’établir une check-list sur chaque local visité et de valider le plus pertinent pour l’activité."
    },
    {
      title: "Pourquoi est-il plus délicat de trouver un local commercial qu’un fonds de commerce&nbsp;?",
      answer: "Contrairement à la reprise d’un fonds de commerce, dont le local est adapté à l’activité, la création d’entreprise nécessite de trouver un local commercial. Il n’est donc pas certain que l’activité sera pérenne dans le local. Par ailleurs, le local devra être modifié pour s’adapter (matériel et aménagements) à la nouvelle activité. Enfin, il faut négocier un bail commercial neuf."
    }
  ]
},
"/conseils-pros/acheter-fonds-de-commerce": {
  title: "Acheter un fonds de commerce : Comment et pourquoi ?",
  description: "A l’heure où il n’a jamais semblé aussi attirant de créer sa propre activité, acheter un fonds de commerce existant est une option souvent plus sécuritaire.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/acheter-fonds-de-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Acheter un fonds de commerce : Comment et pourquoi ?",
      item: "/conseils-pros/acheter-fonds-de-commerce"
    }
  ],
  faq: [
    {
      title: "Comment bien se préparer pour acheter un fonds de commerce&nbsp;?",
      answer: "Connaître la nature et le rôle des intervenants, ainsi que le déroulement des étapes, permet de bien anticiper l’achat d’un fonds de commerce. Réaliser un business plan complet et approcher les organismes financiers en amont permet de valider la faisabilité du projet avant de se lancer. Enfin, il faut savoir valoriser un fonds de commerce pour bien l’acheter."
    },
    {
      title: "Quelles sont les étapes pour acheter un fonds de commerce&nbsp;?",
      answer: "La phase préparatoire vise à réaliser un business plan ou au minimum un prévisionnel d’exploitation et un plan de financement. Puis on sélectionne, visite et contre-valorise différents fonds. On formalise par l’offre d’achat, le compromis de vente, puis après la recherche et l’obtention du financement, l’acte de vente. L’opération se conclut par l’accompagnement du repreneur par le cédant."
    },
    {
      title: "Pourquoi acheter un fonds de commerce&nbsp;?",
      answer: "Acheter un fonds de commerce, contrairement à une création, augmente la faisabilité du projet entrepreneurial, en s’appuyant sur une dynamique d’activité existante. L’acquéreur remplace le cédant et poursuit l’exploitation, avec l’objectif de l’optimiser une fois qu’il l’a prise en main."
    }
  ]
},
"/conseils-pros/compte-exploitation-previsionnel": {
  title: "Comment établir son compte d'exploitation prévisionnel",
  description: "Reprise ou création d’entreprise : découvrez comment établir un compte d’exploitation prévisionnel pour cadrer économiquement le projet et fixer un cap.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/compte-exploitation-previsionnel",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment établir son compte d'exploitation prévisionnel",
      item: "/conseils-pros/compte-exploitation-previsionnel"
    }
  ],
  faq: [
    {
      title: "Quels sont les risques d’un compte d’exploitation prévisionnel&nbsp;?",
      answer: "Comme tout document prospectif, le compte d’exploitation prévisionnel projette une image future, naturellement soumise aux aléas internes et externes à l’exploitation. Le risque principal est d’établir un prévisionnel d’exploitation trop optimiste, basé sur des éléments estimatifs non-mesurés. Cela peut entraîner un endettement disproportionné et a maxima, la faillite de l’entreprise."
    },
    {
      title: "Comment réaliser un compte d’exploitation prévisionnel&nbsp;?",
      answer: "La réalisation d’un compte d’exploitation prévisionnel se bâtit dans un tableur, sur différents éléments complémentaires. Ces éléments focalisent chacun sur une facette économique de l’exploitation projetée. Le résultat de chaque élément converge vers le compte de résultat prévisionnel, à partir duquel l’on élabore un plan de financement et un seuil de rentabilité."
    },
    {
      title: "Pourquoi réaliser un compte d’exploitation prévisionnel&nbsp;?",
      answer: "Dans un projet de création ou de reprise d’un commerce ou d’une entreprise, réaliser un compte d’exploitation prévisionnel permet d’avoir une vision de l’exploitation future et un cap à suivre. C’est également indispensable dans le cadre d’une demande de financement, où le candidat à la reprise démontre sa maîtrise économique du projet."
    }
  ]
},
"/conseils-pros/gestion-tresorerie": {
  title: "Nos conseils sur la gestion de trésorerie en entreprise",
  description: "La gestion de trésorerie est le fondement d’une entreprise pérenne, permettant d’anticiper les flux d’argent pour assurer le financement de l’activité.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/gestion-tresorerie",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Nos conseils sur la gestion de trésorerie en entreprise",
      item: "/conseils-pros/gestion-tresorerie"
    }
  ],
  faq: [
    {
      title: "Comment établir un plan de trésorerie&nbsp;?",
      answer: "Pour établir un plan de trésorerie efficace, il est essentiel de commencer par la création et le suivi attentif d'un plan prévisionnel de trésorerie. Cela implique l'analyse régulière de différents indicateurs financiers, qui va vous aider à identifier et à mettre en œuvre des mesures proactives ou correctives adaptées. Parmi ces mesures, on peut citer la gestion optimisée des stocks, la négociation des délais de paiement avec vos fournisseurs et de recouvrement avec vos clients, ainsi que l'évaluation d’opportunités de placements financiers pour optimiser vos ressources. Ces actions contribueront à la santé financière de votre entreprise en assurant une gestion de trésorerie plus prédictive et réactive."
    },
    {
      title: "Quel est le principal outil en gestion de trésorerie&nbsp;?",
      answer: "Le principal outil en gestion de trésorerie est le plan de trésorerie, aussi connu sous le nom de budget de trésorerie. Il permet de suivre et prévoir les flux de trésorerie, les entrées et sorties d'argent, sur une période donnée, aidant ainsi à anticiper les besoins en fonds et à gérer efficacement les liquidités de l'entreprise."
    },
    {
      title: "Pourquoi la gestion de trésorerie est indispensable&nbsp;?",
      answer: "La gestion de trésorerie est incontournable en entreprise, car elle permet d’anticiper les aléas éventuels pouvant mener à une situation de cessation de paiements. Elle permet aussi de réaliser des économies de fonctionnement et de constituer une réserve financière de sécurité ou d’investissement."
    }
  ]
},
"/conseils-pros/accompagnement-creation-entreprise": {
  title: "Trouver votre accompagnement à la création d'entreprise",
  description: "Être accompagné lors d’une création (ou reprise) d’entreprise augmente fortement les chances de réussite. Découvrez les différentes pistes d’accompagnement.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/accompagnement-creation-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Trouver votre accompagnement à la création d'entreprise",
      item: "/conseils-pros/accompagnement-creation-entreprise"
    }
  ],
  faq: [
    {
      title: "Pourquoi se faire accompagner dans la création d'entreprise&nbsp;?",
      answer: "Entreprendre est une aventure jalonnée de multiples écueils à éviter : financiers, juridiques, fiscaux, administratifs, normatifs, légaux, sociaux. En étant accompagné, le futur dirigeant s’entoure de savoir-faire et de conseils qui l’orientent dans la bonne direction et lui permettent de se focaliser sur son projet."
    },
    {
      title: "Comment se faire accompagner pour créer son entreprise&nbsp;?",
      answer: "Les formes d’accompagnement à la création d'entreprise varient en fonction des besoins et de la maturité du projet. L’accompagnement peut intervenir à différentes phases : préparative, analytique, prévisionnelle, financière, de création ou de lancement."
    },
    {
      title: "Qui contacter pour monter un projet&nbsp;?",
      answer: "Les acteurs de l’accompagnement en création d'entreprise sont nombreux, privés ou publics. Hormis les accompagnants naturels que sont les conseils comptables et juridiques du créateur ou du repreneur, il existe plusieurs réseaux d’accompagnement stratégique et/ou financier dotés par les fonds publics (BPI, Entreprendre, Initiative France, etc.)."
    }
  ]
},
"/conseils-pros/calcul-imposition-titre-societe": {
  title: "Titres de société : Calcul & imposition de la plus-value",
  description: "Si la cession des titres d’une société génère une plus-value, celle-ci est soumise à l’impôt. Comment anticiper l’imposition pour optimiser la cession ?",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/calcul-imposition-titre-societe",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Titres de société : Calcul & imposition de la plus-value",
      item: "/conseils-pros/calcul-imposition-titre-societe"
    }
  ],
  faq: [
    {
      title: "Comment optimiser l’imposition sur plus-value de cession des titres&nbsp;?",
      answer: "Il est possible d’optimiser l’imposition sur plus-value de cession de titres de société en bénéficiant d’abattements pour durée de détention des titres. Le départ en retraite du dirigeant entraîne également un abattement important. Enfin, les mécanismes de l’apport-cession et de donation avant cession permettent de réduire la fiscalité en préparant l’investissement dans un autre projet ou en transmettant du patrimoine à ses descendants."
    },
    {
      title: "Comment est imposée la plus-value de cession des titres de société&nbsp;?",
      answer: "Les plus-values sur cessions de titres de société sont soumises au prélèvement forfaitaire unique (la fameuse « flat-tax ») ou à l’intégration au barème progressif de l’impôt sur le revenu. L’imposition sur plus-value de titres de société varie en fonction de la date d’acquisition des titres, avant ou après le 1er janvier 2018."
    },
    {
      title: "Comment est calculée la plus-value de cession des titres de société&nbsp;?",
      answer: "La plus-value sur cession de titres de société est la différence entre le prix de revient des titres et leur prix de cession. Le prix de revient est indiqué dans l’acte d’achat ou de donation, auquel s’ajoutent les frais d’acquisition. Si l’entreprise a été créée, il est constitué par le total des apports initiaux et des augmentations de capital par apport en numéraire ou en industrie."
    }
  ]
},
"/conseils-pros/cession-entreprise": {
  title: "Guide sur la cession d’entreprise, reprise et transmission",
  description: "Vendre une entreprise suit une chronologie en étapes distinctes et bien précises. Voici notre guide sur la cession d’entreprise, reprise et transmission.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/cession-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Guide sur la cession d’entreprise, reprise et transmission",
      item: "/conseils-pros/cession-entreprise"
    }
  ],
  faq: [
    {
      title: "Quelles sont les étapes de la cession d’une entreprise&nbsp;?",
      answer: "L’étape préparatoire (diagnostic, prévisionnel et dossier de présentation) consiste à se poser les bonnes questions pour choisir le bon mode de cession. Puis vient la recherche, la sélection et la rencontre des repreneurs potentiels. Enfin, la phase de vente se compose de la négociation (signature de la lettre d’intention),\n l’accord (signature du protocole d’accord) et le closing (signature de l’acte définitif)."
    },
    {
      title: "Comment choisir le mode de cession d’une entreprise&nbsp;?",
      answer: "Choisir le mode de cession d’une entreprise relève de facteurs personnels et externes. Titres de société, fonds de commerce (cession onéreuse),\n donation ou succession (gratuite) ou location gérance (temporaire). Le choix dépend principalement de l’imposition sur plus-value, l’attractivité de l’affaire, sa structuration générale et la nature du repreneur (salariés, enfants, personne physique ou morale extérieure à l’entreprise)."
    },
    {
      title: "Pourquoi anticiper la cession de son entreprise&nbsp;?",
      answer: "Anticiper la cession de son entreprise permet au dirigeant d’analyser et valider les raisons de son choix. Mais aussi de planifier l’après, en termes patrimoniaux, fiscaux, voire entrepreneuriaux. En réalisant un diagnostic de l’entreprise et un dossier de vente réaliste et prometteur, il définit un calendrier et se dote d’arguments solides pour défendre son prix de vente."
    }
  ]
},
"/conseils-pros/lbo": {
  title: "Intérêt et mise en place d’un LBO (Leveraged buy-out)",
  description: "Découvrez ce qu'est le LBO, quel est son intérêt et comment le mettre en place pour la reprise d'une entreprise).",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/lbo",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Intérêt et mise en place d’un LBO (Leveraged buy-out)",
      item: "/conseils-pros/lbo"
    }
  ],
  faq: [
    {
      title: "Quels sont les avantages du LBO&nbsp;?",
      answer: "L’avantage majeur du LBO est de pouvoir racheter une société en engageant peu de fonds propres. Cela permet à des cadres dirigeants de reprendre leur propre entreprise, qu’ils connaissent bien. Cela permet aussi à des chefs d’entreprise partant en retraite de transmettre leur société avec plus de probabilité de réussite de l’opération."
    },
    {
      title: "Comment fonctionne le LBO&nbsp;?",
      answer: "Dans le LBO, l’effet de levier passe par un endettement conséquent pour racheter l’entreprise cible (société fille) via une holding (société mère). Dans le montage, le crédit souscrit par la holding est remboursé par les bénéfices de la société fille, remontés sur la holding sous forme de dividendes."
    },
    {
      title: "Qu’est-ce que le LBO&nbsp?",
      answer: "Le leveraged buy-out (LBO) est un montage financier avec effet de levier utilisé dans le rachat d’entreprise, de la PME aux grands groupes. Il existe différents types de LBO, en fonction de la nature du repreneur, intérieur ou extérieur (ou les 2) à l’entreprise rachetée : LMBO, LBI ou LMBI, LBU, BIMBO et OBO."
    }
  ]
},
"/conseils-pros/garantie-actif-passif": {
  title: "Garantie actif passif : tout connaître de cette clause",
  description: "La garantie actif passif permet, lors de la reprise d’une entreprise, de protéger l’acquéreur contre un risque financier lié à la gestion de son prédécesseur.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/garantie-actif-passif",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Garantie actif passif : tout connaître de cette clause",
      item: "/conseils-pros/garantie-actif-passif"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce que la contre-garantie de garantie actif-passif&nbsp;?",
      answer: "Lorsque le vendeur préfère percevoir le prix total lors de la cession, plutôt que d’en bloquer une partie en garantie, il peut recourir une contre-garantie. C’est alors sa banque qui se porte garante de la garantie actif passif et qui devient l’entité actionnable en garantie à la place du cédant. \\n"
    },
    {
      title: "Comment fonctionne la garantie actif-passif&nbsp;?",
      answer: "La garantie actif passif consiste à bloquer une partie du prix de vente sur une durée précise, généralement 3 ans. Au fil du temps et de la diminution du risque, le montant bloqué en garantie est progressivement libéré au bénéfice du vendeur."
    },
    {
      title: "Qu’est-ce que la garantie actif-passif&nbsp;?",
      answer: "Dans une cession d’entreprise, l’acquéreur reprend l’intégralité de la structure juridique, s’exposant aux potentielles conséquences de la gestion du prédécesseur. La garantie actif passif est une garantie donnée au repreneur par le vendeur. Elle sécurise ainsi le risque fiscal et financier."
    }
  ]
},
"/conseils-pros/business-plan": {
  title: "C’est quoi un business plan ? Exemple et conseils\\r\\n",
  description: "Lors d’une création ou reprise d’entreprise, faire un business plan est indispensable pour détailler les objectifs à atteindre et les méthodes pour y parvenir.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/business-plan",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "C’est quoi un business plan ? Exemple et conseils\\r\\n",
      item: "/conseils-pros/business-plan"
    }
  ],
  faq: [
    {
      title: "Comment monter un business plan&nbsp;?",
      answer: "Un business plan comprend plusieurs volets, destinés à présenter de manière exhaustive le projet. Résumé, genèse du projet, contexte, équipe et marché plantent le décor. Descriptif de l’offre, business model, stratégie et moyens entrent dans le vif du sujet. Le dossier financier complète et étaye le propos par des chiffres cohérents."
    },
    {
      title: "Où trouver un business plan&nbsp;?",
      answer: "Pour trouver un business plan, vous pouvez consulter des modèles en ligne, utiliser des logiciels de business planning, vous adresser à des chambres de commerce ou réseaux d'entrepreneurs, ou encore consulter des livres et guides dans les bibliothèques. Des conseillers en création d'entreprise et des formations en entrepreneuriat peuvent également vous être utiles. Choisissez la ressource qui correspond le mieux à votre secteur et à vos besoins."
    },
    {
      title: "Qu’est-ce qu’un business plan&nbsp;?",
      answer: "Le business plan est un document préparatoire réalisé lors d’un projet de création ou de reprise d’entreprise. Il détaille toutes les facettes du projet, en précisant objectivement comment l’entreprise va être organisée, créer de la valeur, réaliser du chiffre d’affaires et pérenniser."
    }
  ]
},
"/conseils-pros/earn-out": {
  title: "La clause d'earn out : comprendre son fonctionnement",
  description: "La clause d’earn out permet de faciliter la cession d’une entreprise en conditionnant une partie du prix de vente aux résultats d’exploitation futurs.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/earn-out",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "La clause d'earn out : comprendre son fonctionnement",
      item: "/conseils-pros/earn-out"
    }
  ],
  faq: [
    {
      title: "Quelles sont les difficultés posées pas les clauses d'earn-out&nbsp;?",
      answer: "Les clauses d'earn out introduisent des défis tels que la complexité des calculs pour définir des critères de performance clairs et mesurables, les conflits potentiels sur l'évaluation des performances de l'entreprise après la vente, l'incertitude financière pour le vendeur qui ne peut prévoir le montant final qu'il recevra, et des risques de gestion orientée vers la maximisation des résultats à court terme au détriment de la santé à long terme de l'entreprise."
    },
    {
      title: "Que signifie \\\"clause d'earn-out\\\" en français&nbsp;?",
      answer: "La \\\"clause d'earn out\\\" en français désigne une clause de complément de prix dans un contrat de cession d'entreprise entre acheteur et vendeur. Elle prévoit que le paiement d'une partie du prix de vente dépendra de la réalisation de certains objectifs financiers ou opérationnels de l'entreprise cédée après la vente."
    },
    {
      title: "Comment comptabiliser un earn-out&nbsp;?",
      answer: "Pour comptabiliser un earn-out, une partie conditionnelle du paiement dans une opération de reprise, commencez par évaluer le montant probable à la date de l'acquisition, basé sur les prévisions de performance future de l'entité acquise. Ce montant est ensuite comptabilisé comme une dette ou un actif. Il doit être réévalué à chaque période comptable en fonction des performances réelles et des nouvelles prévisions. Les ajustements de cette estimation sont reflétés dans le compte de résultat, influençant directement le résultat financier de l'entreprise."
    }
  ]
},
"/conseils-pros/reprise-entreprise": {
  title: "Le guide pour votre reprise d'entreprise : Étapes & conseils",
  description: "Découvrez les étapes essentielles de la reprise d'une entreprise : préparation, chiffrage, négociation, montage, financement et signature.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/reprise-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Le guide pour votre reprise d'entreprise : Étapes & conseils",
      item: "/conseils-pros/reprise-entreprise"
    }
  ],
  faq: [
    {
      title: "Comment racheter/reprendre une entreprise&nbsp;?",
      answer: "Définissez vos motivations, évaluez vos compétences et assurez votre apport financier. Recherchez des entreprises via votre réseau, chambres de commerce et plateformes en ligne. Rencontrez les cédants pour évaluer la compatibilité. Analysez la structure et les finances de l’entreprise, puis élaborez un business plan détaillé. Soumettez votre dossier à plusieurs banques pour obtenir le financement nécessaire. Rédigez une lettre d’intention et un protocole d’accord. Une fois les conditions remplies, signez l’acte définitif de vente et prévoyez un accompagnement par le cédant pour faciliter la transition."
    },
    {
      title: "Comment se déroule l'accompagnement pour une reprise d'entreprise&nbsp;?",
      answer: "L’accompagnement du repreneur par le cédant doit être discuté dès le début. Plus l’entreprise dépend d’un savoir-faire spécifique ou de son dirigeant, plus cet accompagnement doit être planifié. Il n’y a pas de norme d’accompagnement, c’est un accord mutuel influençant le financement ; L’accompagnement peut être rémunéré, selon sa durée et le rôle du cédant."
    },
    {
      title: "Quelles sont les aides à la reprise d'une activité&nbsp;?",
      answer: "Les aides incluent les prêts d'honneur, les garanties de prêts, ainsi que des subventions régionales. Des exonérations fiscales et l'ARCE pour les demandeurs d'emploi sont disponibles. Les CCI et CMA offrent formations et accompagnements, et les plateformes de crowdfunding aident à lever des fonds."
    }
  ]
},
"/conseils-pros/categorie-erp": {
  title: "Assurer l'accessibilité dans les ERP : Un guide par catégorie",
  description: "Guide sur les ERP en France : classification, accessibilité et conseils pour l'inclusion de tous.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/categorie-erp",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Assurer l'accessibilité dans les ERP : Un guide par catégorie",
      item: "/conseils-pros/categorie-erp"
    }
  ],
  faq: [
    {
      title: "Quelle est la réglementation des ERP du 1er et 2e groupe&nbsp;?",
      answer: "La réglementation des ERP du 1er et 2e groupe définit les normes de sécurité, d'accessibilité, et de protection contre les incendies pour les établissements accueillant du public. Le 1er groupe concerne les grandes structures avec des règles plus strictes, tandis que le 2e groupe s'applique aux établissements plus petits. Les exigences incluent la gestion des issues de secours, des systèmes d'alarme, et l'accessibilité pour les personnes à mobilité réduite. Ces règles varient selon les juridictions et nécessitent une vérification des lois locales."
    },
    {
      title: "Comment calculer la catégorie d'un ERP&nbsp;?",
      answer: "La catégorie d'un ERP se détermine en évaluant les besoins de l'entreprise (taille, complexité des processus, secteur, et exigences spécifiques) et en les comparant aux fonctionnalités des différents systèmes ERP disponibles. Cela permet de choisir un ERP qui correspond précisément à la capacité requise pour soutenir les opérations de l'entreprise, en évitant un système surdimensionné ou insuffisant."
    },
    {
      title: "C'est quoi un ERP de type l&nbsp;?",
      answer: "Un ERP de type I est un système unifié de gestion d'entreprise intégrant fonctions clés (finance, logistique, RH, CRM, projets) pour une vue globale en temps réel, favorisant coordination, décision et efficacité. Toutefois, malgré ses avantages, il peut s'avérer coûteux, complexe à personnaliser et exige une mise en œuvre et formation soignées."
    }
  ]
},
"/conseils-pros/tableau-de-bord-entreprise": {
  title: "Comment élaborer un tableau de bord d'entreprise ?",
  description: "Un tableau de bord d’entreprise est indispensable pour mesurer et suivre les performances, puis adapter la stratégie. Voici comment le mettre en place.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/tableau-de-bord-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment élaborer un tableau de bord d'entreprise ?",
      item: "/conseils-pros/tableau-de-bord-entreprise"
    }
  ],
  faq: [
    {
      title: "Quels indicateurs-clefs (KPI) pour un tableau de bord d'entreprise&nbsp;?",
      answer: "Il y a trois catégories de KPI. Les KPI d'activité mesurent les volumes (quantités vendues, produites et achetées, stocks, nombre de clients, etc.). Les KPI de résultats mesurent les performances (financière, de rentabilité, de coûts, de qualité, commerciale et marketing). Les KPI RH mesurent le turn-over, les processus, ou encore la satisfaction des employés)."
    },
    {
      title: "Comment construire un tableau de bord d'entreprise&nbsp;?",
      answer: "Pour créer un tableau de bord d'entreprise, il faut détailler les objectifs de l’entreprise, puis les éléments-clefs pour les atteindre. Puis on définit les 10 indicateurs les plus pertinents (KPI - Key Performance Indicators). Ils doivent être facilement et clairement calculables. Faire participer les membres de l’équipe à la création du tableau de bord d’entreprise permet d’assurer son adoption dans la durée."
    },
    {
      title: "Pourquoi utiliser un tableau de bord d'entreprise&nbsp;?",
      answer: "Le tableau de bord d'entreprise permet le pilotage opérationnel et le pilotage stratégique de l’entreprise. Le premier mesure la réalisation de l’activité et permet de corriger ce qui doit l’être. Le second  permet d’avoir une vision globale et ainsi d’adopter des décisions stratégiques à moyen/long terme."
    }
  ]
},
"/conseils-pros/gestion-de-stock": {
  title: "Découvrez les différentes méthodes de gestion de stock",
  description: "Découvrez pourquoi la gestion de stocks a un impact majeur sur la pérennité de l’entreprise et quelles méthodes utiliser en fonction de l’activité.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/gestion-de-stock",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Découvrez les différentes méthodes de gestion de stock",
      item: "/conseils-pros/gestion-de-stock"
    }
  ],
  faq: [
    {
      title: "Comment choisir sa méthode de gestion de stock&nbsp;?",
      answer: "La date de la commande et les quantités commandées, fixes ou variables, sont les deux éléments moteurs de la gestion de stock. Au-delà de notions de bon sens, d’ordre et de propreté des locaux d’entreposage, chaque activité requiert une méthode adaptée : réapprovisionnement ou calendaire, à point de commande, recomplètement, réapprovisionnement, JAT (juste à temps) ou kanban."
    },
    {
      title: "Quels sont les enjeux de la gestion de stock&nbsp;?",
      answer: "L’enjeu principal de la gestion de stock est d’assurer le fonctionnement permanent de la chaîne de fabrication, exploitation et distribution. Des stocks mal gérés peuvent devenir un handicap et mettre en danger la santé financière de l’entreprise, notamment avec le sous-stockage ou le sur-stockage."
    },
    {
      title: "Qu’est-ce que la gestion de stock&nbsp;?",
      answer: "Le stock immobilise des fonds de l’entreprise, qui ne se transforment en flux de trésorerie entrants que lorsqu’ils sont vendus. La gestion de stock consiste donc à déployer un ensemble de méthodes pour trouver l’équilibre idéal entre la quantité minimale de stock nécessaire et la capacité permanente à satisfaire la demande sans rupture."
    }
  ]
},
"/conseils-pros/gerer-entreprise": {
  title: "Comment gérer son entreprise ? Découvrez nos conseils",
  description: "Bien gérer une entreprise nécessite de déployer des méthodes adaptées, souvent empreintes de bon sens. Découvrez nos préconisations simples à mettre en place.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/gerer-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment gérer son entreprise ? Découvrez nos conseils",
      item: "/conseils-pros/gerer-entreprise"
    }
  ],
  faq: [
    {
      title: "Quels outils utiliser pour bien gérer une entreprise&nbsp;?",
      answer: "Il existe de nombreux outils et méthodes pour bien gérer une entreprise. Le management collaboratif et le lean management pour l’approche humaine. Pour l’opérationnel, on retient les méthodes Kanban, DMAIC, PDCA, le diagramme de Gantt, mais aussi les méthodes SMQ, QQOQCCP, les 5S, les 8D, le diagramme de Pareto ou encore la méthode Poka Yoké. Toutes ont en commun une analyse méthodique de l’exploitation en vue de l’optimiser."
    },
    {
      title: "Quelles sont les principales méthodes pour bien gérer une entreprise&nbsp;?",
      answer: "Les principales méthodes pour bien gérer une entreprise reposent avant tout sur la définition de process efficients, de tableaux de bords exploitables et d’une offre claire. Il faut ensuite réfléchir en équipe, tenir une comptabilité ordonnée, informatiser et bien gérer les stocks. Enfin, maîtriser ses dépenses et ses fournisseurs, limiter les gaspillages complète le dispositif. Plusieurs outils permettent de mener cela à bien."
    },
    {
      title: "Bien gérer une entreprise demande-t-il des connaissances pointues&nbsp;?",
      answer: "Bien gérer une entreprise n’est pas un exercice facile. Cependant, au-delà des techniques de gestion financières, il existe une multitude de méthodes simples et évidentes pour optimiser l’exploitation. Souvent empreintes de bon sens, ces méthodes nécessitent un peu de recul de la part du dirigeant pour analyser sa propre activité, en vue de l’améliorer."
    }
  ]
},
"/conseils-pros/methode-smart": {
  title: "Fixer vos objectifs avec la méthode SMART",
  description: "La réussite en entreprise dépend entre autres de la réalisation d’objectifs. Pour fixer ces objectifs, il existe une méthode efficace : la méthode SMART.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/methode-smart",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Fixer vos objectifs avec la méthode SMART",
      item: "/conseils-pros/methode-smart"
    }
  ],
  faq: [
    {
      title: "Comment définir des objectifs avec la méthode SMART&nbsp;?",
      answer: "Créer et écrire des objectifs avec la méthode SMART consiste à suivre une trame de 5 critères, en détaillant chaque élément pour le clarifier au mieux. Les 5 critères SMART préconisent que les objectifs doivent être Spécifiques, Mesurables, Atteignables/Ambitieux, Réalistes et Temporels (définis dans le temps). Ainsi, rien n’est laissé au hasard et chaque tâche est précisée."
    },
    {
      title: "Pourquoi définir des objectifs avec la méthode SMART&nbsp;?",
      answer: "Utiliser la méthode SMART pour définir des objectifs permet à l’entreprise d’optimiser ses différents projets. Les effets bénéfiques sont le gain de temps, l’économie d’argent, l’optimisation des ressources diverses, l’évitement de problèmes potentiels et l’efficience et la satisfaction des collaborateurs. Et donc l’atteinte d’objectifs plus facilement."
    },
    {
      title: "Qu’est-ce que la méthode SMART&nbsp;?",
      answer: "La méthode SMART est un management par objectifs. C’est un outil servant à établir les objectifs et indicateurs les mieux adaptés à la réussite d’un projet. A partir d’une trame de réflexion, les objectifs sont clairement établis avec l’équipe impliquée dans le projet, afin de maximiser ses chances de succès."
    }
  ]
},
"/conseils-pros/optimiser-process-entreprise": {
  title: "Comment optimiser vos process en entreprise ?",
  description: "La gestion d’entreprise dépend de process établis. Ils doivent évoluer pour rester pertinents et s’adapter au contexte. Voici les méthodes pour les optimiser.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/optimiser-process-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment optimiser vos process en entreprise ?",
      item: "/conseils-pros/optimiser-process-entreprise"
    }
  ],
  faq: [
    {
      title: "Que peut-on optimiser avec des process d’entreprise&nbsp;?",
      answer: "Définir des process d’entreprise permet de résoudre de nombreux maux dans une exploitation. De manière générique, il y a les process visant à identifier et résoudre les problèmes. Il y a aussi ceux destinés à optimiser la qualité, ou encore l‘efficacité. Et enfin il y a les process que l’on utilise pour gérer les différents projets, comme la méthode Kanban."
    },
    {
      title: "Comment améliorer les process d’entreprise&nbsp;?",
      answer: "Pour identifier et résoudre les problèmes, on peut recourir à plusieurs méthodes reconnues. Elles consistent à procéder par étapes. On identifie le problème par ses symptômes, puis on évalue son ampleur. Après avoir ciblé ses causes, on réfléchit à la meilleure solution, qu’on déploie, qu’on vérifie dans le temps et qu’on améliore si nécessaire."
    },
    {
      title: "Pourquoi définir des process en entreprise&nbsp;?",
      answer: "En entreprise, l’exploitation nécessite d’accomplir un ensemble de tâches, en vue d’obtenir un résultat. Chaque tâche peut être décomposée en une série d’actions précises. Pour optimiser l’accomplissement de ces tâches et leur aboutissement, il faut définir des process. Ce sont des modes opératoires écrits, qu’il suffit aux collaborateurs de suivre à la lettre."
    }
  ]
},
"/conseils-pros/chasse-gaspillage-economies-entreprise": {
  title: "La chasse au gaspillage en entreprise",
  description: "Le succès en entreprise dépend entre autres d’une bonne maîtrise des coûts. La chasse au gaspillage permet ainsi de réaliser de belles économies.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/chasse-gaspillage-economies-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "La chasse au gaspillage en entreprise",
      item: "/conseils-pros/chasse-gaspillage-economies-entreprise"
    }
  ],
  faq: [
    {
      title: "Comment gérer les offerts clients et la consommation du personnel&nbsp;?",
      answer: "Les offerts clients et les consommations du personnel obéissent à des normes comptables. Ce sont des comptes de charges qui impactent votre marge, votre rentabilité et votre résultat comptable. La marchandise ayant été achetée, sa sortie doit être comptabilisée. Pour maîtriser vos marges, offertes clients et consommation du personnel doivent être encadrées par des règles claires."
    },
    {
      title: "Quelles sont les potentiels gaspillages à surveiller en entreprise&nbsp;?",
      answer: "De nombreux postes de charges peuvent être victimes de gaspillage. Le déploiement de règles simples permet de les optimiser. L’on retrouve principalement les énergies et fluides, les fournitures administratives et les invendus. Le respect du matériel par les employés permet également de prolonger son utilisation. Enfin, il faut bien gérer les offerts, cadeaux et consommations personnelles."
    },
    {
      title: "Pourquoi chasser le gaspillage en entreprise&nbsp;?",
      answer: "Dans les facteurs de réussite d’une entreprise, on retrouve la maîtrise des coûts : négociation avec ses fournisseurs, bonne gestion des ressources et économies. Une chasse au gaspillage raisonnée est souvent la première source d’économies importantes, grâce à la participation et la vigilance des équipes."
    }
  ]
},
"/conseils-pros/e-reputation": {
  title: "E-reputation d'entreprise : Comment bien la maîtriser ?",
  description: "L’e-reputation traduit la satisfaction de vos clients en ligne. 1er levier de commercialisation ou 1ère cause d’échec, il est indispensable de la maîtriser.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/e-reputation",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "E-reputation d'entreprise : Comment bien la maîtriser ?",
      item: "/conseils-pros/e-reputation"
    }
  ],
  faq: [
    {
      title: "Comment améliorer sa e reputation&nbsp;?",
      answer: "Bien gérer sa e-reputation consiste principalement à suivre et à traiter les publications sur votre affaire. Relayer les avis positifs permet de mieux vendre son offre et de conquérir de nouveaux clients. Traiter systématiquement et adroitement les avis négatifs permet de montrer à tout le monde que vous vous souciez de la satisfaction de vos clients."
    },
    {
      title: "Pourquoi l’entreprise doit-elle bien gérer sa e-reputation&nbsp;?",
      answer: "Pour une entreprise, bien gérer sa e-reputation est aussi important que bien gérer sa trésorerie. C’est souvent sur la base de sa e-reputation que ses potentiels clients décident de passer à l’acte d’achat... ou non. C’est donc un immense levier de commercialisation, puisqu’une bonne e-reputation traduit la satisfaction clientèle et rassure le prospect."
    },
    {
      title: "L’e-réputation, c’est quoi&nbsp;?",
      answer: "L’e-réputation, c’est la réputation de votre entreprise sur internet et les réseaux sociaux. Cela inclut tout ce qui peut y être publié (notes, avis, commentaires, informations, même les rumeurs) au sujet de votre affaire. Ces informations étant facilement accessibles à tous, leur impact dépasse largement la notion de réputation d’avant internet & des réseaux sociaux."
    }
  ]
},
"/conseils-pros/nantissement-fonds-commerce": {
  title: "Le nantissement de fonds de commerce",
  description: "Le nantissement du fonds de commerce est un gage donné par l’exploitant à sa banque (ou à un fournisseur),\n en garantie du règlement de son prêt.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/nantissement-fonds-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Le nantissement de fonds de commerce",
      item: "/conseils-pros/nantissement-fonds-commerce"
    }
  ],
  faq: [
    {
      title: "Comment formaliser le nantissement de fonds de commerce&nbsp;?",
      answer: "Le nantissement de fonds de commerce est un contrat écrit (sous seing privé ou par un acte notarié),\n concomitant à l’acte d’acquisition du fonds et au contrat de prêt. Il est enregistré au greffe et reste valable 10 ans, pouvant être renouvelé et modifié. Le contrat de nantissement de fonds de commerce doit intégrer au minimum l’enseigne, le nom commercial, la clientèle et l’achalandage, ainsi que le droit au bail. L’immobilier et le stock ne sont pas inclus."
    },
    {
      title: "Qui a recours au nantissement de fonds de commerce&nbsp;?",
      answer: "Dans le cadre d’une reprise de fonds de commerce, l’acquéreur nécessite un financement. Généralement une banque. Certains fournisseurs participent parfois à une fraction du financement. Ils sont alors créanciers de l’exploitant. L’octroi d’un prêt étant conditionné à des garanties, la première d’entre elles, exigée par le créancier, est le nantissement du fonds de commerce. L’administration fiscale peut aussi avoir recours au nantissement du fonds de commerce, dans le cadre d’un contentieux fiscal."
    },
    {
      title: "Qu’est-ce que le nantissement de fonds de commerce&nbsp;?",
      answer: "Le nantissement de fonds de commerce est une garantie utilisée par un  créancier (banque ou fournisseur) avec le (futur) exploitant d’une entreprise. Par ce contrat, ce dernier donne le fonds en garantie du paiement de sa dette. S’il ne paye plus sa dette, le prêteur a un droit de préférence et un droit de suite sur le fonds de commerce lorsqu’il est vendu."
    }
  ]
},
"/conseils-pros/hotel-investissement": {
  title: "Hotel à vendre : quelles étapes pour un investissement réussi ?",
  description: "Racheter le fonds de commerce d’un hôtel à vendre est une opération jalonnée d’étapes-clefs. Voici comment procéder pour un investissement réussi.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/hotel-investissement",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Hotel à vendre : quelles étapes pour un investissement réussi ?",
      item: "/conseils-pros/hotel-investissement"
    }
  ],
  faq: [
    {
      title: "Quelles sont les points de vigilance à regarder sur un hôtel à vendre&nbsp;?",
      answer: "Dans un dossier d’hôtel à vendre, les points de vigilance sont nombreux. Il y le sujet des normes (sécurité, accessibilité, classement, hygiène). Puis le sujet de l’état de l’outil d’exploitation (équipement des chambres, répartition des locaux, qualité et ancienneté du matériel). Ensuite viennent les contrats (maintenance, commerciaux, salariés). Et enfin il faut en faire une bonne valorisation par différentes approches."
    },
    {
      title: "Comment appréhender les performances d’un hôtel à vendre&nbsp;?",
      answer: "Lorsqu’on étudie un dossier d’hôtel à vendre, les performances à étudier sont d’abord les performances économiques : chiffre d’affaires, marges, valeur ajoutée et rentabilité. Puis viennent les performances commerciales : le taux d’occupation, le PMC (prix moyen chambre),\n le revpar (revenu par chambre)."
    },
    {
      title: "Qu’est-ce qu’un fonds de commerce d’hôtel à vendre&nbsp;?",
      answer: "Un fonds de commerce d’hôtel à vendre comprend d’une part les éléments corporels, composés par le matériel, l’outillage et les aménagements. D’autre part, les éléments incorporels, composés par la clientèle, le nom commercial, les licences et le droit au bail, entre autres."
    }
  ]
},
"/conseils-pros/location-gerance-risques-avantages": {
  title: "Comment éviter les pièges de la location-gérance ? Nos conseils",
  description: "La location-gérance de fonds de commerce est une alternative à l’achat du fonds, mais aussi un préliminaire. Quels sont les risques et les avantages ?",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/location-gerance-risques-avantages",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment éviter les pièges de la location-gérance ? Nos conseils",
      item: "/conseils-pros/location-gerance-risques-avantages"
    }
  ],
  faq: [
    {
      title: "Quelle est la différence entre le bail commercial et la location-gérance&nbsp;?",
      answer: "La différence principale entre le bail commercial et la location-gérance réside dans ce qui est loué et les responsabilités qui en découlent. Dans un bail commercial, un propriétaire loue un local commercial à un entrepreneur, qui y exerce son activité indépendamment. Le locataire est responsable de l'entreprise mais ne détient pas les actifs commerciaux de la propriété. En revanche, dans une location-gérance, le propriétaire d'une entreprise confie la gestion de celle-ci, y compris son fonds de commerce, à un locataire-gérant. Le locataire-gérant dirige l'entreprise mais ne la possède pas, et le propriétaire reste responsable de certains aspects juridiques et financiers de l'entreprise."
    },
    {
      title: "Quel est l'intérêt de la location-gérance&nbsp;?",
      answer: "Pour le propriétaire du fonds, la mise en location-gérance offre un revenu régulier (la redevance),\n sans devoir exploiter le fonds. Elle lui garantit aussi une continuité de l’activité professionnelle s’il reprend l’activité à son compte en fin de contrat. Pour le locataire-gérant, c’est une facilité d’accès à un fonds, notamment si son apport est insuffisant pour acheter immédiatement le fonds. Il peut aussi juger de la viabilité du bien avant de l’acquérir."
    },
    {
      title: "Comment est rémunéré un locataire-gérant&nbsp;?",
      answer: "Un locataire-gérant est rémunéré en percevant une part des bénéfices de l'entreprise qu'il gère. Cette rémunération est généralement définie dans le contrat de location-gérance et peut être un montant fixe, un pourcentage des ventes ou des bénéfices, ou une combinaison des deux. En plus de cette part sur les bénéfices, le locataire-gérant peut aussi se verser un salaire s'il est également employé de l'entreprise."
    }
  ]
},
"/conseils-pros/acte-sous-seing-prive-acte-authentique": {
  title: "Acte sous seing privé ou acte authentique : ce qui les oppose",
  description: "Découvrez quelles sont les différences entre un acte sous seing privé et un acte authentique lors d’une vente de fonds de commerce.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/acte-sous-seing-prive-acte-authentique",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Acte sous seing privé ou acte authentique : ce qui les oppose",
      item: "/conseils-pros/acte-sous-seing-prive-acte-authentique"
    }
  ],
  faq: [
    {
      title: "Quelles sont les garanties d’un acte authentique&nbsp;?",
      answer: "Un acte authentique présente 3 grandes garanties : une date certaine qui rend le rend incontestable, une force probante qui lui donne le statut de preuve en cas de litige et une force exécutoire qui permet de faire valoir les termes qui le composent. A contrario, l’acte sous seing privé est garanti à partir du moment où il est enregistré auprès de l’administration fiscale après signature."
    },
    {
      title: "Dans quels cas recourir à un acte sous seing privé&nbsp;?",
      answer: "Les actes sous seing privé sont utilisés dans 90% des cas. Pour les compromis de vente immobilière, les locations-gérances de fonds de commerce, les cessions de parts sociales, les contrats de location, reconnaissance de dette, etc. Moins exigeants que les actes authentiques, ils peuvent être rédigés et signés par des particuliers, avec ou sans intervention d’un avocat pour les accompagner (ce qui est fortement déconseillé pour éviter les risques de nullité, ou pire)."
    },
    {
      title: "Quelle est la différence entre un acte sous seing privé et un acte authentique&nbsp;?",
      answer: "L’acte authentique s’oppose à l’acte sous seing privé dans la mesure où il doit être rédigé et signé par un officier public (notaire ou huissier). Alors que l’acte sous seing privé peut être rédigé par les parties, généralement accompagnées par des professionnels privés que sont les avocats. Seul l’acte authentique peut être utilisé pour une vente de logement ou de murs commerciaux. Pour la vente de fonds de commerces ou la cession de parts sociales (ou d’actions),\n l’acte sous seing privé et l’acte authentique peuvent être utilisés. Sauf mention contraire dans le bail commercial (qui peut obliger à un acte authentique)."
    }
  ]
},
"/conseils-pros/choisir-fonds-commerce-boulangerie": {
  title: "Nos conseils pour réussir la reprise d’un fonds de commerce de boulangerie",
  description: "Découvrez les étapes à ne pas négliger pour bien choisir, préparer, finaliser et réussir votre projet de reprise d’un fonds de commerce de boulangerie.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/choisir-fonds-commerce-boulangerie",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Nos conseils pour réussir la reprise d’un fonds de commerce de boulangerie",
      item: "/conseils-pros/choisir-fonds-commerce-boulangerie"
    }
  ],
  faq: [
    {
      title: "Quels sont les avantages à la reprise d’une boulangerie par rapport à la création&nbsp;?",
      answer: "La reprise d’un fonds de commerce de boulangerie est souvent plus sécurisante qu’une création, votre choix s’appuyant sur l’existant. D’une part, un outil de travail opérationnel puisqu’étant vendu avec le local commercial, le matériel, la clientèle, l’équipe salariale… D’autre part, le financier avec une base concrète de chiffre d’affaires, de revenus générés par l’activité et d’un aperçu de l’évolution possible de l’entreprise."
    },
    {
      title: "Comment trouver une boulangerie à reprendre&nbsp;?",
      answer: "La réussite de votre projet de rachat d’un fonds de commerce de boulangerie passe par une analyse assidue des différentes offres. Pour avoir une meilleure vision des possibilités, rapprochez-vous des réseaux spécialisés, des meuniers, des agents immobiliers spécialisés en vente de boulangerie, de la CCI et de la Chambre des Métiers."
    },
    {
      title: "Comment bien sélectionner le fonds de commerce de boulangerie à reprendre&nbsp;?",
      answer: "Le choix de reprise d’une boulangerie s’articule autour de trois grands axes. Premièrement, il vous faut définir votre projet, à savoir les qualifications nécessaires et le type d’activité exercée. Ensuite, vient l’analyse de la faisabilité du projet au travers de l’étude des finances, des contrats et d’une valorisation du fonds. Enfin, la finalisation du projet, avec la création de la structure juridique, le business plan et l’accompagnement par des professionnels, nécessaire au bon déroulement de la cession de fonds."
    }
  ]
},
"/conseils-pros/choisir-agent-immobilier-fonds-commerce": {
  title: "L’utilité d’un intermédiaire en vente de fonds de commerce",
  description: "Être accompagné par un agent spécialisé pour vendre un fonds de commerce (ou l’acheter) double les chances de succès de l’opération. Comment le choisir ?",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/choisir-agent-immobilier-fonds-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "L’utilité d’un intermédiaire en vente de fonds de commerce",
      item: "/conseils-pros/choisir-agent-immobilier-fonds-commerce"
    }
  ],
  faq: [
    {
      title: "Comment choisir l’agent immobilier spécialisé pour vendre mon fonds de commerce&nbsp;?",
      answer: "Confier la vente de son affaire à un intermédiaire repose sur la confiance. Choisissez-en un qui connaît votre activité et votre secteur. Il fera ainsi une juste estimation de votre bien, posera les bonnes questions et saura mettre en valeur l’affaire auprès des repreneurs. Questionnez-le sur sa stratégie de commercialisation et son réseau de clients potentiels. Il doit être à l’écoute et dynamique. Il saura vous exposer la réalité, même si elle vous déplait. Enfin, outre maîtriser différents paramètres juridiques et comptables, il doit clairement détailler les étapes de son intervention pour votre compte."
    },
    {
      title: "Pourquoi passer par un agent immobilier spécialisé pour vendre mon fonds de commerce&nbsp;?",
      answer: "Passer par un agent immobilier spécialisé vous assure l’accès à une expertise et expérience propre au domaine de la vente de fonds de commerce. La connaissance des spécificités de ce secteur ne s’improvise pas. En faisant appel à un spécialiste, vous bénéficiez d’un accompagnement sur mesure, d’une bonne estimation de l’affaire, d’une diffusion adaptée et confidentielle, d’une l’annonce de vente bien rédigée, d’une sélection des profils adaptés, d’une prise en charge des visites. De l’estimation au closing, il encadre l’opération."
    },
    {
      title: "Quel est le rôle d’un agent immobilier spécialisé en fonds de commerce&nbsp;?",
      answer: "Le rôle d’un agent immobilier spécialisé en fonds de commerce est de sécuriser la vente de votre affaire, pendant que vous vous consacrez à son exploitation au quotidien. L’agent conseille le cédant, évalue l’affaire, cherche et sélectionne les acquéreurs, négocie le bon prix et accompagne les parties jusqu’à la signature finale. Il sait anticiper les problématiques liées à ce type de cession, connaît généralement les grands principes juridiques, comptables, fiscaux et sociaux et les pièges à éviter lorsque l’on vend un fonds de commerce, bien différent d’un logement."
    }
  ]
},
"/conseils-pros/choisir-fonds-commerce-restaurant-racheter": {
  title: "Reprise d’un fonds de commerce de restaurant : Le guide",
  description: "Acheter un fonds de commerce de restaurant nécessite d’analyser de nombreux points clefs. On vous explique !",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/choisir-fonds-commerce-restaurant-racheter",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Reprise d’un fonds de commerce de restaurant : Le guide",
      item: "/conseils-pros/choisir-fonds-commerce-restaurant-racheter"
    }
  ],
  faq: [
    {
      title: "Quelle formation pour ouvrir un restaurant&nbsp;?",
      answer: "Pour ouvrir un restaurant, il est conseillé de suivre une formation adaptée qui couvre à la fois la gestion d'entreprise et les compétences culinaires. Des diplômes en gestion hôtelière ou en restauration, tels que le BTS Management en hôtellerie-restauration ou un diplôme en école de cuisine, peuvent être très bénéfiques. Ces formations enseignent des compétences en gestion des finances, en marketing, en service client, ainsi qu'en préparation et gestion des aliments. Des connaissances en réglementation sanitaire et en sécurité alimentaire sont également cruciales. Il existe des formations spécifiques comme le permis d'exploitation et la formation en hygiène alimentaire, qui sont obligatoires en France pour ouvrir un restaurant."
    },
    {
      title: "Comment acheter un fonds de commerce restaurant&nbsp;?",
      answer: "Pour acheter un fonds de commerce de restaurant, il est essentiel de suivre une démarche structurée. Commencez par évaluer vos besoins et votre budget pour définir le type de restaurant qui vous convient. Ensuite, recherchez des opportunités sur le marché, en utilisant des plateformes spécialisées ou en consultant des agents immobiliers commerciaux. Avant de faire une offre, examinez soigneusement les documents financiers du restaurant pour évaluer sa santé financière et sa rentabilité. Inspectez également l'établissement pour évaluer l'état des équipements et des locaux. Négociez les termes de vente et assurez-vous de comprendre tous les aspects légaux et réglementaires, tels que les baux, les licences et les permis nécessaires."
    },
    {
      title: "Comment valoriser un fonds de commerce restaurant&nbsp;?",
      answer: "Pour valoriser un fonds de commerce de restaurant, commencez par analyser les performances financières, en examinant le chiffre d'affaires, les bénéfices et les flux de trésorerie. L'emplacement et les caractéristiques du marché local sont aussi cruciaux car ils influencent directement la valeur. Évaluez l'état et la valeur des équipements, du mobilier et des améliorations du local. La réputation du restaurant et la fidélité de sa clientèle sont également importantes. Enfin, vérifiez les contrats en cours, tels que les baux et les licences, qui peuvent augmenter la valeur."
    }
  ]
},
"/conseils-pros/sequestre-fonds-commerce": {
  title: "Séquestre du prix de vente d’un fonds de commerce : ce qu’il faut savoir",
  description: "Séquestre du prix de vente lors d’une cession de fonds de commerce : fonctionnement, garantie, impact, délais et réglementation de mise en place.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/sequestre-fonds-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Séquestre du prix de vente d’un fonds de commerce : ce qu’il faut savoir",
      item: "/conseils-pros/sequestre-fonds-commerce"
    }
  ],
  faq: [
    {
      title: "Quels sont les avantages et les difficultés du séquestre de fonds de commerce&nbsp;?",
      answer: "Le séquestre de fonds de commerce est un avantage pour l’acquéreur, protégeant celui-ci de tout litige financier avec les divers créanciers impayés du vendeur qui lui a cédé le fonds. Les dettes sont réglées sur le montant séquestré et non sur la trésorerie future du repreneur. Le séquestre peut présenter une difficulté pour le vendeur, puisque le montant de la vente est bloqué entre 3 et 5 mois. Dépourvu de revenu suite à la cession de son activité et dans l’attente de l’écoulement du délai de séquestre, le vendeur peut se retrouver en difficulté financière s’il n’a pas anticipé les différents aspects d’une cession de fonds."
    },
    {
      title: "Pourquoi séquestrer le prix de vente d’un fonds de commerce&nbsp;?",
      answer: "Le séquestre est indispensable pour protéger l’acquéreur du fonds de commerce du passif fiscal du vendeur et des conséquences liées aux oppositions des créanciers. De ce fait, si le prix de vente n’est pas séquestré, les créanciers impayés peuvent se retourner vers l’acquéreur pour purger les dettes, à hauteur du prix de cession. Sans séquestre, l’acquéreur s’expose donc au risque de devoir verser une deuxième fois le montant du prix de cession, sans garantie de remboursement par le vendeur."
    },
    {
      title: "En quoi consiste le séquestre de fonds de commerce lors d’une cession de fonds&nbsp;?",
      answer: "Le séquestre désigne le fait de confier à une tierce personne (généralement le juriste rédacteur de l’acte) le montant de la vente d’un fonds de commerce, en prévision d’éventuels litiges. Cette réserve est une sécurité qui permet aux différents créanciers du cédant de réclamer le montant de leur créance, si celle-ci n’a pas été réglée avant la cession. Ainsi, le poids financier des dettes du vendeur n’impacte pas le repreneur du fonds."
    }
  ]
},
"/conseils-pros/compte-courant-associe": {
  title: "Définition & fonctionnement du compte courant d’associé",
  description: "Découvrez le fonctionnement, la rémunération, la fiscalité et les conditions de cession d’un compte courant d’associé.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/compte-courant-associe",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Définition & fonctionnement du compte courant d’associé",
      item: "/conseils-pros/compte-courant-associe"
    }
  ],
  faq: [
    {
      title: "Comment récupérer l'argent d'un compte courant d'associé&nbsp;?",
      answer: "Pour récupérer l'argent d'un compte courant d'associé, il faut d'abord vérifier les termes du contrat d'association ou les statuts de l'entreprise pour s'assurer que le retrait est permis. Ensuite, il peut être nécessaire d'obtenir l'approbation de l'assemblée générale, surtout si le montant est significatif. Il est important de préparer un accord écrit pour documenter le retrait. Enfin, assurez-vous que le retrait respecte les lois fiscales et comptables en vigueur."
    },
    {
      title: "Quel est l'inconvénient principal de l'apport en compte courant d'associé&nbsp;?",
      answer: "L'inconvénient principal de l'apport en compte courant d'associé est le risque de perte de ces fonds en cas de difficultés financières ou de faillite de l'entreprise, car les créances des associés sont souvent remboursées après celles des autres créanciers."
    },
    {
      title: "Quel est le principe d'un compte courant d'associé&nbsp;?",
      answer: "Un compte courant d’associé peut se définir comme un prêt consenti par un associé à son entreprise. Inscrit au passif du bilan de la société, il peut s’agir d’un prêt direct ou d’une non-réclamation de sommes dues. La somme ainsi mise à disposition peut être rémunérée grâce à un taux d’intérêt fixe, spécifié dans les statuts ou dans une convention créée spécifiquement pour ce cas de figure."
    }
  ]
},
"/conseils-pros/differences-droit-au-bail-pas-de-porte-droit-entree": {
  title: "Quelles différences entre droit au bail, droit d’entrée et pas-de-porte ?",
  description: "Découvrez les différences entre le pas-de-porte, le droit d’entrée et le droit au bail lors de la reprise d’un local commercial.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/differences-droit-au-bail-pas-de-porte-droit-entree",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Quelles différences entre droit au bail, droit d’entrée et pas-de-porte ?",
      item: "/conseils-pros/differences-droit-au-bail-pas-de-porte-droit-entree"
    }
  ],
  faq: [
    {
      title: "Pourquoi payer le droit d’entrée ou pas-de-porte dans un bail commercial&nbsp;?",
      answer: "Pour le bailleur, le paiement d’un pas-de-porte offre une certaine sécurité. Il lui permet de se protéger des hausses de loyer inférieures à la valeur locative réelle des locaux et de la dépréciation de la valeur du bien. Pour le locataire, le pas-de-porte étant déductible du résultat fiscal sur plusieurs années, il permet de bénéficier d’un loyer moins élevé à la fin de la période d’amortissement. À cela, s’ajoutent les autres avantages inclus dans le pas-de-porte (aménagements particuliers, avantages commerciaux, indemnité d’éviction…)."
    },
    {
      title: "Quelle est la différence entre un droit d’entrée et un droit au bail&nbsp;?",
      answer: "Le droit au bail et le droit d’entrée sont tous deux une somme d’argent versée par le futur locataire pour jouir d’un local commercial. Ils diffèrent sur 2 points : qui perçoit la somme et quelle fiscalité. Pour le droit d’entrée, le montant est versé par le locataire au bailleur. Selon sa valeur juridique, il est soumis à TVA si c’est un supplément de loyer et non-imposable si c’est une indemnité. Le droit au bail, lui, est payé par le locataire entrant au locataire sortant (le cédant). Le cédant doit le déclarer au titre des BIC. Et le repreneur doit le porter à l’actif de son bilan."
    },
    {
      title: "Qu’est-ce qu’un pas-de-porte ou droit d’entrée&nbsp;?",
      answer: "Lors de la conclusion d’un bail commercial, le bailleur peut demander une somme d’argent au locataire, en plus du loyer et de la caution. Il s’agit du droit d’entrée, aussi appelé pas-de-porte. Ce n’est pas obligatoire. Le bailleur peut ne pas le demander et le locataire peut le refuser ou le négocier. Les parties doivent en définir la nature (supplément au loyer et/ou indemnité),\n le montant et les conditions de paiement (en une ou plusieurs fois)."
    }
  ]
},
"/conseils-pros/cession-entreprise-contrat-travail": {
  title: "La reprise des contrats de travail lors d’une cession d’entreprise",
  description: "Découvrez comment gérer la transmission des contrats de travail des salariés lors d’une cession d’entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/cession-entreprise-contrat-travail",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "La reprise des contrats de travail lors d’une cession d’entreprise",
      item: "/conseils-pros/cession-entreprise-contrat-travail"
    }
  ],
  faq: [
    {
      title: "Comment s’effectue le transfert des contrats lors d’une transmission d’activité&nbsp;?",
      answer: "Plusieurs types de transfert des contrats de travail existent. Ils dépendent directement du type de cession. Si elle est totale, le transfert est automatique et de plein droit, sans démarche particulière. Si seule une partie de la société est cédée, le transfert est partiel (le contrat devient divisible, sous conditions). Enfin, à cela s’ajoutent deux particularités : le transfert partiel si les conditions pour un transfert automatique ne sont pas remplies, ainsi que le transfert des salariés protégés."
    },
    {
      title: "Qu’advient-il des contrats de travail salariés lors d’une cession d’entreprise&nbsp;?",
      answer: "Lors d’une cession, les contrats salariés sont transférés de l’ancien au nouvel employeur, dans les mêmes conditions. Le salarié conserve son ancienneté, son salaire, sa qualification, ainsi que les autres avantages acquis au cours de sa carrière (congés payés, voiture de fonction…). Si le nouvel employeur souhaite apporter des modifications au contrat, cela doit se faire avec l’accord du salarié. Ce dernier ne peut pas non plus être soumis à une nouvelle période d’essai ou à la signature d’un nouveau contrat."
    },
    {
      title: "Qu’est-ce qu’une cession d’entreprise&nbsp;?",
      answer: "La cession d’une entreprise désigne la transmission de son exploitation par un acte (vente, donation…) à un repreneur. Elle peut être totale lorsque l’ensemble des actifs sont cédés. Ou partielle si elle ne porte que sur une partie de la société (titres ou fonds de commerce). Il existe différentes manières de céder sa société : à titre onéreux (location-gérance, cession progressive, fusion-absorption…) ou à titre gratuit (succession, donation, reprise par les salariés…)"
    }
  ]
},
"/conseils-pros/comprendre-etablir-compte-resultat": {
  title: "Comment lire et établir le compte de résultat",
  description: "Découvrez le fonctionnement du compte de résultat et son utilité pour analyser la santé financière de votre entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/comprendre-etablir-compte-resultat",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment lire et établir le compte de résultat",
      item: "/conseils-pros/comprendre-etablir-compte-resultat"
    }
  ],
  faq: [
    {
      title: "De quoi est composé le compte de résultat&nbsp;?",
      answer: "Le compte de résultat est organisé en trois parties : le résultat d’exploitation, le résultat financier et le résultat exceptionnel. Le résultat d’exploitation l’activité courante de l’entreprise. Le résultat financier reflète la stratégie appliquée au sein de l’entreprise en matière de financement. Enfin, le résultat exceptionnel fait référence à toutes les opérations hors du commun ayant eu lieu au cours de l’exercice comptable (dons, subventions…). De ces trois résultats découle le résultat net comptable, qui mesure les ressources nettes de l’entreprise après imposition sur les bénéfices."
    },
    {
      title: "Quel est le rôle d’un compte de résultat&nbsp;?",
      answer: "Le rôle d’un compte de résultat est double. Pour le chef d’entreprise, il permet de savoir comment les richesses de son entreprise sont utilisées (rémunérations, achats, investissements, impôts…). Cela lui permet d’ajuster sa stratégie commerciale, managériale et financière. En cas de cession d’entreprise, l’analyse du compte de résultat permet au repreneur d’estimer la rentabilité et la valeur de l’affaire."
    },
    {
      title: "Qu’est-ce qu’un compte de résultat&nbsp;?",
      answer: "Le compte de résultat est un document comptable qui présente l’ensemble des charges (dépenses) et des produits (recettes) d’une entreprise au cours d’un exercice comptable. Il fait partie des comptes annuels de l’entreprise, au même titre que le bilan actif/passif, le tableau des SIG (soldes intermédiaires de gestion) et la liasse fiscale."
    }
  ]
},
"/conseils-pros/role-expert-comptable-entreprise": {
  title: "Expert-comptable en entreprise : rôle, missions et obligations",
  description: "Découvrez les nombreux aspects que revêt le métier d’expert-comptable, qui sont indispensables à la gestion et conformité des comptes de l’entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/role-expert-comptable-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Expert-comptable en entreprise : rôle, missions et obligations",
      item: "/conseils-pros/role-expert-comptable-entreprise"
    }
  ],
  faq: [
    {
      title: "Quels sont les trois rôles de la comptabilité&nbsp;?",
      answer: "Les 3 rôles de la comptabilité : tenue totale ou partielle de la comptabilité, réalisation, examen et attestation de la régularité des comptes annuels à la clôture de l’exercice comptable et enfin, la réalisation d’un audit contractuel. Si l’expert-comptable assume l’une de ses trois missions, il peut être amené à remplir d’autres missions secondaires, ayant trait à l’établissement des contrats de travail, gestion des déclarations fiscales et formalités juridiques."
    },
    {
      title: "Quel est le rôle de l'expert-comptable&nbsp;?",
      answer: "Le rôle de l’expert-comptable est de tenir et d’attester de la cohérence et de la conformité des comptes de l’entreprise par laquelle il a été missionné. Pour remplir ce rôle, plusieurs missions peuvent lui être confiées, en fonction des besoins et du fonctionnement de la société. Cela peut aller de la tenue de la comptabilité à l’examen des comptes annuels, en passant par le développement d’une stratégie d’optimisation de la rentabilité de l’entreprise."
    },
    {
      title: "Combien gagne un expert-comptable&nbsp;?",
      answer: "En général, le salaire d'un expert-comptable dépend de plusieurs facteurs, tels que son expérience, sa localisation géographique, le type d'entreprise pour laquelle il travaille et sa spécialisation. En moyenne, un expert-comptable débutant peut gagner entre 35 000 et 45 000 euros par an, tandis qu'un professionnel expérimenté peut gagner bien plus, souvent dépassant les 70 000 euros par an. Ces chiffres peuvent varier considérablement en fonction du pays et de la région."
    }
  ]
},
"/conseils-pros/soldes-intermediaires-gestion": {
  title: "Comment interpréter le tableau des soldes intermédiaires de gestion",
  description: "Découvrez comment utiliser les indicateurs des soldes intermédiaires de gestion (SIG) pour analyser et optimiser la rentabilité d’une entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/soldes-intermediaires-gestion",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment interpréter le tableau des soldes intermédiaires de gestion",
      item: "/conseils-pros/soldes-intermediaires-gestion"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce que le tableau des soldes intermédiaires de gestion&nbsp;?",
      answer: "Le tableau des soldes intermédiaires de gestion (SIG) regroupe et résume l’ensemble des charges et produits d’une entreprise, en les rassemblant en familles d’indicateurs financiers. Les différents soldes intermédiaires de gestion permettent une meilleure lisibilité du compte de résultat. Chacun de ces indicateurs permet d’analyser la formation du résultat, témoin des performances et de la rentabilité d’une entreprise à la fin d’un exercice comptable."
    },
    {
      title: "Pourquoi calculer les soldes intermédiaires de gestion d’une entreprise&nbsp;?",
      answer: "En calculant ses soldes intermédiaires de gestion, le dirigeant d’une entreprise peut identifier les sources de gain ou de perte de rentabilité. Ils permettent, entre autres, d’évaluer la formation du résultat net, de mesurer la répartition des richesses créées, d’optimiser les secteurs de l’entreprise qui sont porteurs, d’analyser les variations de résultats aux exercices précédents… Indicateurs de rentabilité, les SIG permettent de voir dans quelle mesure le résultat de l’entreprise est dû à son activité ou à des produits autres (financiers ou exceptionnels)."
    },
    {
      title: "L’analyse des soldes intermédiaires de gestion se limite-t-elle à l’entreprise-même&nbsp;?",
      answer: "Si les soldes intermédiaires de gestion sont des indicateurs fiables des sources de rentabilité d’une entreprise, leur rôle ne se limite pas à une interprétation interne. Intégrés aux tableaux financiers prévisionnels d’un business plan, ils permettent d’appuyer les demandes de prêts ou les recherches d’investisseurs. Lors d’une stratégie d’évolution, ils offrent des données comparatives entre les sociétés d’un secteur commun, de la concurrence ou de l’évolution du marché."
    }
  ]
},
"/conseils-pros/ebe-excedent-brut-exploitation": {
  title: "EBE : Ce que votre Excédent Brut d’Exploitation dit de votre business",
  description: "L’EBE (Excédent Brut d’Exploitation) est un indicateur clé pour évaluer la rentabilité d’une entreprise. Découvrez comment l’analyser et l’utiliser pour piloter votre activité.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/ebe-excedent-brut-exploitation",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "EBE : Ce que votre Excédent Brut d’Exploitation dit de votre business",
      item: "/conseils-pros/ebe-excedent-brut-exploitation"
    }
  ],
  faq: [
    {
      title: "Quelle est la différence entre l’EBE et le résultat d’exploitation&nbsp;?",
      answer: "L’Excédent Brut d’Exploitation (EBE) mesure la rentabilité brute d’une entreprise en ne prenant en compte que les recettes et dépenses directement liées à son activité. Le résultat d’exploitation, en revanche, évalue la rentabilité globale en intégrant toutes les charges, y compris les amortissements, provisions, dépenses exceptionnelles et investissements. Il se calcule ainsi : Résultat d’exploitation = Produits d’exploitation – Charges d’exploitation. En analysant le cycle d’exploitation, il permet de déterminer si le modèle économique est viable et offre une vision plus complète des performances de l’entreprise, utile pour comparer sa position sur le marché et face à la concurrence."
    },
    {
      title: "Quelle est la différence entre l’EBE simple et l’EBE retraité&nbsp;?",
      answer: "L’Excédent Brut d’Exploitation (EBE) mesure les richesses générées par une entreprise et sa capacité à produire de la trésorerie. Cependant, il ne prend pas en compte l’impact des choix de gestion sur la rentabilité. L’EBE retraité corrige cette limite en ajustant certaines charges, comme la rémunération des dirigeants, les compléments de rémunération, certaines dépenses exceptionnelles ou les remontées sur holding. En supprimant ces éléments, il offre une vision plus objective de la rentabilité réelle de l’entreprise, sans être influencé par des coûts qui pourraient être optimisés sans affecter son activité."
    },
    {
      title: "Quelle est la différence entre l'EBE et le bénéfice net&nbsp;?",
      answer: "L’Excédent Brut d’Exploitation (EBE) mesure la rentabilité opérationnelle d’une entreprise avant prise en compte des amortissements, charges financières et impôts. Il reflète sa capacité à générer de la trésorerie. Le bénéfice net, quant à lui, est le résultat final après déduction de toutes les charges, y compris les frais financiers et fiscaux. Il représente le gain réel pouvant être distribué ou réinvesti. L’EBE évalue la performance brute, tandis que le bénéfice net donne une vision globale de la rentabilité."
    }
  ]
},
"/conseils-pros/bilan-comptable-analyse": {
  title: "Savoir lire, comprendre et interpréter le bilan comptable d’une entreprise",
  description: "Découvrez comment lire et analyser le bilan comptable d’une entreprise, afin d’optimiser sa gestion et sa rentabilité via les indicateurs financiers.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/bilan-comptable-analyse",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Savoir lire, comprendre et interpréter le bilan comptable d’une entreprise",
      item: "/conseils-pros/bilan-comptable-analyse"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce qu’un bilan comptable&nbsp;?",
      answer: "Le bilan comptable d’une entreprise est un document financier qui fait état de sa situation patrimoniale, à un instant T. Il fait partie des comptes annuels, au même titre que le tableau des soldes intermédiaires de gestion, la liasse fiscale et le compte de résultat. Il présente en deux colonnes l’actif (gauche) et le passif (droite) d’une entreprise. L’actif reprend tout ce que possède l’entreprise (immobilisations, stocks, trésorerie…) et le passif rassemble toutes les ressources dont elle dispose et qui appartiennent à des tiers (dettes bancaires, dettes fiscales, dettes fournisseurs…). Établit à la fin d’un exercice comptable, il doit nécessairement être équilibré (résultat du passif égal à celui de l’actif)."
    },
    {
      title: "Quel est le but du bilan comptable pour l’entreprise&nbsp;?",
      answer: "Le bilan comptable permet de faire état de la santé financière de l’entreprise. À partir des données qui le composent, il est possible de calculer plusieurs ratios et indicateurs financiers qui témoignent de l’impact de la politique de gestion adoptée par les dirigeants. Ces derniers mettent notamment en lumière le niveau de rentabilité de l’entreprise, les richesses dont elle dispose immédiatement, ses besoins en renouvellement de matériel (taux d’usure),\n son taux d’endettement (auprès d’établissements bancaires),\n ou sa capacité à payer ses dettes en s’appuyant sur sa production (taux de solvabilité)."
    },
    {
      title: "Comment savoir si un bilan comptable est bon ou pas&nbsp;?",
      answer: "Pour évaluer si un bilan comptable est bon ou pas, il faut examiner plusieurs éléments clés. Regardez le rapport entre les actifs et les passifs pour comprendre la situation financière de l'entreprise ; un bon bilan présente généralement des actifs supérieurs aux passifs. Évaluez également la liquidité de l'entreprise (capacité à couvrir ses dettes à court terme) et sa solvabilité (capacité à long terme). La présence de fonds propres solides et d'une bonne marge bénéficiaire est également un signe positif. Enfin, comparez ces données avec les années précédentes et avec les normes du secteur pour avoir une vision plus complète."
    }
  ]
},
"/conseils-pros/BFR-besoin-fonds-roulement": {
  title: "Optimiser et évaluer votre entreprise avec le BFR",
  description: "Tout savoir sur le BFR : définition, calcul, impact sur la trésorerie et stratégies pour optimiser la gestion financière de votre entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/BFR-besoin-fonds-roulement",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Optimiser et évaluer votre entreprise avec le BFR",
      item: "/conseils-pros/BFR-besoin-fonds-roulement"
    }
  ],
  faq: [
    {
      title: "C'est quoi un bon BFR&nbsp;?",
      answer: "Un bon BFR dépend de l’activité de l’entreprise. Idéalement, il doit être faible ou négatif  pour limiter le besoin de financement et préserver la trésorerie. Un BFR trop élevé peut  poser problème si l’entreprise doit avancer trop de fonds pour financer son stock ou accorde des délais de paiement trop longs. L’enjeu est donc d’optimiser la gestion des encaissements, des paiements et des stocks pour assurer un bon équilibre financier."
    },
    {
      title: "Pourquoi le BFR doit-il être négatif&nbsp;?",
      answer: "Un BFR négatif signifie que l'entreprise génère de la trésorerie grâce à son cycle  d'exploitation. Cela se produit lorsque les délais de paiement fournisseurs sont plus  longs que ceux des clients, permettant ainsi d'encaisser avant de devoir payer. C'est un  avantage car il réduit le besoin de financement et améliore la trésorerie."
    },
    {
      title: "BFR et BFR normatif, de quoi s'agit-il&nbsp;?",
      answer: "Le BFR repose sur trois éléments clés : les stocks, les créances et les dettes  fournisseurs. Son calcul normatif (ou BFR en jours de CA) permet d’évaluer les  ressources nécessaires au financement des futurs cycles d’exploitation."
    }
  ]
},
"/conseils-pros/obligations-comptables-entreprises": {
  title: "Quelle sont les différentes obligations comptables d’une entreprise ?",
  description: "Découvrez les obligations comptables d’une entreprise, ce qu’elles impliquent et comment les respecter selon le régime fiscal et statut juridique de la société.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/obligations-comptables-entreprises",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Quelle sont les différentes obligations comptables d’une entreprise ?",
      item: "/conseils-pros/obligations-comptables-entreprises"
    }
  ],
  faq: [
    {
      title: "Une entreprise doit-elle faire appel à un expert-comptable pour ses obligations comptables&nbsp;?",
      answer: "La sous-traitance de la comptabilité par un cabinet d’expert-comptable n’est pas obligatoire. Elle se révèle cependant être un choix judicieux, afin d’éviter les erreurs lors des enregistrements comptables et la réalisation des comptes annuels, bénéficier de conseils avisés, profiter de services de gestion annexes (bulletin de paie, contrats de travail…),\n etc. En revanche, ce qui est obligatoire, c’est la vérification des comptes des entreprises par actions (SA, SAS, notamment) par un commissaire aux comptes (CAC),\n via la réalisation d’un audit légal."
    },
    {
      title: "La tenue d’une comptabilité est-elle obligatoire pour toutes les entreprises&nbsp;?",
      answer: "Oui, la tenue d’une comptabilité générale régulière, sincère et fidèle est obligatoire pour toutes les sociétés commerciales et industrielles, conformément aux articles L 123-12 à L 123-28 du Code du commerce. Cela permet d’établir les résultats de l’entreprise, les assiettes d’imposition, de mettre en avant les sources de richesses ou de pertes, la rentabilité, les possibilités d’évolution, etc. Dans cette optique, les obligations comptables varient, afin de s’adapter à la forme sociale (entreprises ou associations) et au régime d’imposition de chaque structure."
    },
    {
      title: "Comment définir les obligations comptables&nbsp;?",
      answer: "Les obligations comptables d’une entreprise représentent l’ensemble des règles qu’elles doivent respecter pour tenir leur comptabilité et réaliser leurs comptes annuels. Ces obligations sont fixées par les articles L110-1 à L960-4 du Code du commerce. Toutes les entreprises ont des obligations comptables. Même si ces dernières changent en fonction de la fiscalité et du type d’entreprise, elles consistent en l’enregistrement des pièces comptables et des mouvements affectant le patrimoine, l’édition des factures, le contrôle par inventaire des stocks et immobilisations détenues, la réalisation et le dépôt des comptes annuels à la date de clôture de l’exercice comptable (bilan, compte de résultat, liasse fiscale)."
    }
  ]
},
"/conseils-pros/amortissement-fonds-commerce": {
  title: "Amortissement du fonds de commerce : ce qu’il faut savoir",
  description: "Découvrez les règles comptables et fiscales qui permettent aux entreprises de procéder à l’amortissement de leur fonds de commerce.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/amortissement-fonds-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Amortissement du fonds de commerce : ce qu’il faut savoir",
      item: "/conseils-pros/amortissement-fonds-commerce"
    }
  ],
  faq: [
    {
      title: "Quelles sont les limites de la loi sur l’amortissement d’un fonds de commerce&nbsp;?",
      answer: "La loi de finances 2022 comporte surtout des avantages pour les entreprises qui acquièrent un fonds de commerce pour la première fois entre le 1er janvier 2022 et le 31 décembre 2025. Elles profitent ainsi directement d’une réduction d’impôt suite à l’amortissement de coût d’acquisition du fonds. En revanche, pour les entreprises qui possèdent un fonds acquis avant 2022 non amortis, il est plus difficile d’en tirer des avantages... En effet, celles-ci doivent appliquer l’amortissement de leur fonds, à la date d’adoption de la loi de finances, sans qu’une déduction fiscale ne soit possible. Le résultat comptable s’en trouve donc diminué, sans que l’entreprise puisse bénéficier de l’économie d’impôt réalisée."
    },
    {
      title: "Comment la loi de finances 2022 permet l’amortissement d’un fonds de commerce&nbsp;?",
      answer: "La loi de finances 2022 permet de déduire fiscalement les amortissements linéaires, dégressifs, variables ou exceptionnels des fonds de commerce. Jusqu’à présent, les amortissements et/ou dépréciations de valeur n’étaient pas repris fiscalement. La loi de finances rétablit temporairement cela, en constituant un avantage fiscal qui vise à réduire le coût total d’acquisition d’un fonds de commerce. Pour y parvenir, diverses dérogations sont mises en place afin de permettre une réduction d’impôt, suite à la déduction fiscale de l’amortissement du fonds de commerce. Véritable levier de création de valeur, cette mesure particulière permet de faciliter le financement d’une reprise de fonds de commerce."
    },
    {
      title: "Quelle est la différence entre un fonds de commerce et un fonds commercial&nbsp;?",
      answer: "Le fonds de commerce est une notion juridique, qui est liée à une activité commerciale. Il est composé de l’ensemble des biens corporels et incorporels nécessaires à l’entreprise pour assumer son cycle d’exploitation. Le fonds commercial est une notion de droit comptable uniquement. C’est un actif incorporel comptabilisé dans l’actif du bilan comptable de l’entreprise. Le fonds commercial fait partie du fonds de commerce."
    }
  ]
},
"/conseils-pros/tva-taxe-valeur-ajoutee-entreprise": {
  title: "Fonctionnement de la TVA pour les entreprises : le guide complet",
  description: "Comprendre l’impact de la TVA d’entreprise : quels taux appliquer, quel régime choisir, comment la reverser ou encore comment la gérer lors d’une cession.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/tva-taxe-valeur-ajoutee-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Fonctionnement de la TVA pour les entreprises : le guide complet",
      item: "/conseils-pros/tva-taxe-valeur-ajoutee-entreprise"
    }
  ],
  faq: [
    {
      title: "Quels sont les inconvénients de la TVA pour une entreprise&nbsp;?",
      answer: "L’inscription à la TVA présente des inconvénients, mais ils sont communs à toutes les entreprises. Ils concernent tout d’abord les ressources que doit déployer l’entreprise afin de garantir le maintien de conformité de la TVA (création de départements financiers, externalisation de la comptabilité…). Cela génère du travail, voire des coûts en plus. Ensuite, avec la TVA, l’entreprise s’expose à plus de risques de non-conformité. Son application nécessite donc une très bonne connaissance des catégories de ventes et de dépenses de l’entreprise, et une vigilance constante. Enfin, le passage à la TVA entraîne une augmentation des tarifs (jusqu’à 20 %). L’impact est limité pour les entreprises clientes, elles-mêmes redevables, qui peuvent la récupérer. Il est en revanche plus lourd pour les consommateurs, qui en assument le coût final."
    },
    {
      title: "Quels sont les avantages de la TVA pour une entreprise&nbsp;?",
      answer: "Que les institutions autorisent le passage volontaire à la TVA n’est pas anodin… C’est bien que la TVA présente des avantages non négligeables pour les entreprises. Parmi eux, le remboursement de la TVA. De fait, plus tôt une entreprise est enregistrée au régime de TVA, plus tôt elle peut la récupérer (TVA déductible contre TVA collectée). Elle est également un signe de développement commercial et donc de crédibilité. Les grosses entreprises sont plus enclines à traiter avec des entreprises redevables de la TVA, rassurées par leur influence et le fait qu’elles peuvent ensuite elles-mêmes la récupérer. Enfin, la TVA permet de faciliter les échanges commerciaux avec l’étranger (Union Européenne). Les transactions ne se font pas en perte, grâce à la TVA intercommunautaire."
    },
    {
      title: "Qu’est-ce-que la TVA (taxe sur la valeur ajoutée)&nbsp;?",
      answer: "La TVA (ou taxe sur la valeur ajoutée) est un impôt indirect sur la consommation, payé par le consommateur et collecté par les entreprises. Elle représente la différence entre le prix hors taxe (HT) et le prix toutes taxes comprises (TTC) des ventes et prestations de services. Afin d’harmoniser la gestion des échanges économiques, toute entreprise exerçant en France et dans l’Union Européenne est soumise à la TVA. Les règles d’application dépendent directement de son régime fiscal, de sa taille et des activités exercées."
    }
  ]
},
"/conseils-pros/guide-fiscalite-entreprise": {
  title: "Tout savoir sur la fiscalité des entreprises",
  description: "Découvrez comment s’articule la fiscalité des entreprises : de l’imposition sur les bénéfices à la TVA, en passant par la CET, les dividendes, plus-values sur cession et les différentes taxes.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/guide-fiscalite-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Tout savoir sur la fiscalité des entreprises",
      item: "/conseils-pros/guide-fiscalite-entreprise"
    }
  ],
  faq: [
    {
      title: "La fiscalité d’entreprise peut-elle être un frein à la création d’entreprises&nbsp;?",
      answer: "La France a pour réputation de taxer plus lourdement ses entreprises, lorsque son niveau de taxation est comparé à la moyenne européenne. Depuis plusieurs années cependant, le gouvernement met en place différentes dispositions afin d’adapter et de simplifier les obligations fiscales des entreprises, en fonction de leur statut, de leur taille… Cette disposition de l’État à alléger la fiscalité concerne plus particulièrement les plus petites entreprises, afin d’encourager l’entrepreneuriat et l’embauche. Mais elle s’adresse également à tous les dirigeants, le but étant de leur permettre de se consacrer pleinement à leur projet."
    },
    {
      title: "Comment fonctionne la fiscalité d’entreprise&nbsp;?",
      answer: "Dès sa création, une entreprise est soumise à divers impôts et taxes qui lui sont assignés de plein droit pour certains, par choix pour d’autres. Le procédé dépend de critères et seuils de références rapportés aux caractéristiques de l’entreprise. Pour imposer une entreprise à tel ou tel impôt, l’administration fiscale se base sur son régime fiscal, son statut social, son activité et son chiffre d’affaires. Entrent également en ligne de compte la présence ou non de salariés, d’associés, de possession de titres ou de biens immobiliers… En résumé, tout ce qui caractérise et permet l’exploitation de l’entreprise est potentiellement soumis à imposition ou exonération."
    },
    {
      title: "De quoi se compose la fiscalité d’entreprise&nbsp;?",
      answer: "La fiscalité d’entreprise se compose de trois grandes familles : la fiscalité directe, la fiscalité de la consommation et la fiscalité locale. Chacune d’elle comporte diverses taxes et impôts dont sont redevables les entreprises comme la taxe sur la valeur ajoutée (TVA),\n l’impôt sur le revenu (IR) et l’impôt sur les sociétés (IS),\n ou encore la contribution économique territoriale (CET). À ces impôts « principaux », s’ajoutent d’autres taxes et impôts applicables aux salaires, aux dividendes, ou encore aux plus-values professionnelles."
    }
  ]
},
"/conseils-pros/guide-matrice-BCG": {
  title: "Comment utiliser la matrice stratégique BCG ? Nos conseils",
  description: "Découvrez la matrice BCG et apprenez à évaluer le potentiel d’une activité tout en optimisant la gestion de votre catalogue de produits et services.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/guide-matrice-BCG",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment utiliser la matrice stratégique BCG ? Nos conseils",
      item: "/conseils-pros/guide-matrice-BCG"
    }
  ],
  faq: [
    {
      title: "Comment expliquer la matrice BCG&nbsp;?",
      answer: "La matrice BCG tient son nom de l’entreprise de son créateur Bruce Henderson, la Boston Consulting Group. C’est un outil de stratégie marketing qui permet d’optimiser le portefeuille de produits et/ou d’activités d’une entreprise. Représentée sous la forme d’un graphique à deux axes (taux de croissance et part de marché relative),\n la matrice BCG mesure l’attractivité du marché et la position concurrentielle de chaque produit et/ou activité sur laquelle l’entreprise souhaite se positionner. Pour y parvenir, elle classe chacun des éléments du portefeuille de vente (ou DAS, domaines d’activité stratégiques) dans 4 catégories : star, dilemme, vache à lait et poids mort. Chacune ayant des particularités et limites que l’entreprise doit étudier pour prendre les décisions marketing qui s’imposent."
    },
    {
      title: "Comment faire une matrice BCG pour son entreprise&nbsp;?",
      answer: "Pour construire sa matrice BCG, une entreprise doit tout d’abord bien connaître son marché ciblé, ses produits et ceux de la concurrence. Ensuite, l’élaboration de la matrice se passe en 3 étapes : l’évaluation du marché à l’aide de 2 critères (la part de marché relative et le taux de croissance du marché),\n le placement des données sur le graphique, l’analyse de la classification des offres sous les 4 catégories de la matrice BCG : dilemme, star, vache à lait et poids mort. En fonction de la catégorisation de ses offres, l’entreprise doit ensuite adapter sa stratégie marketing et prendre les décisions adaptées à ses objectifs."
    },
    {
      title: "Quelles sont les limites de la matrice BCG&nbsp;?",
      answer: "La matrice BCG fournit une analyse en ne se basant que sur deux dimensions : la part de marché relative et le taux de croissance du marché. Or, ce ne sont pas les seuls indicateurs de rentabilité ou de succès d’un produit. En basant son analyse des produits sur leur simple capacité à s’autofinancer, elle ne tient pas compte des autres sources de financement dont dispose l’entreprise, comme l’emprunt, les investissements… Ensuite, elle ne met pas en avant les corrélations entre produits à l’intérieur d’une même gamme, où des produits rentables peuvent « pousser » ceux qui le sont moins."
    }
  ]
},
"/conseils-pros/benchmark-concurrentiel": {
  title: "Sachez analyser votre concurrence grâce au benchmark concurrentiel",
  description: "Découvrez comment, grâce au benchmark concurrentiel, analyser les pratiques de vos concurrents afin d’améliorer la compétitivité de votre entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/benchmark-concurrentiel",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Sachez analyser votre concurrence grâce au benchmark concurrentiel",
      item: "/conseils-pros/benchmark-concurrentiel"
    }
  ],
  faq: [
    {
      title: "Quelles sont les limites du benchmarking de la concurrence&nbsp;?",
      answer: "Si le benchmark concurrentiel permet aux entreprises de toutes tailles de trouver leur place sur le marché, il présente des limites qui doivent être prises en compte avant de se plonger dans l’analyse. En s’inspirant des méthodes de fonctionnement de la concurrence, le benchmark concurrentiel ouvre la porte au plagiat. Il expose alors l’entreprise au risque de copier une méthode qui ne serait pas adaptée à son mode de gestion. C’est également une opération chronophage qui mobilise beaucoup de ressources humaines (une équipe doit y être dédiée) et financières. Enfin, son succès dépend de l’implication et de la coordination entre les équipes dirigeantes et les différents services collaborateurs. Le benchmark concurrentiel n’est donc pas une fin en soi, mais constitue plutôt une première étape sur le chemin du changement."
    },
    {
      title: "Pourquoi une entreprise a tout intérêt à réaliser un benchmark concurrentiel&nbsp;?",
      answer: "Il est dans l’intérêt d’une entreprise de réaliser un benchmark de la concurrence si celle-ci ne veut pas se retrouver bloquée dans une politique de gestion obsolète, qui ne satisfait ni ses collaborateurs, ni la clientèle visée. En réalisant un benchmark de la concurrence, elle peut ainsi élaborer des business model performants, améliorer ses stratégies marketing et commerciale, optimiser sa relation client en anticipant leur besoin, profiter d’une connaissance de la concurrence, fixer des objectifs précis et atteignables… Lorsque l’entreprise s’informe sur les meilleures pratiques actuelles et innove dans ce sens, elle devient la plus compétitive dans le marché convoité."
    },
    {
      title: "Qu’est-ce que le benchmark concurrentiel&nbsp;?",
      answer: "Le benchmark concurrentiel, ou benchmarking, est une technique marketing visant à comparer son entreprise à ses concurrents directs ou indirects. Cette étude permet d’évaluer sa place occupée sur le marché en analysant les différents modes de gestion, d’organisation, de communication de la concurrence, afin de s’en inspirer pour les appliquer en interne. Il ne s’agit pas de plagier, mais plutôt de mettre en évidence les dysfonctionnements stratégiques internes, afin d’y remédier par diverses actions permettant d’améliorer la popularité, compétitivité et popularité de son entreprise."
    }
  ]
},
"/conseils-pros/comment-definir-business-model": {
  title: "Comment définir son business model : Étapes & conseils",
  description: "Découvrez comment créer un business model efficace pour générer des revenus et vous démarquer sur un marché concurrentiel.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/comment-definir-business-model",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment définir son business model : Étapes & conseils",
      item: "/conseils-pros/comment-definir-business-model"
    }
  ],
  faq: [
    {
      title: "Qu'est-ce qu'un modèle économique (business model)&nbsp;?",
      answer: "Le business model est le modèle économique d'une entreprise, représentant son mécanisme de création de valeur et la manière dont elle génère des revenus. Il détaille les moyens mis en œuvre pour transformer une idée en une entreprise viable et rentable. Élément central du business plan, le business model valide l'intérêt économique du projet entrepreneurial. Grâce à une analyse du marché, de la clientèle cible, ainsi que des ressources et moyens financiers nécessaires, il permet de s'assurer de l'équilibre entre les opportunités et les contraintes du projet."
    },
    {
      title: "Quelle est la différence entre un business model et un business plan&nbsp;?",
      answer: "Le but du business model est de définir ce que l'entreprise vend, à qui, et comment. Il offre une vision globale de la stratégie de l'entreprise en expliquant son mécanisme de génération de revenus. En ce sens, il constitue un élément central du business plan, qui présente le projet de création (ou de reprise) d'entreprise dans son intégralité. Le business plan inclut le business model validé, ainsi qu'une présentation écrite de l'entreprise, les résultats de l'étude de marché, le prévisionnel financier et le statut juridique de l'entreprise."
    },
    {
      title: "Quels sont les 4 composants d'un business model&nbsp;?",
      answer: "Un business model se compose de quatre composants principaux : la proposition de valeur, qui décrit l'offre unique de l'entreprise pour ses clients ; l'infrastructure, qui englobe les ressources, partenaires et technologies nécessaires ; les clients, qui incluent la segmentation, la relation client et les canaux de distribution ; et enfin, la finance, qui couvre les flux de revenus et la structure des coûts."
    }
  ]
},
"/conseils-pros/fonctionnement-pacte-associes": {
  title: "Pacte d’associés : mode d’emploi",
  description: "Tout savoir sur le pacte d’associés d’une entreprise, de l’intérêt derrière sa réalisation aux différentes clauses qu’il ne faut pas négliger d’y inclure.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/fonctionnement-pacte-associes",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Pacte d’associés : mode d’emploi",
      item: "/conseils-pros/fonctionnement-pacte-associes"
    }
  ],
  faq: [
    {
      title: "Quelles sont les limites du pacte d’associés&nbsp;?",
      answer: "La réalisation d’un pacte d’associés demande une grande vigilance de la part de son rédacteur et de ses signataires. Toutes les parties doivent s’assurer de la logique des clauses, afin qu’il n’y ait pas de contradictions, ni entre elles, ni avec celles des statuts. Il est également important de veiller à préserver les intérêts des signataires et de l’entreprise. Aucune partie ne doit être lésée ou victime d’une clause piégeuse ou abusive. Tous les cas de figure doivent donc être envisagés et étudiés avec soin, afin d’éviter tout litige futur. Ce qui serait dommage, étant donné que c’est le but premier du pacte d’associés ! C’est pourquoi il est recommandé de s’entourer de personnes spécialisées dans la rédaction de ce type de document juridique, comme les avocats spécialisés en droit des affaires."
    },
    {
      title: "Quand doit-on rédiger un pacte d’associés&nbsp;?",
      answer: "La rédaction d’un pacte d’associés peut se faire à tout moment au cours de la vie d’une entreprise : à sa création, lors de sa cession ou en cas d’augmentation de son capital, à travers l’arrivée d’un nouvel associé ou investisseur. L’important étant de veiller à ce que les clauses qu’il comprend soit claires et précises et non-discriminatoires, qu’elles ne contredisent pas celles des statuts de l’entreprise et qu’elles précisent sa durée."
    },
    {
      title: "Qu’est-ce qu’un pacte d’associés&nbsp;?",
      answer: "Le pacte d’associés est un contrat entre un ou plusieurs associés d’une entreprise. Il peut être signé par tous les associés ou seulement certains d’entre eux (au minimum deux). Le pacte d’associés est un document juridique extra-statutaire qui vise à définir les engagements contractuels entre associés et de façon confidentielle, contrairement aux statuts. En fonction de l’entreprise et du partage de son capital (en parts sociales ou en actions),\n on parlera de pacte d’associés (parts sociales) ou de pacte d’actionnaires (actions). Dans les deux cas, la finalité reste la même : le pacte permet de définir les relations entre associés, les conditions de cessions des titres, la gouvernance de l’entreprise et les sanctions en cas de non-respect du pacte."
    }
  ]
},
"/conseils-pros/statut-eurl-avantages-inconvenients": {
  title: "Tout savoir sur le statut EURL (entreprise unipersonnelle à responsabilité limitée)",
  description: "Explorez les avantages et les inconvénients du statut EURL pour éclairer votre choix entrepreneurial avec notre guide rapide et concis !",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/statut-eurl-avantages-inconvenients",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Tout savoir sur le statut EURL (entreprise unipersonnelle à responsabilité limitée)",
      item: "/conseils-pros/statut-eurl-avantages-inconvenients"
    }
  ],
  faq: [
    {
      title: "Quel statut choisir&nbsp;: auto-entrepreneur, eurl ou sarl unipersonnelle&nbsp;?",
      answer: "Le choix entre auto-entrepreneur, EURL, ou SARL unipersonnelle dépend de vos objectifs et contraintes : auto-entrepreneur pour démarrer facilement avec peu de formalités et un régime fiscal avantageux mais limité en chiffre d'affaires ; EURL pour une structure juridique simple avec un seul associé, offrant une séparation des patrimoines et plus de crédibilité sans limite de chiffre d'affaires ; SARL unipersonnelle pour bénéficier des avantages de la SARL tout en étant seul, avec une gestion et des obligations comptables plus strictes. Choisissez en fonction de la taille et de la complexité de votre projet."
    },
    {
      title: "Quel statut choisir&nbsp;: auto-entrepreneur, eurl ou sarl unipersonnelle&nbsp;?",
      answer: "Le choix entre auto-entrepreneur, EURL, ou SARL unipersonnelle dépend de vos objectifs et contraintes : auto-entrepreneur pour démarrer facilement avec peu de formalités et un régime fiscal avantageux mais limité en chiffre d'affaires ; EURL pour une structure juridique simple avec un seul associé, offrant une séparation des patrimoines et plus de crédibilité sans limite de chiffre d'affaires ; SARL unipersonnelle pour bénéficier des avantages de la SARL tout en étant seul, avec une gestion et des obligations comptables plus strictes. Choisissez en fonction de la taille et de la complexité de votre projet."
    },
    {
      title: "Quel statut choisir&nbsp;: auto-entrepreneur, eurl ou sarl unipersonnelle&nbsp;?",
      answer: "Le choix entre auto-entrepreneur, EURL, ou SARL unipersonnelle dépend de vos objectifs et contraintes : auto-entrepreneur pour démarrer facilement avec peu de formalités et un régime fiscal avantageux mais limité en chiffre d'affaires ; EURL pour une structure juridique simple avec un seul associé, offrant une séparation des patrimoines et plus de crédibilité sans limite de chiffre d'affaires ; SARL unipersonnelle pour bénéficier des avantages de la SARL tout en étant seul, avec une gestion et des obligations comptables plus strictes. Choisissez en fonction de la taille et de la complexité de votre projet."
    }
  ]
},
"/conseils-pros/statut-snc-particularites-avantages": {
  title: "SNC - Société en nom collectif : ce qu’il faut savoir",
  description: "Découvrez notre guide de la société en nom collectif (SNC) : ses particularités, ses limites et les avantages à choisir ce statut pour son entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/statut-snc-particularites-avantages",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "SNC - Société en nom collectif : ce qu’il faut savoir",
      item: "/conseils-pros/statut-snc-particularites-avantages"
    }
  ],
  faq: [
    {
      title: "Quelles sont les limites du statut SNC&nbsp;?",
      answer: "Les limites du statut SNC se trouvent dans la responsabilité solidaire et indéfinie qui repose sur les associés. En cas de dettes, un créancier peut ne poursuivre qu’un seul des associés pour l’ensemble des dettes sociales de la SNC. Cette poursuite peut être nominative et ne pas tenir compte de qui est réellement fautif parmi les associés. À cela s’ajoute la responsabilité indéfinie : quels que soient le montant et la nature des apports de chacun, chaque associé est responsable sur son patrimoine personnel pour régler la dette de la société, sans limite. Enfin, la cession de parts sociales n’est possible qu’avec l’accord unanime des associés."
    },
    {
      title: "Quand choisir le statut de SNC pour son entreprise&nbsp;?",
      answer: "Choisir le statut d’une SNC pour un projet entrepreneurial se justifie dans 2 cas. Le premier concerne les exploitations de bureau de tabac, dont l’exercice est très réglementé et où la seule forme d’exploitation acceptée par la loi est celle d’EI (entreprise individuelle) ou de SNC. La deuxième concerne les créations d’entreprises familiales, qui n’ont pas pour but à croître exponentiellement ou à être cédées à un tiers. Cette forme juridique d’entreprise nécessite une forte connaissance et confiance en ses partenaires d’affaires."
    },
    {
      title: "Quelles sont les principales caractéristiques d’une société en nom collectif (SNC)&nbsp;?",
      answer: "Généralement créée par les membres d’une même famille, la SNC est une société de personnes. Sous ce statut, les associés (au minimum 2) sont responsables solidairement et indéfiniment des dettes de la société. Cela signifie qu’en cas de poursuite en paiement par un créancier, tous les associés sont concernés (qu’ils soient ou non à l’origine de la perte) et que leur patrimoine personnel n’est pas protégé. Pour sa gestion, la forme juridique d’une SNC donne, par défaut, le statut de gérant à tous les associés, sauf clause statutaire contraire. D’un point de vue fiscal, l’entreprise n’est pas imposée sur le revenu en son nom mais en celui des associés."
    }
  ]
},
"/conseils-pros/statut-sci-caracteristiques-avantages": {
  title: "Pourquoi choisir de créer son entreprise en SCI ?",
  description: "Découvrez les caractéristiques et des avantages propres au statut de SCI, afin d’optimiser la constitution et la gestion de votre patrimoine immobilier.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/statut-sci-caracteristiques-avantages",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Pourquoi choisir de créer son entreprise en SCI ?",
      item: "/conseils-pros/statut-sci-caracteristiques-avantages"
    }
  ],
  faq: [
    {
      title: "Quelles sont les limites du statut SCI&nbsp;?",
      answer: "Le statut de SCI présente quelques inconvénients, comme la responsabilité indéfinie vis-à-vis des dettes de la société, qui pèse sur les épaules des associés de la SCI. Bien qu’elle ne soit pas solidaire, cette responsabilité indéfinie engage le patrimoine personnel des associés à hauteur de leur apport dans la société. Les formalités à accomplir lors de la création sont rigoureuses et entraînent des coûts. Rédaction des statuts, publication dans un journal d’annonces légales, envoi des statuts signés au greffe, immatriculation au registre du commerce et des sociétés… Du fait de certaines règles spécifiques auxquelles est soumise la SCI, d’autres frais cachés peuvent être engagés, comme par exemple lorsqu’elle dépose un permis de construire, pour lequel elle doit obligatoirement faire appel à un architecte."
    },
    {
      title: "Quel intérêt y a-t-il à choisir le statut de SCI pour son entreprise&nbsp;?",
      answer: "L’intérêt de créer une SCI (société civile immobilière) pour qui veut gérer un patrimoine immobilier à plusieurs est multiple. En plus de permettre d’adapter le statut de l’entreprise à l’objet social poursuivi (familial, gestion-location, attribution…),\n la SCI comporte plusieurs avantages fiscaux (choix de l’imposition IS ou IR),\n financiers (construction d’un capital social à plusieurs),\n de gestion et de transmission du patrimoine. Elle est également réputée pour sa souplesse de fonctionnement, grâce à la rédaction des statuts qui fixent, dès sa création, les modalités de prises de décisions, les relations entre associés et les conditions de cession de parts sociales."
    },
    {
      title: "Qu’est-ce qu’une SCI (société civile immobilière)&nbsp;?",
      answer: "Une société civile immobilière (SCI) est une forme de société civile, qui permet de gérer un patrimoine immobilier à plusieurs (achat et location). Composée d’au minimum deux associés, une SCI peut être créée avec apport minimal en capital. Elle comporte plusieurs avantages, qui en font un statut privilégié des familles et groupement de personnes souhaitant investir dans l’immobilier et se constituer un patrimoine. Le statut juridique de la SCI est une alternative offrant flexibilité et avantages, surtout en matière de gestion, fiscalité et succession."
    }
  ]
},
"/conseils-pros/societe-civile-professionnelle-avantages-inconvenients": {
  title: "Les points forts et limites du statut de société civile professionnelle SCP",
  description: "Découvrez le fonctionnement et les modalités de création d’une société civile professionnelle, les avantages et inconvénients propre à ce statut juridique.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/societe-civile-professionnelle-avantages-inconvenients",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Les points forts et limites du statut de société civile professionnelle SCP",
      item: "/conseils-pros/societe-civile-professionnelle-avantages-inconvenients"
    }
  ],
  faq: [
    {
      title: "Quelles sont les inconvénients à créer une société civile professionnelle&nbsp;?",
      answer: "Il y a 3 inconvénients principaux dans le statut de société civile professionnelle : la responsabilité indéfinie et solidaire des associés, le formalisme de fonctionnement et le régime social de l’associé-gérant. Et pour cause, sous ce statut, les associés peuvent être poursuivis collectivement en cas de dettes de la société, avec exposition de leur patrimoine personnel jusqu’à recouvrement de la dette. Ensuite, le formalisme qui caractérise ce statut peut être bloquant pour qui souhaite s’associer. La création d’une SCP n’est ouverte qu’à une certaine catégorie de professions, demande le respect de formalités bien précises, la création de statuts, la tenue d’assemblées générales pour les décisions collectives… Enfin, c’est également un statut qui n’offre pas une couverture sociale optimale, puisque l’associé-gérant d’une société civile dépend du régime des indépendants (travailleurs non-salariés TNS)."
    },
    {
      title: "Quels sont les principaux avantages de la forme juridique SCP&nbsp;?",
      answer: "Le statut de SCP comporte plusieurs avantages et notamment celui de regrouper les moyens de chaque professionnel et de mutualiser les ressources, tout en respectant l’indépendance professionnelle de chacun des membres. Ces derniers jouissent d’ailleurs d’un certain poids décisionnaire, puisque les décisions collectives doivent être votées à l’unanimité lors d’assemblées générales. De plus, d’un poids de vue financier, la création d’une société civile professionnelle ne nécessite pas de capital minimum. Sur le plan fiscal, les bénéfices sont imposés au nom des associés qui choisissent entre l’IR ou l’IS. Enfin, la cession de parts sociales est libre et arbitrée par ce que les associés ont inscrit dans les statuts de la société."
    },
    {
      title: "Qu’est-ce qu’une société civile professionnelle&nbsp;?",
      answer: "Une société civile professionnelle permet à des personnes physiques d’exercer ensemble une profession libérale réglementée au sein d’une structure juridique, tout en conservant leur indépendance. Composée d’au minimum 2 personnes, une SCP accomplit, par l’intermédiaire des professionnels qu’elle rassemble, des actes professionnels et met en commun les moyens dont chacun dispose (matériel, véhicule, local, standard…). Le statut de SCP est un statut strict, qui n’est pas ouvert à toutes les professions et qui limite les possibilités d’associations professionnelles. En effet, pour s’associer sous ce statut, il est nécessaire d’exercer une activité issue d’un même corps de métier."
    }
  ]
},
"/conseils-pros/statut-entreprise-individuelle-caracteristiques": {
  title: "Guide pratique du statut d’entreprise individuelle (EI)",
  description: "L’entreprise individuelle (EI) : tout ce qu’il faut savoir sur ce statut juridique nouvellement mis à jour, qui facilite la création d’entreprise en solo.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/statut-entreprise-individuelle-caracteristiques",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Guide pratique du statut d’entreprise individuelle (EI)",
      item: "/conseils-pros/statut-entreprise-individuelle-caracteristiques"
    }
  ],
  faq: [
    {
      title: "Quelles limites comportent le statut d’entreprise individuelle&nbsp;?",
      answer: "L’entreprise individuelle comporte quelques inconvénients à prendre en considération. Pour citer les principaux, il y a son mode de fonctionnement, l’entrepreneur individuel ne pouvant avoir d’associés. S’il souhaite s’associer, il devra effectuer un changement de statut juridique, constituer un capital social et rédiger des statuts. Il y a aussi la protection limitée que procure le régime social de l’auto-entrepreneur. Et enfin, les exceptions au principe de séparation automatique des patrimoines personnel et professionnel, qui n’est plus valable s’il y a renonciation volontaire en faveur d’un créancier, opérations de recouvrement (IR, prélèvements sociaux),\n manœuvres frauduleuses ou liquidation judiciaire."
    },
    {
      title: "Quels sont les avantages à créer sous le statut de l’entreprise individuelle&nbsp;?",
      answer: "En tant que forme simplifiée d’entreprise, le statut de l’entreprise individuelle bénéficie de formalités de création simples et rapides. Statut est ouvert à un large éventail d’activités professionnelles, il est un excellent tremplin pour devenir travailleur indépendant. Il ne nécessite aucun apport de départ et se caractérise par des obligations comptables restreintes. Il offre la possibilité d’exercer sous le régime de la micro-entreprise et de bénéficier ainsi d’allègements. Depuis 2022, le patrimoine personnel et professionnel de l’EI sont automatiquement distincts, limitant la responsabilité de l’entrepreneur aux biens nécessaires à l’activité professionnelle (sauf s’il délivre des cautions, bancaires par exemple, mais toujours hors-résidence principale)."
    },
    {
      title: "Qu’est-ce qu’une entreprise individuelle&nbsp;?",
      answer: "Une entreprise individuelle est une forme simplifiée d’entreprise. Toute personne majeure peut créer rapidement son EI, sans capital social de départ, pour une activité commerciale, industrielle, libérale ou artisanale. L’entrepreneur individuel exerce son activité en nom propre, ne peut pas avoir d’associé et est le seul décisionnaire. Le statut de l’EI bénéficie d’allègements au niveau du fonctionnement, de la gestion et de la fiscalité de l’entreprise. De plus, depuis la loi de février 2022 en faveur de l'activité professionnelle indépendante, les entreprises individuelles bénéficient d’un régime plus protecteur pour le patrimoine personnel."
    }
  ]
},
"/conseils-pros/entreprise-choisir-statut-juridique": {
  title: "Création d’entreprise : comment choisir la forme juridique de son entreprise ?",
  description: "En création d’entreprise, le choix du statut juridique est essentiel : comment choisir ? Quelles caractéristiques pour chaque statut ? Suivez le guide.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/entreprise-choisir-statut-juridique",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Création d’entreprise : comment choisir la forme juridique de son entreprise ?",
      item: "/conseils-pros/entreprise-choisir-statut-juridique"
    }
  ],
  faq: [
    {
      title: "Quel est le meilleur statut juridique pour une entreprise&nbsp;?",
      answer: "Il n’y a pas de statut juridique standard idéal ! Il existe en revanche un statut juridique plus adapté à votre projet entrepreneurial que ne le serait un autre. Lorsque l’on choisit un statut, de nombreux critères sont à prendre en compte, comme le choix du régime fiscal, l’impact du régime social, être à la tête d’une activité seul ou à plusieurs, la protection de patrimoine personnel, le type d’activité exercée et les possibles restrictions inhérentes… Une étude approfondie de votre projet est donc nécessaire afin de cibler chacun de ces aspects, de s’assurer que le statut choisi ne porte pas préjudice au projet (notamment au niveau des charges) et de projeter votre entreprise dans le futur."
    },
    {
      title: "Le choix de la forme juridique pour une entreprise est-il définitif&nbsp;?",
      answer: "La forme juridique choisie pour une entreprise à sa création n’est pas définitive. Une entreprise est vouée à évoluer, il peut donc être nécessaire de faire évoluer son statut juridique en fonction de la situation. Toutefois, en fonction du statut de départ, le passage vers le statut suivant peut être plus ou moins complexe, voire limité. C’est pourquoi il est important de bien préparer son projet de création et d’anticiper sur ses possibles évolutions. De cette manière, vous serez assuré de choisir un statut juridique qui bénéficie d’une passerelle vers un autre, si nécessaire. De plus, un changement de statut constitue un poids administratif et impacte le capital social de l’entreprise. Il est donc nécessaire d’obtenir l’accord de tous les associés."
    },
    {
      title: "Qu’est-ce qu’un statut juridique d’entreprise&nbsp;?",
      answer: "Le statut juridique (ou forme juridique) d’une entreprise est le cadre juridique qui officialise et définit l’existence d’une société, et qui détermine les règles de son fonctionnement. Parmi ces règles, l’on retrouve tout ce qui a trait au fonctionnement de l’entreprise (le rôle des gérants et des associés, obligations comptables…),\n au cadre juridique (obligation de création, de fermeture, de cession, niveau de responsabilité…),\n aux régimes fiscaux (impôt sur le revenu IR ou impôt sur les sociétés IS) et aux régimes sociaux appliqués (travailleur non salarié TNS, assimilé-salarié)."
    }
  ]
},
"/conseils-pros/statut-SAS-avantages-inconvenients": {
  title: "Points forts et points faibles de la SAS (Société par actions simplifiée)",
  description: "SAS - Société par actions simplifiée : caractéristiques, avantages et inconvénients de l’un des statuts privilégiés en création d’entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/statut-SAS-avantages-inconvenients",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Points forts et points faibles de la SAS (Société par actions simplifiée)",
      item: "/conseils-pros/statut-SAS-avantages-inconvenients"
    }
  ],
  faq: [
    {
      title: "Quels sont les inconvénients de la SAS&nbsp;?",
      answer: "Comme toute forme juridique, la SAS comporte quelques limites. La liberté dans les rédactions des statuts peut conduire à des oublis de clauses statutaires primordiales, à des incompréhensions et/ou raccourcis pouvant créer des conflits. Il est donc fortement conseillé de solliciter les services de juristes spécialisés. D’un poids de vue comptable, le statut d’assimilé-salarié entraîne des charges sociales plus élevées. Enfin, peu adaptée aux projets familiaux, la SAS est délaissée par les créateurs d’entreprise qui souhaitent construire une entreprise familiale protectrice de ses collaborateurs, tout en bénéficiant d’avantages fiscaux."
    },
    {
      title: "Quels avantages présente le statut de SAS pour une société&nbsp;?",
      answer: "Créer une société sous le statut juridique de la SAS présente des avantages gestionnaires, fiscaux et fonctionnels. En premier lieu la liberté contractuelle des associés pour rédiger les statuts de leur société. Hormis l’obligation de nommer un président qui représente la société, ils sont libres de décider du montant et de la composition du capital social, des modalités d’entrée de nouveaux associés, de l’organisation de la direction et de la répartition des pouvoirs. Le patrimoine personnel des associés est mieux protégé, distinct de celui de la société. Ils peuvent choisir le régime d’imposition (IR ou IS),\n limiter les charges sociales grâce aux dividendes, et obtenir la protection sociale des assimilés-salariés."
    },
    {
      title: "Qu’est-ce qu’une SAS&nbsp;?",
      answer: "Une SAS (société par actions simplifiée) est devenu le statut juridique privilégié des créateurs et dirigeants d’entreprise commerciale. La SAS offre une souplesse de fonctionnement où les associés (deux au minimum) décident seuls du contenu des statuts, de la constitution du capital social, des modalités de votes et d’entrée de nouveaux actionnaires. De plus, la SAS permet à ses actionnaires et dirigeants de bénéficier d’une protection de leur patrimoine personnel et d’avantages au niveau du régime fiscal et social. La SAS se décline sous une forme unipersonnelle qui présente les mêmes caractéristiques : la SASU."
    }
  ]
},
"/conseils-pros/statut-sasu-avantages-inconvenients": {
  title: "Points forts et points faibles de la SASU",
  description: "Choisir le statut SASU : ce qu’il faut savoir des avantages et des inconvénients que présente ce statut avant de se lancer.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/statut-sasu-avantages-inconvenients",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Points forts et points faibles de la SASU",
      item: "/conseils-pros/statut-sasu-avantages-inconvenients"
    }
  ],
  faq: [
    {
      title: "Quel est le fonctionnement d'une SASU&nbsp;?",
      answer: "Une SASU fonctionne avec un actionnaire unique qui détient et gère l'entreprise. Cet actionnaire\\ndécide de l'organisation et du fonctionnement de la SASU selon les statuts qu'il établit. Il nomme un\\nprésident, qui peut être lui-même, chargé de la direction de la société et de sa représentation légale. La SASU est soumise à l'impôt sur les sociétés par défaut, avec la possibilité d'opter pour l'impôt sur le revenu sous conditions. La responsabilité de l'actionnaire est limitée à ses apports, protégeant son patrimoine personnel."
    },
    {
      title: "Quel est l'intérêt de créer une SASU&nbsp;?",
      answer: "La création d'une SASU permet de protéger le patrimoine personnel de l'actionnaire, offre une grande flexibilité de gestion, permet une optimisation fiscale, simplifie la transmission de l'entreprise et renforce sa crédibilité auprès des partenaires et financiers."
    },
    {
      title: "Est-ce qu'une SASU est une personne morale&nbsp;?",
      answer: "Oui, une SASU (Société par Actions Simplifiée Unipersonnelle) est considérée comme une personne morale. Cela signifie qu'elle a une existence juridique distincte de celle de son unique actionnaire, lui permettant d'avoir des droits et des obligations, de posséder des biens, de contracter des emprunts, et d'être sujette à imposition."
    }
  ]
},
"/conseils-pros/statut-sarl-avantages-inconvenients": {
  title: "SARL, quels sont les avantages et inconvénients de ce statut ?",
  description: "Tout connaître des différents avantages et inconvénients qui caractérisent la SARL avant de construire son projet entrepreneurial sous ce statut juridique.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/statut-sarl-avantages-inconvenients",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "SARL, quels sont les avantages et inconvénients de ce statut ?",
      item: "/conseils-pros/statut-sarl-avantages-inconvenients"
    }
  ],
  faq: [
    {
      title: "Quels sont les inconvénients du statut juridique SARL&nbsp;?",
      answer: "Parmi les inconvénients de la SARL, nous pouvons mentionner sa rigidité juridique, qui peut ne pas convenir à certains entrepreneurs épris de grande liberté dans leurs décisions et actions. En effet, la SARL est très encadrée légalement et peu de dispositions statutaires peuvent s’opposer à ce que les textes de lois imposent. Cette rigidité de gestion s’illustre notamment dans les conditions d’entrée de nouveaux associés au capital, qui n’est possible que suite à l’obtention de l’accord des associés, à l’unanimité. La SARL se caractérise également par des formalités de création contraignantes et coûteuses avec la rédaction de statuts, la libération du capital avant la création, et les aides extérieures auxquelles doit recourir le gérant pour s’assurer de la conformité légale de sa société."
    },
    {
      title: "Quels sont les principaux avantages d’une SARL&nbsp;?",
      answer: "La SARL est populaire auprès des créateurs d’entreprise, grâce à ses nombreux avantages. Parmi eux, nous pouvons citer la sécurité de fonctionnement, fortement encadré par le code de commerce, ce qui offre stabilité de gestion et sécurité en cas de désaccord entre associés et/ou gérants. Une SARL fournit une meilleure protection de ses associés, face aux dettes contractées, au niveau de la protection sociale ou grâce au titre de conjoint-collaborateur. Enfin, cette forme juridique de société s’adapte à de nombreux projets professionnels, puisqu’elle peut compter plusieurs associés (SARL classique),\n un associé unique (EURL) ou être choisie pour mener des projets familiaux (SARL familiale)."
    },
    {
      title: "Qu’est-ce qu’une SARL, société à responsabilité limitée&nbsp;?",
      answer: "La SARL est une société commerciale qui se caractérise par un fort encadrement légal, une responsabilité limitée et un capital social divisé en parts sociales qui ne peuvent être cédées que suite à un accord unanime. Accessible et plurisectorielle, cette forme juridique de société est adaptée à nombre de projets, aux petites et aux moyennes entreprises. La SARL comporte même une forme de société adaptée aux projets familiaux : la SARL familiale. Ses règles de gestion et de fonctionnement doivent figurer dans les statuts de la société, qui doit se rassembler en AG au minimum une fois par an pour les prises de décision et validation des comptes. La SARL est par défaut imposée à l’impôt sur les sociétés (IS),\n mais peut opter pour l’impôt sur le revenu (IR),\n pour 5 ans (sous conditions)."
    }
  ]
},
"/conseils-pros/avantages-franchiser-entreprise": {
  title: "Qu'est-ce qu'une franchise ? Définition & avantages",
  description: "Entreprendre ou se développer en franchise : tour d’horizon des\\navantages pour le franchisé et le franchiseur, partenaires dans ce modèle commercial.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/avantages-franchiser-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Qu'est-ce qu'une franchise ? Définition & avantages",
      item: "/conseils-pros/avantages-franchiser-entreprise"
    }
  ],
  faq: [
    {
      title: "Quelle est la différence entre franchise et succursale&nbsp;?",
      answer: "Dans une franchise, les points de vente sont structurés en réseau. Ce réseau est dirigé\\npar une entité centrale, souvent désignée comme la tête de réseau, qui fournit aux points\\nde vente une licence d'utilisation de sa marque, son expertise et son soutien. Les points\\nde vente se divisent en franchisés et en succursales. Les franchisés sont des\\nentrepreneurs indépendants possédant leur propre structure juridique, comme une\\nSARL ou une SAS, séparée de celle du franchiseur. Les gérants des succursales sont,\\neux, des employés directement rattachés à la tête de réseau."
    },
    {
      title: "Quel est le rôle de la franchise&nbsp;?",
      answer: "Le rôle de la franchise est de permettre une expansion rapide et structurée d'une marque\\nou d'un concept d'entreprise en utilisant le capital et les efforts de parties indépendantes\\n(les franchisés). Ceci aide à diffuser la marque et ses produits ou services tout en\\nmaintenant une uniformité dans l'offre et les opérations."
    },
    {
      title: "Comment fonctionne une franchise&nbsp;?",
      answer: "Une franchise fonctionne en accordant à un franchisé le droit d'exploiter le nom, le\\nmodèle d'affaires, et les méthodes d'une marque ou d'un franchiseur. En échange, le\\nfranchisé paie des droits initiaux et des royalties régulières. Le franchiseur offre\\n\\nformation, support et ressources pour aider le franchisé à démarrer et à gérer son\\nentreprise selon les standards de la marque."
    }
  ]
},
"/conseils-pros/creer-son-entreprise": {
  title: "Guide complet : Comment créer son entreprise en France ?",
  description: "Découvrez toutes les étapes pour créer votre entreprise : de l'idée au lancement, avec conseils pratiques, statuts et démarches.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/creer-son-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Guide complet : Comment créer son entreprise en France ?",
      item: "/conseils-pros/creer-son-entreprise"
    }
  ],
  faq: [
    {
      title: "Quel est le coût pour créer une entreprise&nbsp;?",
      answer: "Le coût de création d’une entreprise varie en fonction du statut juridique choisi, des  formalités administratives et du recours éventuel à un accompagnement professionnel.  Par exemple, créer une micro-entreprise est généralement gratuit, tandis que la création  d’une société comme une SAS ou une SARL implique des frais d’immatriculation et de  publication légale, souvent compris entre 150 et 500 euros. Si vous choisissez de vous  faire accompagner par un expert-comptable, un avocat ou une plateforme spécialisée,  le budget total peut aller de 500 à 2 000 euros. Ces montants peuvent varier selon la  complexité de votre projet, d’où l’intérêt de bien s’informer avant de se lancer."
    },
    {
      title: "Quelles aides pour créer son entreprise quand on est au chômage&nbsp;?",
      answer: "Si vous êtes au chômage, plusieurs aides peuvent faciliter votre création d’entreprise.  Vous pouvez bénéficier de l’ARCE, qui vous permet de toucher une partie de vos  allocations chômage sous forme de capital, ou choisir de maintenir vos allocations  mensuellement pendant le lancement de votre activité. Dans les deux cas, vous devez  avoir obtenu l’ACRE, une exonération partielle de charges sociales pendant un an.  L’ARCE et le maintien des allocations ne sont pas cumulables : il faut choisir la formule la plus adaptée à votre situation."
    },
    {
      title: "Comment devenir auto-entrepreneur&nbsp;?",
      answer: "Devenir auto-entrepreneur est une démarche simple, rapide et gratuite si vous la faites  vous-même. Il vous suffit de déclarer votre activité en ligne sur le site officiel  formalites.entreprises.gouv.fr, géré par l’INPI. Vous devrez fournir quelques  informations sur votre identité et la nature de votre activité. Une fois votre demande  validée, vous recevrez un numéro SIRET, indispensable pour commencer à facturer. Si  besoin, vous pouvez aussi vous faire accompagner par des plateformes spécialisées, moyennant des frais."
    }
  ]
},
"/conseils-pros/entrepreneuriat-clefs-reussite": {
  title: "Les codes pour réussir en entrepreneuriat",
  description: "Conseils, profils et stratégies : les différents atouts à avoir en poche pour réussir en entrepreneuriat.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/entrepreneuriat-clefs-reussite",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Les codes pour réussir en entrepreneuriat",
      item: "/conseils-pros/entrepreneuriat-clefs-reussite"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce que l’entrepreneuriat&nbsp;?",
      answer: "Au sens strict du terme, l’entrepreneuriat désigne l’action d’entreprendre un projet professionnel via la création d’une entreprise. Il est possible d’entreprendre de plusieurs façons : la reprise d’une société, le développement d’une franchise, d’une filiale en interne…\\r\\nL’entrepreneuriat peut-être lucratif ou non, de plus ou moins grande ampleur (EI, TPE, PME…) et concerne divers secteurs d’activités économiques (libéral, agricole, commercial ou artisanal). L’entrepreneuriat permet de sortir du cadre salarial classique, pour donner vie à une idée novatrice, répondre à un besoin, solutionner une demande… Le tout, en étant le seul maître à bord de son projet professionnel et en soutenant le développement d’une activité économique, créatrice de valeur et d’emploi. \\r\\n"
    },
    {
      title: "Quels sont les avantages de l’entrepreneuriat&nbsp;?",
      answer: "Le premier avantage qui vient à l’esprit lorsque l’on parle de l’entrepreneuriat, est qu’il permet d’être son propre patron, synonyme d’indépendance et de flexibilité ; ce milieu comporte aussi d’autres avantages. En premier, nous pouvons citer l’opportunité que l’entrepreneuriat offre de donner vie à une idée, un projet. Une liberté de travail, où l’entrepreneur est seul maître à bord et décide de son rythme de travail, de ses décisions, de ses stratégies marketing… L’entrepreneuriat offre une diversité de travail, loin de la monotonie. En fonction du succès et du développement de l’entreprise, c’est également un milieu créateur d’emplois, acteur de l’économie et de l’insertion professionnelle. Une belle opportunité pour relever des défis et créer une ambiance de travail à l’image de ses valeurs !"
    },
    {
      title: "Quels sont les inconvénients de l’entrepreneuriat&nbsp;?",
      answer: "Si l’entrepreneuriat offre une certaine liberté et flexibilité qui fait parfois défaut au traditionnel salariat, il est aussi synonyme de défis, voire de difficultés. On peut citer la charge de travail, que ce soit au moment du lancement de l’entreprise, pour la maintenir à flot ou pour assumer les diverses responsabilités inhérentes au statut. De ce premier inconvénient, découle une certaine instabilité financière. D’un mois sur l’autre, les résultats de l’entreprise peuvent varier, ce qui nécessite une certaine anticipation. Ce risque financier est d’autant plus accentué que l’entrepreneuriat ne permet pas l’accès à tous les avantages sociaux. Il constitue déjà un pari financier à son lancement, mais d’autant plus lorsque l’on sait que les entrepreneurs ne cotisent pas à l’assurance-maladie ou à l’assurance-chômage. Pour être mieux protéger, ces derniers doivent ainsi investir dans des complémentaires, souvent onéreuses."
    }
  ]
},
"/conseils-pros/aide-creation-entreprise": {
  title: "Les différentes aides à la création d'entreprise",
  description: "Découvrez les aides pour la création d'entreprise : subventions, exonérations, formations et accompagnement. Cet article vous guide pour identifier les ressources adaptées.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/aide-creation-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Les différentes aides à la création d'entreprise",
      item: "/conseils-pros/aide-creation-entreprise"
    }
  ],
  faq: [
    {
      title: "Quelles sont les aides pour devenir auto-entrepreneur&nbsp;?",
      answer: "Devenir auto-entrepreneur en France donne accès à plusieurs aides pour faciliter la création et le développement d'une activité. L'ACRE propose une exonération partielle des charges sociales, tandis que le NACRE offre un accompagnement et un soutien financier. Le microcrédit professionnel, notamment via l'ADIE, est destiné aux entrepreneurs sans accès au crédit bancaire. Des formations gratuites sont également disponibles via les CCI, CMA ou Pôle Emploi. Selon la région, des aides locales peuvent inclure subventions et réductions fiscales. Enfin, diverses organisations proposent du mentorat et du conseil pour soutenir les nouveaux entrepreneurs."
    },
    {
      title: "Comment obtenir le prêt d'honneur de 1500 euros pour les entreprises &nbsp;?",
      answer: "Le prêt d'honneur de 1 500 euros, à taux zéro et sans garantie, est destiné aux créateurs ou repreneurs d’entreprise pour soutenir leur démarrage. Il est accordé par des réseaux comme Initiative France ou Réseau Entreprendre. Pour l'obtenir, il faut constituer un dossier solide avec un business plan, passer devant un comité de sélection, et présenter son projet. Si le prêt est accordé, il peut être utilisé pour financer les besoins liés au lancement de l'activité."
    },
    {
      title: "Quelles sont les aides pôle emploi pour la création d'entreprise&nbsp;?",
      answer: "Pôle emploi propose plusieurs aides pour soutenir la création d'entreprise. L'ARCE (Aide à la Reprise ou à la Création d'Entreprise) permet de recevoir une partie de vos allocations chômage sous forme de capital pour financer votre projet, sous certaines conditions, notamment l'éligibilité à l'ACRE. Vous pouvez également bénéficier du maintien de l'ARE, qui vous permet de continuer à percevoir une partie de vos allocations chômage tout en démarrant votre activité. En outre, le programme Activ’Créa offre un accompagnement personnalisé pour explorer et évaluer la faisabilité de votre projet entrepreneurial. Ces aides visent à soutenir financièrement et accompagner les demandeurs d'emploi dans leurs démarches de création d'entreprise."
    }
  ]
},
"/conseils-pros/clause-agrement": {
  title: "Clause d'agrément : tout ce qu'il faut savoir",
  description: "Définition, fonctionnement et rôle de la clause d’agrément lors d’une cession de titres sociaux au sein d’une société.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/clause-agrement",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Clause d'agrément : tout ce qu'il faut savoir",
      item: "/conseils-pros/clause-agrement"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce qu’une clause d’agrément&nbsp;?",
      answer: "Prévue par la loi, la clause d’agrément est une clause obligatoirement présente dans les statuts de sociétés dont le capital est divisé en parts ou en actions (SA, SAS, SARL…). Elle a pour objet principal la gestion des titres sociaux de la société, notamment par la description de la procédure d’agrément qui doit être suivie lors de leur cession.\\r\\n"
    },
    {
      title: "À quoi sert une clause d’agrément&nbsp;?\\r\\n",
      answer: "Le but d’une clause d’agrément est de réguler et de sécuriser l’actionnariat au sein d’une société. En obligeant tout cédant à obtenir l’accord de la société lors de la cession de ses titres, elle permet aux actionnaires de gérer l’entrée de nouveaux associés et de se préserver contre l’intrusion d’un tiers. Une clause d’agrément permet également de protéger les actionnaires minoritaires si ces derniers ne disposent pas de voix suffisantes. Enfin, la clause d’agrément permet de protéger les intérêts, l’image et l’avenir de la société.\\r\\n"
    },
    {
      title: "Quelles sont les limites de la clause d’agrément&nbsp;?",
      answer: "Seules les SARL ont pour obligation légale d’inclure une clause d’agrément dans leurs statuts. Pour les autres sociétés de personnes, l’insertion d’une telle clause dans les statuts est laissée à la libre appréciation des associés. La procédure d’agrément est donc limitée par ce que les associés portent aux statuts selon leur connaissance du sujet. C’est pourquoi il est recommandé de solliciter les services d’un expert. Enfin, la clause d’agrément peut être écartée en cas de succession, liquidation du régime matrimonial ou de cession à un conjoint, ascendant ou descendant. \\r\\n"
    }
  ]
},
"/conseils-pros/gestion-conflit-travail": {
  title: "Comment gérer les conflits en entreprise ?",
  description: "Gestion des conflits au travail : savoir reconnaître les causes de conflits et gérer les situations conflictuelles en proposant une solution adaptée et durable",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/gestion-conflit-travail",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment gérer les conflits en entreprise ?",
      item: "/conseils-pros/gestion-conflit-travail"
    }
  ],
  faq: [
    {
      title: "À qui faire appel en cas de conflit au travail&nbsp;?",
      answer: "Lorsqu’un conflit survient au sein d’une entreprise, faire appel à un tiers permet d’obtenir un avis objectif et impartial. En interne, c’est notamment le rôle tenu par l’équipe de management et/ou celle des ressources humaines. Si aucune mesure n’est prise par ses services, il est ensuite possible de solliciter l’aide d’un organisme extérieur comme la médecine du travail (pour faire part de votre mal-être),\n l’inspection du travail (pour connaître vos recours),\n le conseil des Prud’hommes…"
    },
    {
      title: "Est-ce qu'une eurl peut embaucher (jusqu'à combien de salarié)&nbsp;?",
      answer: "Oui, une EURL (Entreprise Unipersonnelle à responsabilité Limitée) peut embaucher des salariés. Il n'y a pas de limite maximale quant au nombre de salariés qu'une EURL peut embaucher. La décision d'embaucher dépend de la capacité de l'entreprise à financer les salaires et à gérer ses employés conformément à la réglementation en vigueur."
    },
    {
      title: "Qu'est ce qu'un conflit au travail&nbsp;?",
      answer: "Le conflit au travail se définit par un désaccord entre un ou plusieurs parties au sein d’une même structure (collaborateurs, salariés, hiérarchie…). C’est l’émergence du désaccord et l’absence de résolution qui créent le conflit. S’il s’exprime dans la relation qu’entretiennent les individus, le conflit au travail peut avoir plusieurs causes (de la divergence d’opinion à l’abus de pouvoir) et conséquences. Ainsi, en, en fonction du traitement qu’il connaît, le conflit peut impacter les conditions de travail, la motivation des salariés, la productivité et l’image de l’entreprise…"
    }
  ]
},
"/conseils-pros/proposition-commerciale": {
  title: "Comment réaliser une proposition commerciale ?",
  description: "Nos conseils et exemples pour construire une proposition commerciale efficace et convaincante, afin de faire de vos prospects des clients satisfaits.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/proposition-commerciale",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment réaliser une proposition commerciale ?",
      item: "/conseils-pros/proposition-commerciale"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce qu’une proposition commerciale&nbsp;?",
      answer: "Une proposition commerciale, ou propale, est un document envoyé à vos clients potentiels, dans l’espoir de travailler avec eux. Elle répond à la problématique rencontrée par votre prospect, et lui présente de manière détaillée les solutions que vous avez élaborées pour lui. Le but d’une proposition commerciale est de répondre aux besoins de votre client, tout en lui montrant que votre entreprise est la plus à même d’y répondre."
    },
    {
      title: "Quels sont les différents éléments composant une proposition commerciale&nbsp;?",
      answer: "Une proposition commerciale se compose d’une page de titre, d’un sommaire, d’une lettre d’accompagnement, d’un résumé opérationnel, d’une description de la problématique de votre client et des solutions que vous proposez, de votre plan d’actions, d’une grille tarifaire, d’une présentation de votre entreprise, d’une synthèse et des conditions générales du contrat."
    },
    {
      title: "Quelle est la différence entre une proposition commerciale et un devis&nbsp;?",
      answer: "Un devis est un document comptable, principalement centré sur le prix d’un produit ou d’un service que vous proposez à vos prospects. Il a une durée minimale de validité et doit être signé pour être valable. Une proposition commerciale, quant à elle, offre à vos clients potentiels, une vision bien plus détaillée de ce que vous proposez. Elle reprend, les problématiques des clients, les solutions apportées, les bénéfices qu’ils peuvent en tirer, les modalités de paiement, les délais et les conditions générales de vente."
    }
  ]
},
"/conseils-pros/transformation-digitale-entreprise": {
  title: "Entreprises : 8 outils pour votre transformation digitale",
  description: "Transformation digitale des entreprises : de quoi parle-t-on et quels sont les principaux outils digitaux à mettre en place ?",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/transformation-digitale-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Entreprises : 8 outils pour votre transformation digitale",
      item: "/conseils-pros/transformation-digitale-entreprise"
    }
  ],
  faq: [
    {
      title: "En quoi consiste la transformation digitale d’une entreprise&nbsp;?",
      answer: "La transformation digitale d’une entreprise consiste en l’intégration de nouveaux outils digitaux dans les différents aspects et niveaux de fonctionnement d’une entreprise. Également appelée « transformation numérique » ou « e-transition », elle s’inscrit dans une démarche de progrès, en lien avec l’essor connu par le numérique, Internet et les réseaux sociaux. Si elle s’appuie sur les technologies pour améliorer ses process, elle se compose également d’une part humaine, avec une nouvelle culture d’entreprise, une nouvelle manière de travailler… La transformation digitale est une transformation globale de l’entreprise."
    },
    {
      title: "Quelle est l'importante de la transformation digitale d'une entreprise&nbsp;?",
      answer: "La transformation digitale d’une entreprise lui permet de ne pas devenir obsolète face à l’évolution du marché et de l’avancée des nouvelles technologies. Grâce à la dématérialisation des services, données et process de l’entreprise, la transformation digitale permet de rester compétitif, de maintenir une image moderne en interne, comme en interne, de gagner en productivité et donc en rentabilité. Bien menée, la transformation digitale des entreprises constitue un formidable levier économique."
    },
    {
      title: "Quels sont les outils digitaux essentiels à une transformation digitale&nbsp;?",
      answer: "L’insertion d’outils digitaux dans vos processus de travail et de création de valeur va dépendre de la stratégie visée par votre entreprise et de ses besoins. À titre d’exemple, une entreprise où tous les salariés ne travaillent pas sur site va intégrer une suite collaborative à son fonctionnement. Quand une autre, qui traite avec beaucoup de clients, va choisir un outil CRM… Toutefois, si liste des outils digitaux il devait y avoir, nous pourrions commencer par citer : les outils de comptabilité, les CMS, les suites collaboratives, les plateformes de communication, les outils de stockage de données en ligne…"
    }
  ]
},
"/conseils-pros/methode-ikigai": {
  title: "Comment identifier son job idéal avec la méthode ikigaï ?",
  description: "Tous nos conseils pour utiliser, interpréter et tirer parti de la méthode ikigaï et ainsi trouver sa vocation professionnelle.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/methode-ikigai",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment identifier son job idéal avec la méthode ikigaï ?",
      item: "/conseils-pros/methode-ikigai"
    }
  ],
  faq: [
    {
      title: "En quoi consiste la méthode ikigaï&nbsp;?",
      answer: "L’ikigaï est un concept philosophique japonais, qui peut être traduit par « raison d’être » et « joie de vivre ». Il permet de trouver un équilibre entre ce que l’on aime, ce que l’on sait faire, ce qui est utile et ce dont le monde a besoin. Lorsqu’elle est utilisée dans le milieu du travail, la méthode ikigaï devient un outil qui permet de cibler l’activité professionnelle la plus adaptée, celle qui donne un sens à la vie."
    },
    {
      title: "Pourquoi utiliser la méthode ikigaï dans le milieu professionnel",
      answer: "Dans le cadre professionnel, l’ikigaï permet de s’interroger sur soi-même afin de mieux comprendre ses compétences, ses ressources, ses motivations et ambitions. Trouver son ikigaï permet de trouver l’activité professionnelle qui vous correspond le mieux et qui rétablit un meilleur équilibre entre vie perso et vie pro."
    },
    {
      title: "Quels sont les principaux piliers sur lesquels s'appuie la méthode ikigaï&nbsp;?",
      answer: "La méthode ikigaï repose sur un entrecroisement de plusieurs cercles dont les principaux sont votre passion, votre mission, votre vocation et votre profession. Ces piliers vous interrogent et vous invitent à l’introspection afin de définir ce que vous aimez, ce en quoi vous êtes doué, ce pour quoi vous pouvez être payé et, enfin, ce dont le monde a besoin. C’est l’équilibre entre ces 4 dimensions qui permet de trouver son ikigaï."
    }
  ]
},
"/conseils-pros/monter-entreprise-sans-argent": {
  title: "Comment monter son entreprise sans argent ?",
  description: "Créer une entreprise sans argent, est-ce possible ? Suivez nos conseils pour savoir comment faire et mettre toutes les chances de votre côté.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/monter-entreprise-sans-argent",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment monter son entreprise sans argent ?",
      item: "/conseils-pros/monter-entreprise-sans-argent"
    }
  ],
  faq: [
    {
      title: "Est-il possible de créer une entreprise sans argent&nbsp;?",
      answer: "La création d’une entreprise sans argent est possible, à condition de choisir la bonne forme juridique et la bonne activité. Côté forme juridique, orientez-vous vers un statut qui ne nécessite pas d’apport de départ important, comme celui de l’entreprise individuelle (régime de la micro-entreprise),\n de la SAS ou de la SARL. Pour ce qui est de l’activité, privilégiez les activités ne nécessitant pas de gros stocks, achats de machines, location de locaux…et choisissez les activités à faible budget comme le numérique, les services à la personnes, les activités de services, de formations et conseils, etc."
    },
    {
      title: "Quels sont les conseils pour monter son entreprise sans budget&nbsp;?",
      answer: "Les chances de réussite de la d’une entreprise avec un budget limité peuvent être boostées en suivant ces quelques conseils : réaliser un business plan solide afin de structurer et d’orienter correctement votre projet entrepreneurial, sélectionner le bon statut juridique (EI, SAS ou SARL),\n rechercher des modes de financements alternatifs comme les aides publiques, les prêts d’honneur, le crowdfunding, la prévente…"
    },
    {
      title: "Quels sont les risques lorsque l'on crée une entreprise sans argent&nbsp;?",
      answer: "Créer une entreprise sans argent comporte quelques risques, notamment au niveau du statut d’entrepreneur et du statut juridique. Pour l’entrepreneur, la charge de travail est conséquente et variée. Seul capitaine à bord, vous devez être en mesure de vous imposer une rigueur journalière dans l’accomplissement de vos tâches et d’assumer toutes les missions inhérentes à la gestion de votre entreprise. À cela, s’ajoute le choix du statut juridique, où doivent être pris en compte le montant du capital social (obligation de montant et de libération) et la responsabilité du ou des dirigeants en cas de dettes sociales de l’entreprise."
    }
  ]
},
"/conseils-pros/crowdfunding": {
  title: "Qu'est ce que le crowdfunding : définition & conseils",
  description: "Tout ce qu’il faut savoir sur le crowdfunding : sa signification, ses avantages et inconvénients, son fonctionnement… afin de réussir le financement de votre projet entrepreneurial.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/crowdfunding",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Qu'est ce que le crowdfunding : définition & conseils",
      item: "/conseils-pros/crowdfunding"
    }
  ],
  faq: [
    {
      title: "Qu'est-ce que le crowdfunding&nbsp;?",
      answer: "Le crowdfunding consiste en lever des fonds via le financement participatif, c’est-à-dire la possibilité pour Monsieur et Madame Tout le Monde d’investir (même de petites sommes) dans des projets proposés sur des sites internet spécialisés. C’est une solution de financement qui permet de financer des projets de création, reprise et/ou développement d’activité, service ou produit. On retrouve trois types de crowdfunding que les entreprises peuvent utiliser : le crowdfunding sous forme de dons, sous forme de prêts, ou en capital."
    },
    {
      title: "Quels sont les avantages du crowdfunding&nbsp;?",
      answer: "En plus de lever des fonds, le crowdfunding comporte de nombreux autres avantages pour le porteur de projet à l’initiative de la campagne. Parmi les principaux, l’on peut citer la protection du patrimoine personnel qu’il assure, puisqu’aucune garantie personnelle n’est demandée au lancement de la campagne. De plus, le crowdfunding constitue une étude de marché à moindre coût puisqu’il permet de tester et faire évoluer une idée, un produit grâce aux feedbacks des investisseurs. Il est également une solution formidable à toutes les idées et besoins en financement qui ne trouveraient pas de soutien auprès des organismes bancaires classiques."
    },
    {
      title: "Quels sont les inconvénients du crowdfunding&nbsp;?",
      answer: "Les principaux inconvénients du crowdfunding sont les limites auxquelles ils heurtent telles que l’absence de garantie de financement, si la campagne de collecte n’est pas réussie. Ou encore le vol d’idées innovantes auquel s’exposent les porteurs de projets lorsqu’ils mettent en ligne leur levée de fonds. D’autres inconvénients du financement participatif peuvent surgir en fonction du type de crowdfunding réalisé. Comme avec celui sous forme de prêts, qui engendre des frais supplémentaires (taux d’intérêts) et une requalification de la capacité d’endettement de votre entreprise. Ou celui sous forme de capital, qui complexifie l’actionnariat au sein de l’entreprise."
    }
  ]
},
"/conseils-pros/business-angel": {
  title: "Business angel : une bonne solution pour vos projets ?",
  description: "Tout connaître du business angel : qui est-il, quel est son rôle et comment participe-t-il au financement de votre projet entrepreneurial ?",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/business-angel",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Business angel : une bonne solution pour vos projets ?",
      item: "/conseils-pros/business-angel"
    }
  ],
  faq: [
    {
      title: "Qu'est ce qu'un business angel&nbsp;?",
      answer: "Un business angel est une personne physique qui investit un certain pourcentage de son patrimoine financier au capital d’une entreprise innovante, à fort potentiel de croissance. On parle aussi d’investisseur providentiel puisque le business angel n’appartient pas au cercle proche de la jeune entreprise. il choisit de s’investir et d’investir dans ce projet."
    },
    {
      title: "Quel est le rôle du business angel&nbsp;?",
      answer: "Le rôle premier d’un business angel est d’apporter son soutien financier à une jeune entreprise. Pourtant, cet investissement va bien au-delà de l’aspect financier puisque le business angel investit également son temps, son expérience, son expertise et son réseau relationnel. C’est également un appui pour donner de la crédibilité à votre projet et ainsi obtenir d’autres financements."
    },
    {
      title: "Comment trouver un business angel&nbsp;?",
      answer: "Pour trouver un business angel, vous pouvez vous tourner vers les réseaux de business angels. Regroupements de business angels investissant seul ou à plusieurs (SIBA) dans des projets innovants, ces réseaux mettent en relation entrepreneurs et investisseurs. Ils vous permettent de faire une sélection en fonction de la thématique de votre projet, de votre localisation. Ces réseaux business angels peuvent être généraux ou très ciblés, comme ceux spécialisés dans la santé ou ceux propulsant les femmes business angels."
    }
  ]
},
"/conseils-pros/budget-previsionnel": {
  title: "Comment réaliser un budget prévisionnel pour son projet ?",
  description: "Découvrez comment établir, analyser et exploiter les données d’un budget prévisionnel pour concrétiser votre projet entrepreneurial",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/budget-previsionnel",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment réaliser un budget prévisionnel pour son projet ?",
      item: "/conseils-pros/budget-previsionnel"
    }
  ],
  faq: [
    {
      title: "Qu'est-ce qu'un budget prévisionnel&nbsp;?",
      answer: "Un budget prévisionnel est un document comptable qui permet d’estimer les charges et les recettes d’un projet sur une période donnée, souvent une année civile. Il sert de référence pour comparer l’activité prévisionnelle et l’activité réelle d’une entreprise, permettant ainsi d’adapter les stratégies et les budgets de cette dernière. Son rôle est de montrer la bonne santé financière d’une entreprise ou d’un projet."
    },
    {
      title: "Pourquoi faire un budget prévisionnel pour votre projet&nbsp;?",
      answer: "Préparer un budget prévisionnel est indispensable pour anticiper l’activité et les finances de votre projet. Réel regard sur l’avenir, un prévisionnel permet d’évaluer la rentabilité de votre stratégie de développement, notamment grâce au calcul du seuil de rentabilité. Il vous permet de mieux anticiper votre trésorerie et vos besoins en fonds de roulement. C’est également un argument de poids dans vos recherches de financements. Enfin, grâce aux données qu’il contient et aux indicateurs clés (KPI) qu’il permet de calculer, c’est une aide à la décision précieuse pour adapter et orienter vos stratégies et vos différents budgets."
    },
    {
      title: "Quelles sont les erreurs à éviter lorsqu'on réalise un budget prévisionnel&nbsp;?",
      answer: "Parmi les erreurs les plus communes lors de la réalisation d’un budget prévisionnel l’on retrouve en premier les prévisions irréalistes, avec des chiffres gonflés, pour donner une impression de succès. Cette pratique est tentante, surtout lorsque l’on recherche des financements. Elle est pourtant très risquée car elle expose votre projet à de sérieuses pertes financières. Vient ensuite le fait de négliger l’importance du BFR (besoin en fonds de roulement),\n pourtant primordiale pour faire face aux dépenses imprévues. Ou encore de laisser le prévisionnel avec une trésorerie négative, pensant qu’il pourra être rééquilibré en cours d’année…"
    }
  ]
},
"/conseils-pros/gestion-relation-client": {
  title: "Nos conseils pour la gestion de votre relation client",
  description: "Tout ce qu’il faut savoir sur la relation client : définition, enjeux et moyens d’optimisation et d’analyse de la gestion de la relation client en entreprise",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/gestion-relation-client",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Nos conseils pour la gestion de votre relation client",
      item: "/conseils-pros/gestion-relation-client"
    }
  ],
  faq: [
    {
      title: "En quoi consiste la gestion de la relation client&nbsp;?",
      answer: "La gestion de la relation client GRC (ou customer relationship management CRM) regroupe les stratégies, pratiques et technologies utilisées par les entreprises pour gérer les interactions avec les clients. Elle collecte et utilise des données afin d’analyser leurs besoins, attentes et problématiques, tout au long de leur parcours client."
    },
    {
      title: "À quoi sert la gestion de la relation client en entreprise&nbsp;?",
      answer: "Les objectifs de la gestion de la relation client (GRC) sont multiples et se font autant au bénéfice du client que de l’entreprise. Pour le client, elle permet d’améliorer l’intégralité de son parcours de vie avec la marque (premier contact, service client, achat, fidélisation…). Pour l’entreprise, la relation client permet de consolider sa base client, de se démarquer de la concurrence et booster sa croissance."
    },
    {
      title: "Comment optimiser la gestion de la relation client en entreprise&nbsp;?",
      answer: "Pour optimiser la gestion client en entreprise, plusieurs leviers sont à activer à différents niveaux. Parmi les principales actions à mettre en place, nous pouvons citer : soigner le discours de l’entreprise (afin d’avoir un dialogue unique et cohérent),\n bien connaître sa cible et sa clientèle (la segmentation),\n créer une expérience utilisateur efficace, utiliser plusieurs canaux de communication (e-mails, chatbot, réseaux sociaux),\n analyser la satisfaction client avec des indicateurs clefs ((NPS, CSAT, taux de réachat) et déployer un système CRM efficace pour observer et stocker les données clients."
    }
  ]
},
"/conseils-pros/taux-profitabilite": {
  title: "Qu’est-ce que le taux de profitabilité ? Définition & calcul",
  description: "Comprendre ce qu’est le taux de profitabilité, ce qu’il inclut et sa formule de calcul, ainsi que les autres ratios financiers pour compléter son analyse.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/taux-profitabilite",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Qu’est-ce que le taux de profitabilité ? Définition & calcul",
      item: "/conseils-pros/taux-profitabilite"
    }
  ],
  faq: [
    {
      title: "Quelle est la différence entre le taux de profitabilité et les autres ratios financiers&nbsp;?",
      answer: "Le taux de profitabilité calcule en pourcentage le bénéfice généré sur une période donnée, mais il n’inclut pas les facteurs pouvant influencer son résultat, comme les charges, les dettes, les coûts de production, etc. Afin de compléter son analyse, il faut se tourner vers d’autres ratios financiers comme l’excédent brut d’exploitation (EBE),\n le retour sur investissement (ROI) ou la marge bénéficiaire, qui eux sont des ratios de rentabilité."
    },
    {
      title: "Pourquoi est-il intéressant de calculer le taux de profitabilité d’une entreprise&nbsp;?",
      answer: "Le taux de profitabilité est un indicateur de performance. Les entreprises ont donc tout intérêt à calculer ce ratio afin d’évaluer la gestion de leur entreprise, pour savoir si les choix effectués ont porté leurs fruits. C’est également une donnée permettant de savoir où elles se situent sur le marché, par rapport à leur secteur d’activité, mais aussi la concurrence. Enfin, c’est un atout auprès des banques, des investisseurs ou actionnaires puisqu’un taux de profitabilité élevé sur plusieurs exercices est signe de sécurité financière."
    },
    {
      title: "Qu’est-ce que le taux de profitabilité d’une entreprise&nbsp;?",
      answer: "Le taux de profitabilité permet d’évaluer le niveau de capacité d’une entreprise à gagner de l’argent grâce à son activité, un projet ou un investissement. Il mesure le pourcentage de bénéfices réalisé à partir des ressources financières utilisées. C’est un indicateur de performance qui, lorsqu’il est élevé ou croissant sur le long terme, assure une certaine sécurité financière et reflète l’attractivité d’une entreprise pour des repreneurs potentiels."
    }
  ]
},
"/conseils-pros/cash-flow-definition": {
  title: "Cash-flow: définition, utilisation & méthodes de calcul",
  description: "Tout connaître du cash-flow : sa définition, son intérêt pour votre entreprise, son utilisation, ses méthodes de calcul et comment l’améliorer.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/cash-flow-definition",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Cash-flow: définition, utilisation & méthodes de calcul",
      item: "/conseils-pros/cash-flow-definition"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce que le cash-flow&nbsp;?",
      answer: "Utilisé en finance d’entreprise, le flux de trésorerie – la traduction de cash-flow en français – représente tous les mouvements d’entrée et sortie d’argent connus par une entreprise au cours d’une période donnée. L’on distingue trois types de cash-flow : le cash-flow d’exploitation, le cash-flow d’investissement et le cash-flow de financement."
    },
    {
      title: "Pourquoi calculer le cash-flow d’une entreprise&nbsp;?",
      answer: "Le cash-flow d’une entreprise permet d’évaluer sa capacité à générer des liquidités pour financer son activité en toute autonomie. C’est un indicateur financier crucial dont le calcul donne une vision précise des besoins en trésorerie de l’entreprise. Pour le gestionnaire, le cash-flow est un outil essentiel au pilotage de son entreprise. Enfin, pour les investisseurs et créanciers, c’est un indicateur clé de performance et de stabilité financière."
    },
    {
      title: "Quelles sont les limites du cash-flow&nbsp;?",
      answer: "Le cash-flow est un indicateur de performance qui se base sur une flux annuel. Il peut donc être influencé par des facteurs temporaires comme des ventes et/ou paiements de dettes exceptionnelles. Il est donc préférable d’utiliser le cash-flow pour analyser la performance économique d’une période précise. Ou de compléter son analyse par d’autres ratios financiers pour établir de meilleures conclusions sur la santé financière de l’entreprise."
    }
  ]
},
"/conseils-pros/compte-sequestre": {
  title: "En quoi consiste le compte séquestre ? On vous explique",
  description: "Connaître l'utilité et les principes du compte séquestre, afin de l’utiliser pour sécuriser la transaction d’un fonds de commerce ou d'une entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/compte-sequestre",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "En quoi consiste le compte séquestre ? On vous explique",
      item: "/conseils-pros/compte-sequestre"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce qu’un compte séquestre&nbsp;?",
      answer: "Un compte séquestre est un compte financier ouvert lors d’une transaction immobilière ou d’affaire. Géré par un tiers neutre (avocat, agent immobilier, etc.),\n le compte séquestre bloque et sécurise les fonds ou les actifs versés jusqu’à ce qu’à la clôture de la transaction. Il permet de garantir que les parties impliquées respectent leurs obligations contractuelles (accord de séquestre) avant que ne soient libérés les fonds ou actifs séquestrés."
    },
    {
      title: "Quels sont les avantages du compte séquestre&nbsp;?",
      answer: "Le compte séquestre compte plusieurs avantages, autant pour le déposant (acheteur) que pour le bénéficiaire (vendeur). Il garantit une sécurité accrue, puisqu’il bloque l’acompte jusqu’à ce que toutes les conditions de l’accord soient remplies, réduisant le risque de fraude ou de non-paiement. Comme il est géré par un tiers neutre, il offre transparence et confiance sur les transactions et obligations contractuelles. Enfin, il offre une protection juridique en cas de litige, non-respect des clauses de libération des fonds, hors délai de rétractation, etc."
    },
    {
      title: "Quelles sont les modalités de paiement d’un compte séquestre&nbsp;?",
      answer: "Les modalités de versement des fonds sur un compte séquestre sont directement liées au montant du séquestre lui-même. Pour un montant inférieur à 3 000 €, la méthode la plus courante reste le virement bancaire, suivi du chèque bancaire. Pour les montants supérieurs, le versement doit obligatoirement être réalisé par virement bancaire. Certaines structures autorisent un transfert des fonds en ligne, via des plateformes sécurisées."
    }
  ]
},
"/conseils-pros/coup-accordeon": {
  title: "Coup d’accordéon en entreprise : objectifs & règles",
  description: "Le coup d’accordéon : zoom sur les principes, objectifs et effets d’un mécanisme visant à stabiliser la situation financière d’une entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/coup-accordeon",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Coup d’accordéon en entreprise : objectifs & règles",
      item: "/conseils-pros/coup-accordeon"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce qu’un coup d’accordéon en entreprise&nbsp;?",
      answer: "Le coup d’accordéon est une stratégie financière qui est utilisée par les sociétés afin d’ajuster leur capital social, lorsqu’elles font face à de fortes pertes. Cette opération se passe en deux temps : une réduction du capital pour apurer les pertes, suivie d’une augmentation du capital, par des apports en numéraire ou en nature."
    },
    {
      title: "Quels sont les avantages à réaliser un coup d’accordéon&nbsp;?",
      answer: "L’opération du coup d’accordéon présente plusieurs avantages parmi lesquels on peut citer : l’apurement des dettes, la reconstruction des capitaux propres ainsi que la protection des actionnaires et associés."
    },
    {
      title: "Quelles sont les limites du coup d’accordéon&nbsp;?",
      answer: "Si le coup d’accordéon permet de redresser financièrement une société, ce processus comporte plusieurs risques et limites qui nécessitent un accompagnement. À titre d’exemple, nous pouvons citer la complexité de l’opération qui est cadrée par le Code de Commerce, les statuts de l’entreprise… Mais aussi, les risques juridiques face au droit des actionnaires, la perte de crédibilité envers les partenaires et fournisseurs ou encore le moment où est réalisé le coup d’accordéon."
    }
  ]
},
"/conseils-pros/etude-de-marche": {
  title: "Comment faire une étude de marché : le guide complet",
  description: "Découvrez nos conseils sur comment faire une étude de marché efficace pour connaître votre secteur d’activité et propulser votre projet entrepreneurial.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/etude-de-marche",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment faire une étude de marché : le guide complet",
      item: "/conseils-pros/etude-de-marche"
    }
  ],
  faq: [
    {
      title: "Quelle est la définition d’une étude de marché&nbsp;?",
      answer: "Une étude de marché est un outil stratégique visant à collecter et interpréter des données sur un marché donné. Elle permet de comprendre les besoins des consommateurs, d’évaluer la concurrence, et de déterminer les opportunités et les menaces du marché cible. L'objectif est d'aider les entreprises à confronter leur projet à la réalité du terrain, pour qu’elles puissent prendre les décisions pour optimiser leur stratégie commerciale."
    },
    {
      title: "Quelles sont les étapes clefs pour réaliser une étude de marché&nbsp;?",
      answer: "Pour faire une étude de marché efficace et réaliste, l’entreprise doit respecter une méthodologie à 4 étapes. La 1ère, pour définir le périmètre de l’étude c’est-à-dire identifier le marché dans sa globalité (acteurs, public, territoire, réglementation…). La 2e étape, cible l’étude de la demande : les consommateurs, leurs besoins, leur budget, leurs habitudes… La 3e permet d’analyser l’offre pour connaître ses concurrents et savoir comment se placer face à eux. Enfin, la dernière étape consiste à analyser et interpréter les résultats de l’étude pour dégager des tendances afin d’élaborer des stratégies marketing."
    },
    {
      title: "Quelles sont les erreurs à éviter lors d’une étude de marché&nbsp;?",
      answer: "La réalisation d’une étude de marché demande préparation. Parmi les pièges à éviter, nous pouvons citer l’absence d’objectifs clairs, une mauvaise connaissance du marché ciblé, de son offre et de sa demande, l’utilisation de données obsolètes ou encore une interprétation des résultats qui manque d’objectivité. En somme, une analyse bâclée des 3 piliers de l’étude de marché : environnement, offre et demande."
    }
  ]
},
"/conseils-pros/comment-investir-tresorerie-entreprise": {
  title: "Comment & dans quoi investir votre trésorerie d'entreprise ?",
  description: "Comment investir l’excédent de trésorerie de votre entreprise : tout ce qu’il faut savoir pour la placer judicieusement.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/comment-investir-tresorerie-entreprise",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment & dans quoi investir votre trésorerie d'entreprise ?",
      item: "/conseils-pros/comment-investir-tresorerie-entreprise"
    }
  ],
  faq: [
    {
      title: "Pourquoi investir son excédent de trésorerie d'entreprise&nbsp;?",
      answer: "L’excédent de trésorerie d’une entreprise représente les liquidités disponibles, une fois toutes les obligations financières courantes couvertes (charges, dettes à court terme…). Investir un excédent de trésorerie permet d’optimiser ces liquidités en améliorant leur rentabilité. Cela permet de diversifier les sources de revenus de l’entreprise et de gagner en flexibilité financière pour des projets ou besoins futurs. Enfin, une bonne stratégie de gestion et de placement des ressources est synonyme de compétitivité et de stabilité financière pour l’entreprise."
    },
    {
      title: "Quelles sont les différentes options où investir un excédent de trésorerie d'entreprise&nbsp;?",
      answer: "L’excédent de trésorerie peut être investi dans différentes options, en fonction du niveau de risque auquel peut prétendre l’entreprise et des liquidités disponibles. L’on peut par exemple citer les comptes à termes et plans d’épargne (pour une faible prise de risque),\n les investissements immobiliers ou les obligations (pour un rendement fixe) ou encore les actions et placements en private equity (pour un rendement élevé mais un risque accru)."
    },
    {
      title: "Quels sont les pièges à éviter lorsque l’on souhaite investir un excédent de trésorerie d'entreprise&nbsp;?",
      answer: "Un investissement d’excédent de trésorerie responsable nécessite l’anticipation de certaines problématiques par l’entreprise. Parmi les pièges les plus courants à éviter, nous pouvons par exemple citer le fait de surestimer la liquidité nécessaire, d’investir dans des placements risqués sans analyse approfondie ou encore de négliger la diversification des placements (types d’actifs et composition du portefeuille). Il est également important de considérer la fiscalité et les coûts cachés des placements. Enfin, ne pas se faire accompagner constitue un choix risqué, puisqu’une aide professionnelle vous garantit une expertise qui prend en compte l’intégralité de votre situation, de ces atouts, comme de ses faiblesses."
    }
  ]
},
"/conseils-pros/bail-precaire": {
  title: "Bail précaire : tout ce qu’il faut savoir",
  description: "Bail précaire : les points à savoir sur son fonctionnement, ses caractéristiques et sa mise en place dans le cadre d’une location commerciale temporaire.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/bail-precaire",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Bail précaire : tout ce qu’il faut savoir",
      item: "/conseils-pros/bail-precaire"
    }
  ],
  faq: [
    {
      title: "Qu'est-ce qu'un bail précaire&nbsp;?",
      answer: "Le bail précaire, aussi appelé bail dérogatoire, est un contrat de location commercial, conclu pour une durée maximale de trois ans. Il permet d’échapper au statut classique des baux commerciaux, offrant plus de flexibilité au locataire et au bailleur. Le bail précaire est utilisé pour des situations temporaires, généralement sans engagement sur le long terme. C’est une solution souple, mais instable."
    },
    {
      title: "Quels sont les avantages du bail précaire&nbsp;?",
      answer: "Le bail précaire présente plusieurs avantages pour les parties concernées. Pour le locataire, il permet d’exploiter un local sur une courte période. Cela lui permet de tester une activité ou un emplacement, sans contrainte. Cette flexibilité facilite les projets temporaires ou les essais avant de signer un bail commercial plus long et contraignant. Pour le bailleur, ce type de bail offre une certaine liberté, puisqu’il peut le récupérer rapidement, pendant ou à la fin du bail. Le tout sans aucun dédommagement financier suite à l’éviction ou le non-renouvellement du contrat."
    },
    {
      title: "Quels sont les inconvénients du bail précaire&nbsp;?",
      answer: "Non sans limite, le bail précaire comporte quelques inconvénients pouvant être rédhibitoires. Pour le locataire d’abord, qui ne bénéficie pas des protections découlant du bail commercial classique comme le droit au renouvellement, l’indemnité d'éviction ou le plafonnage du loyer. Cette instabilité peut compromettre le développement d’une activité sur le long terme. Pour le bailleur, la flexibilité du bail précaire peut représenter un risque si le locataire souhaite prolonger sa location. Si la durée du bail est dépassée, celui-ci est automatiquement requalifié en bail commercial classique, bloquant le propriétaire dans ses projets puisqu’il ne peut pas récupérer son bien. Enfin, la succession des locataires (et donc baux de courte durée) peut rendre chronophage la gestion du bien."
    }
  ]
},
"/conseils-pros/indice-ilc": {
  title: "ILC (Indice des Loyers Commerciaux) : définition & calcul",
  description: "Tour d’horizon de l’indice ILC : sa définition, son cadre légal, son rôle central dans les baux commerciaux et sa méthode de calcul.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/indice-ilc",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "ILC (Indice des Loyers Commerciaux) : définition & calcul",
      item: "/conseils-pros/indice-ilc"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce que l’ILC (indice des loyers commerciaux)&nbsp;?",
      answer: "L’Indice des Loyers Commerciaux (ILC) est l’indicateur officiel utilisé pour réviser les loyers des baux commerciaux. Il a été créé pour encadrer les hausses de loyer, selon la périodicité choisie par les parties dans le bail commercial. L’ILC reflète l’évolution des conditions économiques en se basant sur deux sous-indices : l'inflation et les coûts de construction. Il s'adresse aux locataires commerçants et artisans qui exercent une activité commerciale ou artisanale, et qui sont immatriculés au RNE et RCS."
    },
    {
      title: "Comment se calcule l’ILC&nbsp;?",
      answer: "L’ILC est calculé selon deux indicateurs officiels, reflétant des variations économiques spécifiques : l’indice des prix à la consommation (IPC) et l’indice des coûts de la construction (ICC). Depuis 2021, l’ILC est calculé avec les pondérations suivantes : 75 % pour l’IPC et 25 % pour l’ICC. Cela afin de refléter plus justement l’évolution globale des conditions économiques actuelles. Ainsi révisé, l’ILC permet d'ajuster les loyers commerciaux avec plus de justesse, d’équité et de cohérence."
    },
    {
      title: "Pourquoi faut-il calculer l’ILC dans les baux commerciaux&nbsp;?",
      answer: "Il est important de calculer l’ILC lors de la révision des loyers des baux commerciaux, car il permet d’ajuster le prix des loyers en fonction de l'évolution économique actuelle. De par son indexation sur l’ICC et l’IPC, il assure un équilibre entre les charges locatives et les conditions économiques. Ainsi, en calculant l’ILC selon la formule pondérée officielle, les propriétaires se protègent contre l’inflation, tout en assurant aux locataires une hausse raisonnable et prévisible des loyers."
    }
  ]
},
"/conseils-pros/levee-de-fonds": {
  title: "Les bonnes questions à se poser pour votre levée de fonds",
  description: "Le guide complet pour mettre en place et mener à bien la levée de fonds de votre entreprise",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/levee-de-fonds",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Les bonnes questions à se poser pour votre levée de fonds",
      item: "/conseils-pros/levee-de-fonds"
    }
  ],
  faq: [
    {
      title: "Qu’est-ce qu’une levée de fonds&nbsp;?",
      answer: "Une levée de fonds est un processus de recherche de financements externes, auprès d’investisseurs ou institutions susceptibles d'investir au capital d'une entreprise. En échange, ces derniers reçoivent des titres de sociétés dont ils pourront retirer un bénéfice à la fin du contrat. Pour les startups et entreprises innovantes, la levée de fonds est une étape cruciale. En effet, elle permet de financer des projets, renforcer la compétitivité ou accélérer la croissance."
    },
    {
      title: "Quand peut-on mettre en place une levée de fonds&nbsp;?",
      answer: "Une levée de fonds répond à un besoin de lever des fonds rapidement. En ce sens, elle peut être réalisée à différents stades de développement de l’entreprise. En fonction de la somme visée, un stade de développement plus ou moins avancé sera demandé par les investisseurs (garantie de viabilité et rentabilité). Une première levée de fonds peut donc être mise en place au stade précoce de la création, comme à celui de la mise sur le marché d’un nouveau produit, ou encore pour soutenir un projet d’internationalisation."
    },
    {
      title: "Quels sont les avantages à réaliser une levée de fonds pour l’entreprise&nbsp;?",
      answer: "Une levée de fonds présente plusieurs avantages à une entreprise. Elle permet d’accéder à des capitaux sans s’endetter, d’accélérer sa croissance et d’augmenter sa compétitivité. Grâce à cet apport, l’entreprise peut financer le développement de nouveaux produits, renforcer ses équipes ou se déployer sur de nouveaux marchés nationaux ou internationaux... De plus, les investisseurs apportent souvent expertise, réseaux et conseils stratégiques. Pour l’entreprise, cela contribue à sa réussite à long terme de l’entreprise, à sa crédibilité et à sa valorisation."
    }
  ]
},
"/conseils-pros/pacte-dutreil": {
  title: "Pacte Dutreil : comment transmettre l'entreprise familiale ?",
  description: "Comment et pourquoi utiliser le pacte Dutreil lors de la transmission de son patrimoine entrepreneurial familial ?",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/pacte-dutreil",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Pacte Dutreil : comment transmettre l'entreprise familiale ?",
      item: "/conseils-pros/pacte-dutreil"
    }
  ],
  faq: [
    {
      title: "Quelle est la définition du Pacte Dutreil&nbsp;?",
      answer: "Le pacte Dutreil est un dispositif fiscal destiné à faciliter la transmission des entreprises et sociétés, notamment familiales, grâce à une diminution des droits de succession et de donation. Lorsqu'un pacte Dutreil est mis en place, il permet une exonération partielle de 75 % de la valeur des titres de sociétés transmis. Toutefois, les bénéficiaires doivent respecter certains engagements de conservation et de gestion sur le long terme."
    },
    {
      title: "Quels sont les avantages du Pacte Dutreil&nbsp;?",
      answer: "Le Pacte Dutreil comporte de nombreux avantages parmi lesquels on retrouve : l’exonération partielle des droits de mutation (75 % de la valeur de l’entreprise),\n la réduction des droits selon l’âge du donateur, le paiement différé et fractionné des droits de donation ou encore le cumul avec d’autres dispositifs fiscaux. Le but étant de faciliter les transmissions d’entreprises familiales, sans en compromettre la stabilité financière ou l’activité."
    },
    {
      title: "Qui peut bénéficier du Pacte Dutreil&nbsp;?",
      answer: "Du côté des sociétés, depuis 2019, le Pacte Dutreil s’adresse à toute société souhaitant effectuer une transmission ou donation de titres. De manières non-exhaustives, cela concerne les sociétés opérationnelles, les sociétés non-cotées en bourse, les entreprises individuelles, les entreprises familiales, certaines holdings, etc.\\nDu côté des légataires, le Pacte Dutreil est ouvert à toute personne qui hérite ou reçoit des titres de sociétés dans le cadre d’une donation, si les engagements de détention sont respectés. Cela concerne donc les héritiers, donataires et légataires (avec ou sans lien de parenté avec le propriétaire),\n les associés de l’entreprise et les dirigeants."
    }
  ]
},
"/conseils-pros/cession-de-parts-sociales": {
  title: "Comment se déroule une cession de parts sociales ?",
  description: "Cession de parts sociales : découvrez les étapes, formalités et conseils pratiques pour réussir cette opération.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/cession-de-parts-sociales",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment se déroule une cession de parts sociales ?",
      item: "/conseils-pros/cession-de-parts-sociales"
    }
  ],
  faq: [
    {
      title: "En quoi consiste une cession de parts sociales&nbsp;?",
      answer: "Une cession de parts sociales désigne l’opération par laquelle la propriété de parts sociales d’une société est transférée à une autre personne. Ce transfert se fait entre un associé, appelé le cédant, et une autre personne, associée ou non. Par cet acte, le cédant transmet ses droits dans le capital de la société au cessionnaire, après accord des autres associés. Enfin, la cession de parts sociales concerne les sociétés de personnes et les sociétés civiles (SARL, EURL, SNC, SCI…)."
    },
    {
      title: "Comment se passe une cession de parts sociales&nbsp;?",
      answer: "La cession de parts sociales commence par l’évaluation de leur valeur. Si les statuts prévoient une clause d’agrément, l’accord des associés est requis pour procéder à la cession. Par la suite, un acte de cession précisant les modalités est rédigé et signé. Cet acte est soumis aux droits d’enregistrement auprès de l’administration fiscale (SIE). Enfin, les étapes de mise à jour des statuts de la société et d’enregistrement de l’acte de cession formalisent la cession."
    },
    {
      title: "Quelles sont les conséquences d’une cession de parts sociales&nbsp;?",
      answer: "La cession de parts sociales entraîne des conséquences juridiques, fiscales et financières. Juridiquement, elle modifie la répartition du capital social et nécessite l'accord des autres associés en cas de clause d'agrément. Fiscalement, elle génère des droits d'enregistrement dont les parties doivent s’acquitter pour valider la cession. Elle peut également avoir des impacts sur la fiscalité personnelle du cédant en cas de plus-value. Financièrement, elle influence les droits aux dividendes et les pouvoirs décisionnels au sein de la société."
    }
  ]
},
"/conseils-pros/bootstrapping": {
  title: "Se lancer sans investisseurs : le guide du bootstrapping",
  description: "Découvrez comment créer et développer votre entreprise avec un budget limité, grâce à la méthode du bootstrapping.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/bootstrapping",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Se lancer sans investisseurs : le guide du bootstrapping",
      item: "/conseils-pros/bootstrapping"
    }
  ],
  faq: [
    {
      title: "Quelle est la définition du bootstrapping&nbsp;?",
      answer: "Le bootstrapping est une méthode entrepreneuriale, qui consiste à lancer et développer une entreprise en utilisant exclusivement ses propres ressources financières. Sans recours à des financements externes tels que les prêts bancaires ou les investisseurs, cette stratégie d'autofinancement repose sur l’autonomie, l’innovation et l’optimisation des moyens disponibles."
    },
    {
      title: "Quels sont les avantages de la méthode du bootstrap&nbsp;?",
      answer: "Le bootstrapping (ou bootstrap) offre plusieurs avantages dont les principaux sont le contrôle total sur la gestion de l’entreprise, l’absence de dilution du capital et de dettes... Notons que l’autonomie et la flexibilité stratégique qui caractérisent cette méthode favorisent une culture de l’innovation et de la créativité. Enfin, en plaçant la gestion optimisée des ressources eu centre des préoccupations, le bootstrapping redéfinit l’en de création de valeur et la place de la clientèle dans les stratégies de l’entreprise."
    },
    {
      title: "Quels sont les inconvénients du bootstrapping&nbsp;?",
      answer: "Parmi les défis auxquels s’exposent les entrepreneurs choisissant de bootstrapper leur entreprise, l’on retrouve en premier la limitation des ressources financières, qui freine les investissements et ralentissant la croissance. Cette lenteur crée un décalage face à des concurrents mieux financés. De plus, l’absence de financements externes expose davantage l’entreprise aux fluctuations économiques. Enfin, l’entrepreneur subit une pression plus intense, souvent source d’épuisement, avec une exigence constante d’innovation."
    }
  ]
},
"/conseils-pros/bic-ou-bnc": {
  title: "BIC ou BNC : quel régime s'applique à mon entreprise ?",
  description: "BIC ou BNC : découvrez les différences, les régimes fiscaux et activités auxquels ils correspondent et conseils pratiques si vous avez des activités mixtes.\\n",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/bic-ou-bnc",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "BIC ou BNC : quel régime s'applique à mon entreprise ?",
      item: "/conseils-pros/bic-ou-bnc"
    }
  ],
  faq: [
    {
      title: "Quelles sont les activités BNC&nbsp;?",
      answer: "Les activités relevant du régime BNC (bénéfices non commerciaux) regroupent toutes les professions libérales. On dit parfois, de manière informelle, que ce sont les activités intellectuelles, de santé et de conseil. Cela inclut les avocats, les médecins, les architectes, les consultants, les artistes percevant des droits d’auteur ou encore les experts-comptables. Toute prestation de service à caractère non commercial exercée à titre indépendant entre dans cette catégorie. Les BNC ne concernent jamais la vente de marchandise."
    },
    {
      title: "Qui est concerné par les BIC&nbsp;?",
      answer: "Le régime des BIC (bénéfices industriels et commerciaux) concerne les professionnels exerçant une activité commerciale, industrielle ou artisanale. Cela inclut par exemple les commerçants, les artisans, les restaurateurs, les loueurs de meublés, les agents immobiliers et les prestataires de services commerciaux. Toute activité impliquant la vente de marchandises ou de biens, ou la réalisation de services à caractère commercial ou industriel relève des BIC."
    },
    {
      title: "Prestation de service, BIC ou BNC&nbsp;?",
      answer: "Une activité de prestation de service va relever des BIC ou des BNC en fonction de sa nature d’activité : si elle est commerciale (un service artisanal est considéré comme commercial),\n alors elle relève des BIC, sinon, des BNC."
    }
  ]
},
"/conseils-pros/niche-fiscale": {
  title: "Niches fiscales en France : Tout ce qu’il faut savoir",
  description: "Découvrez tout sur les niches fiscales en France : définition, avantages, critères, dispositifs clés et exemples concrets pour optimiser vos avantages fiscaux.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/niche-fiscale",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Niches fiscales en France : Tout ce qu’il faut savoir",
      item: "/conseils-pros/niche-fiscale"
    }
  ],
  faq: [
    {
      title: "Combien de niches fiscales en France&nbsp;?",
      answer: "En France, il existe environ 500 niches fiscales, couvrant divers dispositifs d’allégements fiscaux, crédits d’impôt, et exonérations. Ces niches s’adressent aux particuliers, aux entreprises, et à certains secteurs stratégiques, permettant de réduire l’impôt ou de bénéficier d’avantages fiscaux en contrepartie d’investissements ou d’actions spécifiques."
    },
    {
      title: "Quel est le montant des niches fiscales en France&nbsp;?",
      answer: "Le coût total des niches fiscales en France est estimé à environ 80 à 100 milliards d’euros par an. Ce montant représente le manque à gagner pour l’État, compensé par des objectifs comme le soutien à l’économie, l’innovation, ou des politiques environnementales et sociales."
    },
    {
      title: "Comment profiter des 10.000 € de réductions d'impôt&nbsp;?",
      answer: "Pour profiter du plafond global de 10 000 €, choisissez parmi les dispositifs auxquels vous avez le droit ceux qui sont compatibles entre eux, comme les crédits d’impôt pour travaux énergétiques, le dispositif Pinel ou les dons aux organismes. Planifiez vos investissements en respectant les règles d’éligibilité et en diversifiant les niches pour profiter au maximum de vos avantages fiscaux."
    }
  ]
},
"/conseils-pros/ratios-financiers": {
  title: "Ratios financiers : évaluez la performance de votre entreprise",
  description: "Découvrez les ratios financiers pour évaluer la performance de votre entreprise :  guide pour prendre les bonnes décisions de gestion financière.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/ratios-financiers",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Ratios financiers : évaluez la performance de votre entreprise",
      item: "/conseils-pros/ratios-financiers"
    }
  ],
  faq: [
    {
      title: "Comment calculer le ratio financier&nbsp;?",
      answer: "Le calcul d'un ratio financier s'effectue en établissant un rapport entre deux données issues des documents comptables de l'entreprise. La méthode de calcul varie selon le type de ratio que vous souhaitez obtenir. Par exemple, pour calculer la marge nette, vous devez diviser le résultat net par le chiffre d'affaires. Pour le ratio d'endettement, il faut diviser les dettes financières par les capitaux propres. Chaque ratio possède sa propre formule de calcul."
    },
    {
      title: "Quels sont les 3 ratios d’équilibre&nbsp;?",
      answer: "Les trois ratios d'équilibre fondamentaux sont le fonds de roulement net global (FRNG),\n le besoin en fonds de roulement (BFR) et la trésorerie nette. Le FRNG représente la part des ressources stables finançant l'actif circulant, il s'obtient en soustrayant l'actif immobilisé aux capitaux permanents. Le BFR mesure le besoin de financement généré par l'activité opérationnelle, il correspond à la différence entre les actifs circulants d'exploitation et les dettes d'exploitation. La trésorerie nette, quant à elle, résulte de la différence entre le FRNG et le BFR, elle indique les ressources financières immédiatement disponibles."
    },
    {
      title: "Où trouver les informations pour calculer les ratios financiers&nbsp;?",
      answer: "Les informations nécessaires au calcul des ratios financiers se trouvent principalement dans les documents comptables officiels de l'entreprise. Le bilan fournit une photographie du patrimoine de l'entreprise à un instant donné, avec l'actif d'un côté et le passif de l'autre. Le compte de résultat retrace l'activité de l'entreprise sur une période donnée, présentant les produits et les charges. Pour les sociétés cotées, ces informations sont publiques et accessibles via leurs rapports annuels. Pour les autres entreprises, ces documents peuvent être consultés auprès des greffes des tribunaux de commerce ou sur des plateformes spécialisées."
    }
  ]
},
"/conseils-pros/rediger-annonce-immobiliere": {
  title: "Rédiger une annonce immobilière : comment s’y prendre ?",
  description: "Découvrez les techniques pour rédiger une annonce immobilière commerciale percutante qui attirera les meilleurs repreneurs pour votre entreprise.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/rediger-annonce-immobiliere",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Rédiger une annonce immobilière : comment s’y prendre ?",
      item: "/conseils-pros/rediger-annonce-immobiliere"
    }
  ],
  faq: [
    {
      title: "Comment rédiger une annonce immobilière pour vendre un bien&nbsp;?",
      answer: "La rédaction d'une annonce pour vendre un bien immobilier nécessite une approche méthodique et précise. Commencez par un titre accrocheur qui mentionne le type de bien, sa localisation et une caractéristique distinctive. Dans le corps de l'annonce, décrivez d'abord les informations essentielles comme la surface, le nombre de pièces et le prix. Poursuivez avec une description détaillée qui met en avant les atouts du bien : orientation, luminosité, rénovations récentes, équipements. N'oubliez pas de mentionner l'environnement, notamment la proximité des commodités et des transports. Les photos professionnelles sont indispensables, privilégiez des clichés lumineux qui montrent chaque pièce sous son meilleur jour. Terminez par les informations techniques obligatoires comme le DPE et précisez les modalités de visite."
    },
    {
      title: "Comment rédiger une annonce immobilière de location&nbsp;?",
      answer: "Pour une annonce de location, la priorité est de fournir rapidement les informations pratiques essentielles aux futurs locataires. Indiquez clairement le montant du loyer, des charges et du dépôt de garantie dès le début de l'annonce. Précisez la surface, le type de chauffage et la classe énergétique du bien. Détaillez ensuite l'agencement des pièces et les équipements inclus, notamment pour la cuisine et la salle de bain. Mentionnez les conditions particulières comme l'acceptation ou non des animaux, la présence d'un gardien ou les modalités de stationnement. Il est également crucial d'indiquer les documents nécessaires pour le dossier de location et le délai de disponibilité du bien. Les photos doivent montrer le logement tel qu'il sera loué, avec ses équipements et son état actuel."
    },
    {
      title: "Comment publier l’annonce pour l’achat d’une maison&nbsp;?",
      answer: "Commencez par définir précisément vos critères de recherche : budget maximum, surface souhaitée, nombre de pièces et localisation préférée. Décrivez le type de bien recherché en incluant vos exigences spécifiques comme la présence d'un jardin, d'un garage ou d'une orientation particulière. Mentionnez également vos préférences concernant l'état du bien, si vous êtes ouvert aux travaux ou si vous cherchez un bien clé en main. Il est important d'indiquer votre situation d'acheteur (financement déjà accordé, vente en cours, etc.) pour rassurer les vendeurs potentiels. Précisez vos coordonnées et vos disponibilités pour les visites. La diffusion peut se faire sur les plateformes immobilières spécialisées, les réseaux sociaux et auprès des agences locales."
    }
  ]
},
"/conseils-pros/cycle-economique": {
  title: "Comment les cycles économiques influencent la valeur d'un commerce",
  description: "Découvrez comment les cycles économiques influencent la valeur de  votre commerce et optimisez votre timing de vente grâce à nos conseils en estimation.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/cycle-economique",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Comment les cycles économiques influencent la valeur d'un commerce",
      item: "/conseils-pros/cycle-economique"
    }
  ],
  faq: [
    {
      title: "Quelles sont les 4 phases du cycle économique&nbsp;?",
      answer: "Le cycle économique se compose de quatre phases distinctes et successives.  L'expansion est caractérisée par une croissance de l'activité économique, une  amélioration de l'emploi et une hausse de la consommation. Le sommet représente  l'apogée de cette croissance, marqué par une utilisation maximale des capacités de  production mais aussi l'apparition de tensions inflationnistes. La récession correspond  à une contraction de l'activité avec baisse de la production, augmentation du chômage  et diminution de la confiance des consommateurs. Enfin, le creux constitue le point le  plus bas du cycle avant que l'économie n'entame une nouvelle phase de reprise et  d'expansion."
    },
    {
      title: "Quel est le cycle économique actuel&nbsp;?",
      answer: "En ce début 2025, l'économie mondiale montre des signes de stabilisation après une  période de ralentissement. Nous semblons être dans une phase de transition entre le  creux et le début d'une nouvelle expansion, bien que la situation varie selon les régions du monde et les secteurs. L'inflation s'est modérée dans plusieurs économies avancées,  permettant aux banques centrales d'assouplir progressivement leurs politiques  monétaires. Cependant, cette reprise reste fragile et inégale, certains secteurs et  marchés émergents faisant encore face à des défis importants."
    },
    {
      title: "Quels sont les trois cycles&nbsp;?",
      answer: "L'économie est influencée par trois principaux types de cycles qui se superposent. Les  cycles courts (ou cycles de Kitchin),\n d'une durée de 3 à 5 ans, sont liés aux variations des  stocks des entreprises en réponse aux fluctuations de la demande. Les cycles intermédiaires (ou cycles de Juglar) s'étendent sur 7 à 11 ans et correspondent aux  variations des investissements en capital fixe des entreprises. Les cycles longs (ou  cycles de Kondratieff) durent entre 40 et 60 ans et sont associés aux innovations  technologiques majeures et aux transformations structurelles de l'économie, comme  l'avènement du numérique ou précédemment la révolution industrielle."
    }
  ]
},
"/conseils-pros/capital-humain-commerce": {
  title: "Le capital humain dans l'évaluation : que faut-il analyser ?",
  description: "Découvrez comment le capital humain impacte directement la valeur de votre bien immobilier commercial et comment optimiser cette valorisation.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/capital-humain-commerce",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Le capital humain dans l'évaluation : que faut-il analyser ?",
      item: "/conseils-pros/capital-humain-commerce"
    }
  ],
  faq: [
    {
      title: "Quelle est la différence entre capital humain et ressources humaines&nbsp;?",
      answer: "La différence fondamentale réside dans l'approche conceptuelle : les ressources humaines désignent la fonction et les processus de gestion du personnel (recrutement, formation, administration),\n tandis que le capital humain représente la valeur économique des compétences, expériences et connaissances détenues par vos collaborateurs. Les ressources humaines constituent donc l'ensemble des moyens et outils mis en œuvre pour gérer vos effectifs, alors que le capital humain englobe l'ensemble des aptitudes, talents et savoir-faire qui génèrent directement de la valeur pour votre entreprise."
    },
    {
      title: "Qui est à l’origine du capital humain&nbsp;?",
      answer: "Le concept de capital humain a été principalement développé et formalisé par les économistes Theodore Schultz et Gary Becker dans les années 1960, ce dernier ayantd'ailleurs reçu le prix Nobel d'économie en 1992 pour ses travaux sur le sujet. Leur approche novatrice consistait à considérer l'éducation et la formation non comme de\\nsimples dépenses, mais comme de véritables investissements générant des rendements économiques mesurables pour les individus et les organisations. Cette vision a révolutionné la perception des ressources humaines dans l'entreprise, passant d'un coût nécessaire à un actif stratégique."
    },
    {
      title: "Comment développer le capital humain&nbsp;?",
      answer: "Investissez d'abord dans des programmes de formation continue ciblés, directement alignés sur vos objectifs commerciaux et les besoins spécifiques de votre secteur. Mettez en place un environnement favorisant l'apprentissage continu où les erreurs sont perçues comme des opportunités de progression et où le partage des connaissances est valorisé. Créez des parcours d'évolution personnalisés pour vos collaborateurs en enrichissant progressivement leurs missions et responsabilités. Instaurez une politique de reconnaissance qui valorise tant les performances individuelles que collectives.\\n"
    }
  ]
},
"/conseils-pros/obo": {
  title: "Tout savoir sur l'Owner Buy-Out (OBO)",
  description: "Découvrez notre guide pratique sur l'Owner-Buy-Out (OBO), une option légale pour vendre votre commerce tout en conservant une participation.",
  author: "EstimerMonCommerce.fr",
  follow: "follow",
  robots: "index, follow",
  image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  url: "/conseils-pros/obo",
  breadcrumb: [
    {
      name: "Conseils de pros sur la cession, acquisition et optimisation",
      item: "/conseils-pros"
    },
    {
      name: "Tout savoir sur l'Owner Buy-Out (OBO)",
      item: "/conseils-pros/obo"
    }
  ],
  faq: [
    {
      title: "OBO OU LBO&nbsp;?",
      answer: "L'OBO (Owner Buy-Out) est une variante du LBO (Leveraged Buy-Out) conçue pour les dirigeants-propriétaires. Alors que le LBO désigne toute acquisition d'entreprise avec effet de levier par des investisseurs externes, l'OBO se distingue par le fait que le propriétaire actuel qui vend est aussi l’un des acheteurs (via une holding)."
    },
    {
      title: "POURQUOI FAIRE UN OBO&nbsp;?",
      answer: "Cette opération offre trois avantages majeurs : une diversification patrimoniale immédiate (transformation d'actifs professionnels en patrimoine personnel), l'accès à des financements attractifs pour développer votre activité, et la préparation progressive de la succession du dirigeant. L'OBO représente donc une solution équilibrée entre valorisation immédiate et engagement à moyen terme."
    },
    {
      title: "COMMENT FAIRE UN OBO&nbsp;?",
      answer: "Commencez par une évaluation précise de votre entreprise (DCF, multiples), puis structurez le montage financier (répartition optimale entre capital et dette). Ensuite, sélectionnez vos partenaires financiers en fonction de leur vision stratégique et de leur horizon d'investissement. Procédez à la formalisation juridique et fiscale avec l'aide d'experts (avocat, expert-comptable). Enfin, mettez en place un pilotage adapté post-opération pour garantir le remboursement de la dette tout en préservant le développement de votre entreprise."
    }
  ]
},

  // "/conseils-pros/:article": {
  //   useSpecialValue: true,
  //   title: "",
  //   description: "",
  //   author: "EstimerMonCommerce.fr",
  //   follow: "follow",
  //   robots: "",
  //   image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  //   url: "",
  //   breadcrumb: [{ name: "", item: "" }],
  // },
  "/guides-agents-immos": {
    title: "Nos guides pour agents immos",
    description: "Chaque mois, des méthodes & infos pratiques de terrain",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos",
    breadcrumb: [{ name: "Nos guides pour agents immos", item: "/guides-agents-immos" }],
  },
  "/guides-agents-immos/les-secrets-d-une-visite-d-affaire-bien-structuree-pour-transformer": {
    title: "Visite d'affaire bien structurée pour transformer",
    description: "Les secrets d'une visite d'affaire bien structurée pour transformer",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/les-secrets-d-une-visite-d-affaire-bien-structuree-pour-transformer",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos/" },
      { name: "Visite d'affaire bien structurée pour transformer", item: "/guides-agents-immos/les-secrets-d-une-visite-d-affaire-bien-structuree-pour-transformer" }
    ],
  },
  "/guides-agents-immos/utiliser-le-plan-de-financement-pour-valider-le-prix-d-une-affaire": {
    title: "Utiliser le plan de financement pour valider le prix d'une affaire",
    description: "Plan de financement pour valider le prix d'une affaire",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/utiliser-le-plan-de-financement-pour-valider-le-prix-d-une-affaire",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "Utiliser le plan de financement pour valider le prix d'une affaire", item: "/guides-agents-immos/utiliser-le-plan-de-financement-pour-valider-le-prix-d-une-affaire" }
    ],
  },
  "/guides-agents-immos/les-secrets-d-une-prospection-reussie": {
    title: "Les secrets d'une prospection réussie",
    description: "Réussir sa prospection terrain pour constituer un portefeuille de mandats de commerces",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/les-secrets-d-une-prospection-reussie",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "Les secrets d'une prospection réussie", item: "/guides-agents-immos/les-secrets-d-une-prospection-reussie" }
    ],
  },
  "/guides-agents-immos/comment-faire-une-bonne-decouverte-d-un-commerce-ou-d-une-entreprise-a-vendre": {
    title: "Bonne découverte d'un commerce / d'une entreprise à vendre ?",
    description: "Comment faire une bonne découverte d'un commerce ou d'une entreprise à vendre ?",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/comment-faire-une-bonne-decouverte-d-un-commerce-ou-d-une-entreprise-a-vendre",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "Bonne découverte d'un commerce / d'une entreprise à vendre ?", item: "/guides-agents-immos/comment-faire-une-bonne-decouverte-d-un-commerce-ou-d-une-entreprise-a-vendre" }
    ],
  },
  "/guides-agents-immos/les-cles-pour-bien-cerner-l-acquereur-d-un-commerce": {
    title: "Les clés pour cerner l'acquéreur d'un commerce",
    description: "Les clés pour bien cerner l'acquéreur d'un commerce",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/les-cles-pour-bien-cerner-l-acquereur-d-un-commerce",
    breadcrumb: [
      { name: "Les clés pour cerner l'acquéreur d'un commerce", item: "/guides-agents-immos" },
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos/les-cles-pour-bien-cerner-l-acquereur-d-un-commerce" }
    ],
  },
  "/guides-agents-immos/comment-rediger-une-bonne-annonce-de-vente-de-fonds-de-commerce": {
    title: "Rédiger une annonce de vente de fonds de commerce ?",
    description: "Comment rédiger une bonne annonce de vente de fonds de commerce ?",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/comment-rediger-une-bonne-annonce-de-vente-de-fonds-de-commerce",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "Rédiger une annonce de vente de fonds de commerce ?", item: "/guides-agents-immos/comment-rediger-une-bonne-annonce-de-vente-de-fonds-de-commerce" }
    ],
  },
  "/guides-agents-immo/les-secrets-du-compromis-de-vente": {
    title: "Secrets du compromis de vente",
    description: "Les secrets du compromis de vente",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/les-secrets-du-compromis-de-vente",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "Secrets du compromis de vente", item: "/guides-agents-immos/les-secrets-du-compromis-de-vente" }
    ],
  },
  "/guides-agents-immos/comprendre-la-taxe-sur-la-plus-value-d-un-fonds-de-commerce": {
    title: "La taxe sur la plus-value d'un fonds de commerce",
    description: "Comprendre la taxe sur la plus-value d'un fonds de commerce",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/comprendre-la-taxe-sur-la-plus-value-d-un-fonds-de-commerce",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "La taxe sur la plus-value d'un fonds de commerce", item: "/guides-agents-immos/comprendre-la-taxe-sur-la-plus-value-d-un-fonds-de-commerce" }
    ],
  },
  "/guides-agents-immos/comment-monter-un-dossier-de-vente-d-affaire-pro-et-convaincant": {
    title: "Monter un dossier de vente d'affaire pro convaincant ?",
    description: "Comment monter un dossier de vente d'affaire pro et convaincant ?",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/comment-monter-un-dossier-de-vente-d-affaire-pro-et-convaincant",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "Monter un dossier de vente d'affaire pro convaincant ?", item: "/guides-agents-immos/comment-monter-un-dossier-de-vente-d-affaire-pro-et-convaincant" }
    ],
  },
  "/guides-agents-immos/comment-reduire-temps-entre-offre-et-compromis-vente-fonds-commerce": {
    title: "Réduire le temps entre l'offre et le compromis d'une vente de fonds de commerce",
    description: "Comment réduire le temps entre l'offre d'achat et le compromis dans une vente de fonds de commerce ?",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/comment-reduire-temps-entre-offre-et-compromis-vente-fonds-commerce",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "Réduire le temps entre l'offre et le compromis d'une vente de fonds de commerce", item: "/guides-agents-immos/comment-reduire-temps-entre-offre-et-compromis-vente-fonds-commerce" }
    ],
  },
  "/guides-agents-immos/comment-maximiser-chances-acquereur-obtenir-accord-pret-professionnel": {
    title: "Découvre comment aider ton acquéreur à obtenir son prêt professionnel",
    description: "Comment aider ton acquéreur à obtenir son prêt professionnel ?",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/comment-maximiser-chances-acquereur-obtenir-accord-pret-professionnel",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "Découvre comment aider ton acquéreur à obtenir son prêt professionnel", item: "/guides-agents-immos/comment-maximiser-chances-acquereur-obtenir-accord-pret-professionnel" }
    ],
  },
  "/guides-agents-immos/prospection-commerces-vente-quelles-affaires-cibler-ou-eviter": {
    title: "Prospection de commerces à vendre : quelles affaires cibler (ou éviter) ?",
    description: "Prospection de commerces à vendre : quelles affaires cibler (ou éviter) ?",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/guides-agents-immos/prospection-commerces-vente-quelles-affaires-cibler-ou-eviter",
    breadcrumb: [
      { name: "Nos guides pour agents immos", item: "/guides-agents-immos" },
      { name: "Prospection de commerces à vendre : quelles affaires cibler (ou éviter) ?", item: "/guides-agents-immos/prospection-commerces-vente-quelles-affaires-cibler-ou-eviter" }
    ],
  },
  // "/guides-agents-immos/:article": {
  //   useSpecialValue: true,
  //   title: "Nos guides pour agents immos",
  //   description: "Chaque mois, des méthodes & infos pratiques de terrain",
  //   author: "EstimerMonCommerce.fr",
  //   follow: "follow",
  //   robots: "index, follow",
  //   image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
  //   url: "/guides-agents-immos",
  //   breadcrumb: [{ name: "Nos guides pour agents immos", item: "/guides-agents-immos" }],
  // },
  // Legal
  "/cgv": {
    title: "Conditions générales de ventes",
    description:
      "Découvrez les conditions générales de ventes d'EstimerMonCommerce.fr avant d'utiliser notre parcours d'estimation",
    author: "EstimerMonCommerce.fr",
    follow: "nofollow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/cgv",
    breadcrumb: [{ name: "Conditions générales de ventes", item: "/cgv" }],
  },
  "/cgu": {
    title: "Conditions générales d'utilisation",
    description: "Découvrez les conditions générales d'utilisation d'EstimerMonCommerce.fr",
    author: "EstimerMonCommerce.fr",
    follow: "nofollow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/cgu",
    breadcrumb: [{ name: "Conditions générales d'utilisation", item: "/cgu" }],
  },
  "/parametrage-cookies": {
    title: "Nos cookies pour une utilisation optimale",
    description:
      "Ce site utilise des cookies pour vous offrir une navigation de qualité et améliorer votre expérience de navigation sur le site",
    author: "EstimerMonCommerce.fr",
    follow: "nofollow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/parametrage-cookies",
    breadcrumb: [{ name: "Nos cookies pour une utilisation optimale", item: "/parametrage-cookies" }],
  },
  "/mentions-legales": {
    title: "Mentions légales applicables au 15 octobre 2021",
    description:
      "Découvrez les mentions legales d'EstimerMonCommerce.fr pour découvrir l'éditeur, le concepteur et l'hébergeur du site",
    author: "EstimerMonCommerce.fr",
    follow: "nofollow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/mentions-legales",
    breadcrumb: [{ name: "Mentions légales applicables au 15 octobre 2021", item: "/mentions-legales" }],
  },
  "/politique-confidentialite": {
    title: "Politique de confidentialité de vos données",
    description:
      "Découvrez la politique de confidentialité d'EstimerMonCommerce.fr pour en savoir plus sur l'utilisation du site",
    author: "EstimerMonCommerce.fr",
    follow: "nofollow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/politique-confidentialite",
    breadcrumb: [{ name: "Politique de confidentialité de vos données", item: "/politique-confidentialite" }],
  },
  // Parcours
  "/debut-parcours": {
    title: "Commencer mon parcours d'estimation en ligne",
    description:
      "Fonds de commerce, titres de société, murs commerciaux. Estimez votre affaire 100% en ligne, avec EstimerMonCommerce.fr",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "index, follow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/debut-parcours",
    breadcrumb: [{ name: "Commencer mon parcours d'estimation en ligne", item: "/debut-parcours" }],
  },
  "/detail-parcours/murs-commerciaux": {
    title: "Parcours d'estimation en ligne, murs commerciaux",
    description: "Réalisez votre parcours d'estimation en ligne de vos murs commerciaux afin d'estimer leur valeur",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/detail-parcours/murs-commerciaux",
    breadcrumb: [{ name: "", item: "/detail-parcours/murs-commerciaux" }],
  },
  "/detail-parcours/titres-de-societe": {
    title: "Parcours d'estimation en ligne",
    description:
      "Réalisez votre parcours d'estimation en ligne de fonds de commerce et de titres de société afin d'estimer la valeur de votre affaire",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/detail-parcours/titres-de-societe",
    breadcrumb: [{ name: "Parcours d'estimation en ligne", item: "/detail-parcours/titres-de-societe" }],
  },
  "/detail-parcours/fonds-de-commerce": {
    title: "Parcours d'estimation en ligne",
    description:
      "Réalisez votre parcours d'estimation en ligne de fonds de commerce et de titres de société afin d'estimer la valeur de votre affaire",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/detail-parcours/fonds-de-commerce",
    breadcrumb: [{ name: "", item: "/detail-parcours/fonds-de-commerce" }],
  },
  "/synthese": {
    title: "Rapport synthétique de l'estimation de votre affaire",
    description:
      "Découvrez une première estimation de la valeur de votre affaire. Prévisualisez l'état général de celle-ci avant d'obtenir votre rapport complet",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/synthese",
    breadcrumb: [{ name: "Rapport synthétique de l'estimation de votre affaire", item: "/synthese" }],
  },
  // Compte
  "/mon-compte": {
    title: "Mon tableau de bord",
    description:
      "Accédez à vos rapports d’estimation, téléchargez vos factures, actualisez vos informations personnelles et suivez l’offre à laquelle vous avez souscrite",
    author: "EstimerMonCommerce.fr",
    follow: "follow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/mon-compte",
    breadcrumb: [{ name: "Mon tableau de bord", item: "/mon-compte" }],
  },
  "/connexion": {
    title: "Connexion à votre compte personnel",
    description:
      "Bienvenue sur EstimerMonCommerce.fr, connectez-vous à votre compte depuis cette page afin d'estimer en ligne la valeur de votre affaire",
    author: "EstimerMonCommerce.fr",
    follow: "nofollow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/connexion",
    breadcrumb: [{ name: "Connexion à votre compte personnel", item: "/connexion" }],
  },
  "/inscription": {
    title: "Inscrivez-vous pour profiter de toutes nos offres",
    description:
      "Inscrivez-vous depuis cette page pour profiter de tous nos conseils et outils, de nos rapports complets et bien plus encore",
    author: "EstimerMonCommerce.fr",
    follow: "nofollow",
    robots: "noindex, nofollow",
    image: "https://images.pickapic.live/get/7fe873b7-3377-42ae-b76a-4b40d123950e-1638786656.jpeg",
    url: "/inscription",
    breadcrumb: [{ name: "Inscrivez-vous pour profiter de toutes nos offres", item: "/inscription" }],
  },
};

export const headerSEOExceptions = ["/301", "/302", "/401", "/402", "/403", "/404", "/500", "/502", "/503", "/admin"];
